// Auto-generated from nl.json - DO NOT EDIT DIRECTLY
// Edit src/assets/i18n/nl.json instead, then run: npm run i18n:sync
// Or let the build watch mode auto-sync on changes.

import type { Translation } from '../i18n-types';

const nl = {
	meals: {
		breakfast: 'Ontbijt',
		lunch: 'Lunch',
		dinner: 'Diner',
		supper: 'Avondmaal',
		snack: 'Snack',
		snackNumbered: 'Snack {number}',
	},
	editWeighIn: {
		title: 'Gewicht loggen',
		skinfolds: {
			suprailiac: 'Suprailiacaal',
			umbilical: 'Umbilicaal',
			thigh: 'Dij',
			chest: 'Borst',
			tricep: 'Triceps',
		},
		validation: {
			weight: 'Geef je huidige gewicht op.',
			skinfolds: 'Meet je huidplooien 3-5x op elke plek, dan berekenen wij het gemiddelde.',
		},
		labels: {
			bodyWeight: 'Lichaamsgewicht',
			bodyFat: 'Lichaamsvet',
			skinfolds: 'Huidplooien',
			waist: 'Taille',
		},
		notes: {
			bodyFatTracking: 'Schakel de methode(n) in die je wilt gebruiken om lichaamsvet bij te houden.',
			logWeightInstructions: 'Log elke ochtend je gewicht voor het ontbijt en nadat je naar het toilet bent geweest.',
			measureSkinfolds: 'Meet je huidplooien 3–5 keer op elke plek, dan berekenen wij je gemiddelde.',
			measureWaist: 'Meet je taille voor het ontbijt en nadat je naar het toilet bent geweest. Adem volledig uit, span je buikspieren aan en leg het meetlint plat rond je navel met een gelijkmatige spanning. Gebruik voor het beste resultaat een zelfspannend meetlint zoals de AccuFitness MyoTape.',
		},
		buttons: {
			save: 'Opslaan',
		},
		warnings: {
			weightNotMeasured: 'Het is {days} dagen geleden sinds je laatste weging. Probeer er een gewoonte van te maken om jezelf dagelijks te wegen om je consistentie en tracking te verbeteren.',
			weightNotMeasuredWeeks: 'Het is {weeks} weken geleden sinds je laatste weging. Probeer er een gewoonte van te maken om jezelf dagelijks te wegen om je consistentie en tracking te verbeteren.',
			weightNotMeasuredLongTime: 'Probeer er een gewoonte van te maken om jezelf dagelijks te wegen om je consistentie en tracking te verbeteren.',
			bodyFatNotMeasured: 'Het is {days} dagen geleden sinds je je huidplooien of taille hebt gemeten. Meet ze voor het beste resultaat elke {frequency} dagen.',
			bodyFatNotMeasuredWeeks: 'Het is {weeks} weken geleden sinds je je huidplooien of taille hebt gemeten. Meet ze voor het beste resultaat elke {frequency} dagen.',
			bodyFatNotMeasuredLongTime: 'Het is een tijdje geleden sinds je je huidplooien of taille hebt gemeten. Meet ze voor het beste resultaat elke {frequency} dagen.',
		},
		info: {
			futureWeighIn: 'Je kunt geen gewichten invoeren voor datums in de toekomst.',
			neverMeasuredBodyFat: 'Je zou je lichaamsvetsamenstelling elke {frequency} dagen moeten meten. Kies welke methoden je wilt gebruiken. Huidplooitangen zijn nauwkeuriger, maar meetlinten zijn makkelijker.',
			bodyFatNeededForProgressCheck: 'Je voortgangscontrole heeft nog een paar huidplooi- of taillemetingen nodig om je trend te beoordelen. Vandaag meten helpt.',
			bodyFatCooldownTomorrow: 'Je kunt je huidplooi- of taillemeting morgen opnieuw uitvoeren.',
			bodyFatCooldownDays: 'Je kunt je huidplooi- of taillemeting over {days} dagen opnieuw uitvoeren op {date}.',
		},
		links: {
			howToMeasureSkinfolds: 'Hoe meet je huidplooien?',
		},
	},
	weeklyCheckup: {
		dailyAvgWithDelta: '{avg} kcal ({sign}{diff})',
		loading: {
			processingData: 'Gegevens verwerken. Even geduld...',
			finishingCheckup: 'Wekelijkse check-up afronden, even geduld...',
		},
		errors: {
			couldNotProcess: 'We konden je schema nu niet bijwerken. Probeer het opnieuw of neem contact op met support als het blijft gebeuren.',
			progressCheckFailed: 'We konden nu niet bepalen hoe je voortgang verloopt, dus we kunnen je check-up niet uitvoeren. Probeer het later opnieuw of neem contact op met support als het blijft gebeuren.',
		},
		bodyfatEstimation: {
			timeForEstimate: 'Het is een tijdje geleden sinds we je lichaamsvetpercentage voor het laatst hebben geschat, dus laten we dat nu doen.',
			bestEstimate: 'Wat is de beste schatting van je lichaamsvetpercentage die je kunt krijgen (je hebt er maar één nodig)?',
			skipOk: 'Je mag dit gerust overslaan: we blijven dan de laatste schatting gebruiken.',
		},
		nutritionLogging: {
			nextSection: 'Vervolgens bekijken we je calorie-inname van de afgelopen week om je programma voor de komende week bij te werken.',
			deselectIncomplete: 'Deselecteer de dagen die onvolledig of gedeeltelijk gelogd lijken, dan sluiten we ze uit van onze berekeningen.',
		},
		calorieBaseline: {
			beforeAdjust: 'Voordat we je calorie-inname voor de volgende week aanpassen, moeten we een nauwkeurig beeld krijgen van je huidige energie-inname.',
			whichOption: 'Welke van deze opties weerspiegelt het best je gemiddelde calorie-inname van de afgelopen week?',
			logged: 'Gelogd',
			loggedNote: 'Dit is het gemiddelde aantal gelogde calorieën per dag over de afgelopen week, exclusief de dagen die je als onvolledig hebt gemarkeerd.',
			target: 'Doel',
			targetNote: 'Dit is je gemiddelde aanbevolen doelcalorie-inname per dag in de afgelopen week.',
			custom: 'Aangepast',
			customNote: 'Als je een ander aantal calorieën hebt gegeten dan de bovenstaande opties, voer het hier dan in.',
		},
		programUpdate: {
			basedOnProgress: 'Op basis van je voortgangsgegevens raden we de volgende aanpassingen aan je programma aan:',
			progressOnTrack: 'Je voortgang ligt op schema! Er zijn op dit moment geen aanpassingen nodig.',
			notEnoughData: 'Er zijn nog niet genoeg voortgangsgegevens beschikbaar. Er worden op dit moment geen wijzigingen aanbevolen. Blijf je wegingen en lichaamsmetingen loggen, zodat we je voortgang kunnen volgen.',
			notEnoughDataCompleted: 'Er waren tijdens deze check-up niet genoeg voortgangsgegevens beschikbaar. Er werden geen wijzigingen aanbevolen.',
			undeterminedMeasureMoreOften: 'We hebben meer metingen nodig om je voortgang te beoordelen, dus deze week worden geen wijzigingen aanbevolen. Blijf je gewicht elke dag loggen en voeg huidplooi- of taillemetingen toe wanneer het wegingsscherm erom vraagt.',
			undeterminedBodyFatTrendUnclear: 'Je lichaamsvettrend is nog niet duidelijk, dus deze week worden geen wijzigingen aanbevolen. Voeg de komende dagen nog een paar huidplooi- of taillemetingen toe. Het wegingsscherm vraagt erom.',
			undeterminedDataErratic: 'Je metingen schommelen sterk, dus er is geen duidelijke trend te vinden en deze week worden geen wijzigingen aanbevolen. Probeer elke keer onder dezelfde omstandigheden te meten.',
			undeterminedWeightTooFlat: 'Je laatste gewichtsmetingen waren precies hetzelfde, dus deze week worden geen wijzigingen aanbevolen. Controleer of je weegschaal goed werkt.',
			atMinimum: 'Je voortgang wijst erop dat je iets minder zou moeten eten, maar je dagelijkse caloriedoel staat al op het laagste niveau dat de app instelt voor jouw lichaamsgewicht. Lager kan niet, dus er wordt niets aangepast.',
			atMinimumCompleted: 'Je voortgang wees erop dat je minder zou moeten eten, maar je dagelijkse caloriedoel stond al op het laagste niveau dat de app instelt voor jouw lichaamsgewicht, dus er is niets aangepast.',
			lowestTarget: 'Dit is het laagste dagelijkse caloriedoel dat de app instelt voor jouw lichaamsgewicht.',
			changeTooSmall: 'Op basis van je voortgangsgegevens zou je dagelijkse caloriedoel nauwelijks veranderen. Het verschil is te klein om iets uit te maken, dus er wordt niets aangepast.',
			changeTooSmallCompleted: 'De aanbevolen verandering van je calorieën was te klein om iets uit te maken, dus er is niets aangepast.',
		},
		bfMethods: {
			calipers: 'Huidplooitang',
			tape: 'Meetlint',
			visual: 'Visueel',
			unknown: 'Onbekende methode',
		},
		headers: {
			bodyfatEstimation: 'Lichaamsvetschatting',
			programUpdate: 'Programma-update',
			checkupStatus: 'Check-upstatus',
		},
		descriptions: {
			intro: 'Om je programma optimaal en up-to-date te houden, bekijken we nu je voortgang van de afgelopen week en voeren we indien nodig aanpassingen door.',
			futureCheckup: 'Deze wekelijkse check-up is gepland voor een datum in de toekomst. Wacht tot de geplande datum om de check-up te starten.',
			outdatedCheckup: 'Deze check-up is verouderd en kan niet meer worden voltooid. Voltooi in plaats daarvan de check-up van deze week.',
			weightTrendingWell: 'Je gewicht en lichaamsmaten ontwikkelen zich in de goede richting, en dat in een goed tempo. Ga zo door, goed werk!',
			weightNotEnoughData: 'We hebben niet genoeg gegevens om te bepalen of je gewicht en lichaamsmaten in de goede richting bewegen. Registreer meer wegingen en lichaamsmaten.',
			noWorkoutsLoggedLastWeek: 'In de afgelopen week heb je geen trainingen geregistreerd.',
			workoutProgressionSummary: 'In de afgelopen week ben je {progressions} {{keer|keer}} vooruitgegaan bij oefeningen en {regressions} {{keer|keer}} achteruitgegaan.',
		},
		charts: {
			weightTrend: 'Gewichtstrend',
			skinfoldTrend: 'Huidplooitrend',
			waistTrend: 'Tailletrend',
			exerciseProgressions: 'Oefeningsvoortgang',
		},
		tooltips: {
			weightTrend: 'Dagelijkse gewichtsmetingen met hun geschatte trendlijn over de afgelopen 7 dagen.',
			skinfoldTrend: 'Dagelijkse huidplooimetingen met hun geschatte trendlijn over de afgelopen 7 dagen.',
			waistTrend: 'Dagelijkse taillemetingen met hun geschatte trendlijn over de afgelopen 7 dagen.',
			exerciseProgressions: 'Aantal oefeningen dat per training vooruitging over de afgelopen 7 dagen.',
		},
		labels: {
			estimationMethod: 'Schattingsmethode:',
			estimatedBodyfat: 'Geschat lichaamsvet:',
			completionStatus: 'Voltooiingsstatus:',
		},
		buttons: {
			start: 'Starten',
			decline: 'Afwijzen',
			accept: 'Accepteren',
		},
		ownTarget: {
			nothingToChange: 'Dat is het doel dat de app aanbeveelt, dus er valt niets te wijzigen.',
			completedOwn: 'Je hebt je eigen doel ingesteld. De app raadde {kcal} kcal aan.',
			completedCoach: 'Je coach heeft dit doel ingesteld. De app raadde {kcal} kcal aan.',
		},
		step: 'Stap {current} van {total}',
		steps: {
			intro: 'Wekelijkse check-up',
			progressReview: 'Voortgangsoverzicht',
			bodyfatEstimation: 'Lichaamsvetschatting',
			nutritionLogging: 'Voeding loggen',
			calorieBaseline: 'Caloriebaseline',
			programUpdate: 'Programma-update',
		},
		completionActions: {
			accepted: 'Aanpassingen geaccepteerd',
			declined: 'Aanpassingen afgewezen',
			finished: 'Voltooid',
		},
		validation: {
			selectOption: 'Kies een van de opties.',
			customCalorieIntake: 'Vul een eigen waarde voor calorie-inname in.',
			unknownField: 'Onbekend veld',
		},
		finalChoice: {
			acceptApp: 'Nieuw doel accepteren',
			acceptAppHelp: 'De aanbeveling van de app, berekend uit je voortgang.',
			keepAppTarget: 'Doel van de app houden',
			keepAppTargetHelp: 'Je ligt op koers, dus je doel blijft zoals het is.',
			setOwn: 'Eigen doel instellen',
			setOwnHelp: 'Kies zelf een getal, in kcal of als verandering in procent.',
			keepCurrent: 'Huidig doel houden',
			keepCurrentHelp: 'Er verandert deze week niets aan je plan.',
		},
	},
	nutrientList: {
		logged: 'Gelogd',
		targets: 'Doelen',
		nutrients: 'Voedingsstoffen',
		food: 'Item',
		meal: 'Maaltijd',
		day: 'Dag',
		total: 'Totaal',
		left: 'Over',
		protein: 'Eiwit',
		carbs: 'Koolhydraten',
		fat: 'Vet',
		fiber: 'Vezels',
		cholesterol: 'Cholesterol',
		short: {
			protein: 'Eiw',
			carbs: 'Koh',
			fat: 'Vet',
			fiber: 'Vez',
		},
		oneLetter: {
			protein: 'E',
			carbs: 'K',
			fat: 'V',
			fiber: 'Vez',
		},
	},
	common: {
		reconnecting: 'Opnieuw verbinden...',
		offlineBadge: 'Offline',
		options: {
			yes: 'Ja',
			no: 'Nee',
		},
		ui: {
			recommended: 'Aanbevolen',
			default: 'Standaard',
		},
		states: {
			skipped: 'Overgeslagen',
		},
		messages: {
			backOnline: 'Je bent weer online.',
			imageQueuedOffline: 'Foto opgeslagen op dit apparaat. De foto wordt automatisch geüpload zodra je weer online bent.',
			scanAppCapacityReached: 'De app heeft de scanlimiet voor vandaag bereikt. Probeer het morgen opnieuw.',
		},
		toast: {
			dontShowAgain: 'Nooit tonen',
		},
		words: {
			or: 'of',
			and: 'en',
		},
		measureNames: {
			portion: 'portie',
			piece: 'stuk',
			slice: 'plak',
			whole: 'geheel',
			prepared: 'portie',
			large: 'groot',
			medium: 'middelgroot',
			small: 'klein',
			can: 'blik',
			bottle: 'fles',
			quart: 'quart',
			pint: 'pint',
			cup: 'cup',
			tbsp: 'el',
			tablespoon: 'eetlepel',
			tsp: 'tl',
			teaspoon: 'theelepel',
		},
		measureUnits: {
			descriptions: {
				none: 'geen',
				genericNumber: 'Algemeen getal',
				repetitions: 'Herhalingen',
				sets: 'Sets',
				pairs: 'Paren',
				plates: 'Schijven',
				percent: 'Procent',
				millimeters: 'millimeter',
				centimeters: 'centimeter',
				feetAndInches: 'voet en inch',
				inches: 'inch',
				kilograms: 'kilogram',
				pounds: 'pond',
				micrograms: 'microgram',
				milligrams: 'milligram',
				grams: 'gram',
				ounces: 'ounce',
				stonesAndPounds: 'stone en pond',
				kilocalories: 'kilocalorie',
				kilojoules: 'kilojoule',
				internationalUnits: 'internationale eenheden',
				milliliters: 'milliliter',
				fluidOunces: 'vloeibare ounce',
				quarts: 'quart',
				pints: 'pint',
				cups: 'cup',
				tablespoons: 'eetlepel',
				teaspoons: 'theelepel',
			},
		},
		pickerTitles: {
			servingSize: 'Portiegrootte',
			selectUnit: 'Eenheid selecteren',
			timeFormat: 'Tijdnotatie',
		},
		scanModels: {
			allModels: 'Alle modellen',
			costEstimate: '{displayName} (~${cost}/1k)',
		},
		errors: {
			unknownField: 'Onbekend veld',
			generic: 'Er is iets misgegaan. Probeer het opnieuw.',
			tooManyAttempts: 'Te veel pogingen. Wacht even en probeer het opnieuw.',
		},
		offTrack: {
			tooMuchWeightLoss: {
				cutting: {
					summary: 'Je gewicht daalt sneller dan verwacht.',
					action: 'We moeten je voedingsschema aanpassen om spiermassa te behouden terwijl je vet verliest.',
				},
				bulking: {
					summary: 'Je verliest gewicht terwijl je zou moeten aankomen.',
					action: 'We moeten je voedingsschema aanpassen om spiergroei te ondersteunen.',
				},
			},
			tooMuchFatGain: {
				cutting: {
					summary: 'Je komt aan in lichaamsvet terwijl je het zou moeten verliezen.',
					action: 'We moeten je voedingsschema aanpassen om je vetverlies weer op schema te krijgen.',
				},
				bulking: {
					summary: 'Je lichaamsvetmetingen stijgen sneller dan verwacht.',
					action: 'We moeten je voedingsschema aanpassen om overmatige vettoename te voorkomen.',
				},
			},
			notEnoughFatLoss: {
				cutting: {
					summary: 'Je lichaamsvetmetingen dalen niet zoals verwacht.',
					action: 'We moeten je voedingsschema aanpassen om je te helpen vet te verliezen.',
				},
			},
			notEnoughWeightGain: {
				bulking: {
					summary: 'Je gewicht neemt niet toe zoals verwacht.',
					action: 'We moeten je voedingsschema aanpassen om je te helpen vetvrije massa op te bouwen.',
				},
			},
			generic: {
				summary: 'Je hebt een paar trainingen of volumedoelen gemist. Blijf consistent om vooruitgang te blijven boeken.',
			},
		},
		buttons: {
			save: 'Opslaan',
			select: 'Selecteren',
			cancel: 'Annuleren',
			delete: 'Verwijderen',
			ok: 'OK',
			today: 'Vandaag',
			yes: 'Ja',
			accept: 'Accepteren',
			no: 'Nee',
			back: 'Terug',
			next: 'Volgende',
			edit: 'Bewerken',
			remove: 'Verwijderen',
			report: 'Rapporteren',
			dismiss: 'Sluiten',
			ignore: 'Negeren',
			learnMore: 'Meer info',
			discard: 'Weggooien',
			optimize: 'Optimaliseren',
			saveAsNew: 'Opslaan als nieuw',
			split: 'Splitsen',
			addPlates: 'Schijven toevoegen',
			cleanUp: 'Opschonen',
			finish: 'Voltooien',
			skip: 'Overslaan',
			restoreTask: 'Taak herstellen',
			autoTune: 'Auto-afstemmen',
			uncacheFoods: 'Voedingsmiddelen uit cache halen',
			testSurvey: 'Enquête testen',
			apply: 'Toepassen',
			log: 'Loggen',
			undo: 'Ongedaan maken',
			keep: 'Behouden',
			saving: 'Opslaan...',
			tryAgain: 'Opnieuw proberen',
			continue: 'Doorgaan',
			confirm: 'Bevestigen',
		},
		weekdays: {
			monday: 'Maandag',
			tuesday: 'Dinsdag',
			wednesday: 'Woensdag',
			thursday: 'Donderdag',
			friday: 'Vrijdag',
			saturday: 'Zaterdag',
			sunday: 'Zondag',
		},
		weekdayInitials: {
			monday: 'M',
			tuesday: 'D',
			wednesday: 'W',
			thursday: 'D',
			friday: 'V',
			saturday: 'Z',
			sunday: 'Z',
		},
		placeholders: {
			enterFoodName: 'Voer de naam van het voedingsmiddel in',
			selectMeasure: 'Selecteer maat...',
			day: 'DD',
			month: 'MM',
			year: 'JJJJ',
			reps: 'Herhalingen',
			enterText: 'Voer tekst in',
			select: 'Selecteren...',
			selectAnOption: 'Selecteer een optie',
		},
		measurements: {
			weight: 'Gewicht',
			waist: 'Taille',
			skinfold: 'Huidplooi',
			skinfolds: 'Huidplooien',
		},
		labelStyles: {
			us: 'US',
			eu: 'EU',
		},
		programTypes: {
			intensified: 'Geïntensiveerd',
			dup: 'DUP',
			tup: 'TUP',
		},
		loading: {
			pleaseWait: 'Even geduld...',
			sendingReport: 'Rapport verzenden...',
			registeringPayment: 'Betaling registreren...',
			signingIn: 'Inloggen...',
			loggingInWithGoogle: 'Inloggen met Google...',
			loggingInWithFacebook: 'Inloggen met Facebook...',
			loggingInWithApple: 'Inloggen met Apple...',
		},
		relativeDay: {
			today: 'vandaag',
			yesterday: 'gisteren',
			tomorrow: 'morgen',
		},
	},
	navigation: {
		home: 'Start',
		nutrition: 'Voeding',
		settings: 'Instellingen',
		training: 'Training',
	},
	workouts: {
		restTimer: {
			title: 'Rusttimer',
			defaultLabel: 'Standaardrust',
			exerciseOverrideTitle: 'Rusttimer overschrijven',
			adjustMinus: '-15s',
			adjustPlus: '+15s',
			skip: 'Overslaan',
			done: 'Klaar!',
			rollerLabel: 'RUST',
			notificationBody: 'Rust voorbij',
			autoStartLabel: 'Automatisch starten',
			infoNative: 'De rusttimer telt af tussen sets van dezelfde oefening en werkt alleen in de geïnstalleerde mobiele app (iOS of Android). Staat Automatisch starten aan, dan start hij zodra je een set vastlegt. Anders start je hem met de knop Rusttimer starten onder de eerste set. De instellingen zijn op elk apparaat beschikbaar.',
			infoOverride: 'Geldt alleen in de geïnstalleerde mobiele app (iOS of Android).',
		},
		detail: {
			weightExplanations: {
				addedWeightExplanation: 'Dit is het totale <i>toegevoegde</i> gewicht, <i>zonder</i> je eigen lichaamsgewicht.',
				totalWeightExplanation: 'Dit is het <i>totale</i> gewicht (inclusief het gewicht van de stang).',
			},
			buttons: {
				yesAgree: 'Ja, ik ga akkoord.',
				noKeepIntensity: 'Nee, ik houd deze intensiteit voorlopig aan.',
				noKeepExercise: 'Nee, ik houd deze oefening voorlopig aan.',
				noKeepProgram: 'Nee, ik houd dit programma voorlopig aan.',
				decideLater: 'Ik beslis later.',
			},
			resolve: 'Oplossen',
			workoutComplete: 'Goed gedaan! Je hebt je training voltooid.',
			workoutCompleteFirstTest: 'Testtraining voltooid! De volgende training past je doelherhalingen automatisch aan.',
			workoutCompleteSecondTest: 'Startgewichten en doelherhalingen ingesteld! Volgende training: progressieve overload.',
			plan: 'Schema',
			skipped: 'Overgeslagen',
			setOrdinal: 'Set {number}',
			setInstructionsToggle: 'Instructies voor de set',
			collapseSet: 'Set inklappen',
			repsLabel: 'Herhalingen',
			bwHelpText: 'Vul alleen het toegevoegde gewicht in. Vul 0 in als je je lichaamsgewicht gebruikte (zonder extra gewicht).',
			myoReps: 'Myo-reps',
			lastWorkout: 'Vorige training',
			lastWorkoutSameIntensity: 'Vorige training met hetzelfde intensiteitsniveau wordt getoond.',
			selectEquipmentHere: 'Selecteer hier je materiaal.',
			equipmentWarning: {
				title: 'Verbeter je materiaal',
				messagePart1: 'Het geselecteerde materiaal ondersteunt het gekozen gewicht niet ({error}). ',
				messageLink: 'Werk je materiaal bij',
				messagePart2: ' om nauwkeurige progressiesuggesties te garanderen.',
				mobileMessage: 'Het geselecteerde materiaal ondersteunt het gekozen gewicht niet ({error}). Werk je materiaal bij om nauwkeurige progressiesuggesties te garanderen.',
				button: 'Materiaal bijwerken',
			},
			equipmentFloor: {
				hintEmptyBar: 'Lege stang · je doel is {target}',
				hintLightestFixed: 'Je lichtste gewicht · je doel is {target}',
				hintLightestStackPlate: 'Lichtste plaat op deze machine · je doel is {target}',
				hintLightestSetting: 'Lichtste instelling · je doel is {target}',
				title: 'Waarom {floor}?',
				bodyEmptyBar: 'Het streefgewicht van je schema voor deze oefening is {target}. Bij een halterstang is het gewicht dat je invoert het totaal, inclusief de stang. Een lege stang weegt al {floor}, dus lichter kan dit materiaal niet. Bedoelde je {target}? Kies lichter materiaal. Train je bewust met {floor}? Prima. Je volgende doel wordt berekend op basis van wat je hier logt.',
				bodyOther: 'Het streefgewicht van je schema voor deze oefening is {target}. Lichter dan {floor} kan dit materiaal niet. Bedoelde je {target}? Kies lichter materiaal. Train je bewust met {floor}? Prima. Je volgende doel wordt berekend op basis van wat je hier logt.',
				lighterEmptyBar: 'Lege stang · lichter kan niet',
				lighterLightestFixed: 'Je lichtste gewicht · lichter kan niet',
				lighterLightestStackPlate: 'Lichtste plaat op deze machine · lichter kan niet',
				lighterLightestSetting: 'Lichtste instelling · lichter kan niet',
				lighterBodyEmptyBar: 'Deze set zou lichter moeten zijn: ongeveer {wanted}. Bij een halterstang is het gewicht dat je invoert het totaal, inclusief de stang. Een lege stang weegt al {floor}, dus lichter kan dit materiaal niet. Wil je lichter? Kies lichter materiaal en voer dan ongeveer {wanted} in. Blijf je bij de stang? Doe de herhalingen met {floor}.',
				lighterBodyOther: 'Deze set zou lichter moeten zijn: ongeveer {wanted}. Lichter dan {floor} kan dit materiaal niet. Wil je lichter? Kies lichter materiaal en voer dan ongeveer {wanted} in. Blijf je bij dit materiaal? Doe de herhalingen met {floor}.',
				button: 'Apparatuur wijzigen',
			},
			badges: {
				myoReps: 'Myo-reps',
				strengthTest: 'Krachttest',
				repTest: 'Reptest',
				myoRepsInfo: 'Tijdbesparende methode met een activatieset en mini-sets met korte rust.',
				strengthTestInfo: 'Vind het maximale gewicht dat je maar 1-5 keer kunt tillen. Blijf op gevoel gewicht toevoegen tot je maar 1-5 herhalingen kunt doen.',
				repTestInfo: 'Doe zoveel herhalingen als je kunt met het voorgeschreven gewicht. Dit aantal wordt je herhalingsdoel. Deze methode reguleert je trainingsvolume automatisch voor elke spiergroep afzonderlijk, op basis van de spiervezelsamenstelling, de capillaire dichtheid en andere factoren die de spier in bepaalde herhalingsbereiken sterker maken.',
				tempSwap: 'Tijdelijk',
				tempSwapInfo: 'Deze oefening is alleen voor deze training een tijdelijke vervanging. Je trainingsschema wordt niet aangepast.',
				bodyweight: 'Lichaamsgewicht',
				bodyweightInfo: 'Deze oefening gebruikt je lichaamsgewicht als onderdeel van de belasting.',
			},
			superset: 'Comboset',
			units: {
				lb: 'Lb',
				kg: 'Kg',
			},
			firstWorkoutTestExplainer: 'Testtraining om je trainingsschema aan te passen',
			pendingWorkoutWarning: 'Je hebt nog een onafgemaakte training van',
			pendingWorkoutExplanation: 'Je kunt teruggaan en die afmaken, of deze training starten waardoor die automatisch wordt voltooid.',
			workoutChangedInfo: 'Wijzigingen aan deze training worden opgeslagen zodra je minstens één set voltooit.',
			coachChanged: {
				title: 'Je coach heeft deze oefening aangepast.',
				detail: '{date}, {name}: {summary}',
			},
			skipRemaining: 'Rest overslaan',
			skipRemainingConfirm: 'Weet je zeker dat je alle resterende sets en oefeningen wilt overslaan?',
			lastAttempt: 'Laatste poging, {days} dagen geleden:',
			equipment: {
				stack: 'Stack: ',
				fixed: 'Vast: ',
				bar: 'Stang: ',
				platesEachSide: 'Schijven (per kant)',
				micro: 'Micro',
				plates: 'Schijven',
				notConfigured: '(niet ingesteld)',
				automatic: 'Automatisch',
				inferredStep: 'afgeleide stap: ~{step}',
				copiedFromOtherUnit: 'We gebruiken je {name} voor deze oefening. Het is dezelfde machine, nu getoond in de eenheid die je koos.',
				chooseDifferentEquipment: 'Materiaal Kiezen',
				chooseEquipmentLabel: 'Kies apparatuur',
			},
			setInstructions: {
				nonRMTestRetry: 'Rust een paar minuten. Raadpleeg de [instructies](@help:workout.strength-test-failed) en probeer het opnieuw.',
				nonRMTest: 'Vind het maximale gewicht dat je voor het voorgestelde aantal herhalingen kunt tillen. [Meer info](@help:workout.strength-test)',
				rmTestRetry: 'Rust een paar minuten. Raadpleeg de [instructies](@help:workout.RM-strength-test-failed) en probeer het opnieuw.',
				rmTest: 'Vind je 1-5RM. [Meer informatie](@help:workout.RM-strength-test)',
				rmTestFollow: 'Doe zoveel herhalingen als je kunt met een goede techniek. [Meer info](@help:workout.RM-test_follow)',
				repTest: 'Bepaal je herhalingsdoel voor deze oefening. [Meer info](@help:workout.rep-test)',
				regular: 'Doe zoveel herhalingen als je kunt met het voorgeschreven gewicht.',
				followup: 'Doe zoveel herhalingen als je kunt met een goede techniek.',
				dropset: 'Doe zoveel herhalingen als je kunt met een goede techniek. [Meer info](@help:workout.dropset)',
				dropsetEccentric: 'Probeer indien mogelijk alleen de excentrische fase (de neerwaartse beweging) van de oefening te doen, zonder extra belasting, voor zoveel gecontroleerde herhalingen als je kunt. [Meer info](@help:workout.dropset)',
				dropsetReduce: 'Verminder het gewicht zoals aangegeven. Doe zoveel herhalingen als je kunt met een goede techniek. [Meer info](@help:workout.dropset)',
				deload: 'Doe slechts 3-5 **explosieve** herhalingen met de verlaagde belasting. [Meer info](@help:workout.deload)',
				deloadAtFloor: 'Doe slechts 3-5 **explosieve** herhalingen met dit gewicht. [Meer info](@help:workout.deload)',
			},
			setProgress: {
				lastSession: 'Vorige sessie',
				lastMarker: 'laatste · {reps}',
				repsRangePlaceholder: '{min}–{max}',
				progressedTitle: 'Vooruitgang geboekt!',
				targetHitTitle: 'Doelherhalingen behaald!',
				setLoggedTitle: 'Set vastgelegd',
				repsAtWeight: '{reps} {{herhaling|herhalingen}} bij {weight}',
				overLastTime: '+{count} meer dan vorige keer',
				nextSessionAimFor: 'Volgende sessie: streef naar {reps}+.',
				lastTimeYouDid: 'Vorige keer deed je {reps}.',
				lastTimeLabel: 'Vorige keer',
				todayLabel: 'Vandaag',
				startRestTimer: 'Rusttimer starten · {duration}',
				outcomeTargetHit: 'Doel behaald',
				lastShort: 'Vorige {value}',
				targetLabel: 'Doel',
				overLastTimeShort: '+{count} {{herhaling|herhalingen}} (t.o.v. vorige keer)',
				editSet: 'Set wijzigen',
				restTimer: 'Rusttimer · {duration}',
				outcomeSame: 'Zelfde als vorige keer',
				outcomeFewer: 'Minder herhalingen',
				loggedAtLabel: 'Vastgelegd om',
				nextSessionLabel: 'Volgende sessie',
				repsOrMore: '{reps}+',
				targetRangeReps: '{floor}–{target} herhalingen',
				targetReps: '{target} {{herhaling|herhalingen}}',
			},
			summary: {
				title: 'Training voltooid',
				setsCount: '{count} {{set|sets}}',
				minutes: '{minutes} min',
				hoursMinutes: '{hours} u {minutes} min',
				recordsPart: '{count} persoonlijke {{record|records}}',
				progressedPart: '{count} {{oefening|oefeningen}} vooruitgegaan',
				and: 'en',
				personalRecord: 'Persoonlijk record',
			},
			finishedExercise: {
				moreRepsVsLastTime: '+{count} {{herhaling|herhalingen}} t.o.v. vorige keer',
				fewerRepsVsLastTime: '−{count} {{herhaling|herhalingen}} t.o.v. vorige keer',
				sameAsLastTime: 'Zelfde als vorige keer',
				lastWorkoutLine: 'Vorige training: {sets}',
				nextTargetLine: 'Volgend doel: streef naar {reps}+ herhalingen in set 1',
			},
			exerciseHeader: {
				set: 'set',
				sets: 'sets',
				skipped: 'overgeslagen',
				highRep: 'veel herhalingen; ',
				heavy: 'zwaar; ',
				medium: 'gemiddeld; ',
			},
		},
		buttons: {
			description: 'Beschrijving',
			instructions: 'Instructies',
			history: 'Geschiedenis',
			stats: 'Statistieken',
			settings: 'Instellingen',
			skipToday: 'Vandaag overslaan',
			changeExercise: 'Oefening wijzigen',
			resetProgress: 'Voortgang resetten',
			logSet: 'Set vastleggen',
			completeSet: 'Set voltooien',
			saveSet: 'Set opslaan',
			logShort: 'Vastleggen',
			saveShort: 'Opslaan',
			nextDay: 'Volgende dag',
			close: 'Sluiten',
			yesAgree: 'Ja, ik ga akkoord',
			noDisagree: 'Nee, ik ga niet akkoord',
			yesCorrect: 'Ja, het klopt',
			oopsLetMeChange: 'Oeps, laat me dat aanpassen.',
			addNote: 'Notitie toevoegen',
			setNote: 'Setnotitie',
		},
		alerts: {
			youChangedWeight: 'Heb je het gewicht gewijzigd?',
			weightEstimateWrong: 'Onze app schat de ideale belasting voor elk van je werksets in. Waarom denk je dat we het mis hadden?',
			agreeWithDeload: 'Ga je akkoord met een reactieve deload?',
			agreeWithUpgrade: 'Ga je akkoord met een upgrade van je trainingsschema?',
			skipExercise: 'Oefening overslaan...',
			skipRemainingSets: 'Wil je de rest van de sets voor deze oefening in deze training overslaan?',
			skipThisExercise: 'Wil je deze oefening in deze training overslaan?',
			isThisCorrect: 'Klopt dit?',
			notesForSet: 'Notities voor deze set',
			notesForPreviousWorkouts: 'Notities voor vorige trainingen vind je onder Meer > Statistieken en notities.',
			switchType: 'Oefening wijzigen',
			switchTypeMessage: 'Wil je deze oefening permanent in je programma vervangen, of alleen voor deze sessie?',
			thisSessionOnly: 'Alleen deze sessie',
			permanently: 'Permanent',
			resetProgress: 'Voortgang resetten',
			resetProgressConfirm: 'Weet je zeker dat je de huidige cyclus voor deze oefening wilt resetten? We moeten dan je kracht in deze oefening opnieuw testen. Je eerdere PR\'s blijven bewaard in de sectie "Voortgang".',
			switchExerciseResetWarning: 'Je voltooide sets blijven bij deze oefening, en de nieuwe oefening begint bij set 1. Wil je doorgaan?',
			exercisesSkipped: 'Sommige oefeningen zijn overgeslagen door een storing in de app.\n({exercises})',
			weightTooHeavy: 'Het gewicht dat je me aanraadt is veel te zwaar.',
			weightTooLight: 'Het gewicht dat je me aanraadt is veel te licht.',
			closestWeight: 'Het gewicht dat ik heb gekozen is het dichtst bij wat je me aanraadt te gebruiken.',
			recommendDeload: 'Reactieve deload aanbevolen voor deze oefening. Je lijkt nog niet hersteld te zijn.',
			plateau: {
				exerciseChanged: 'We hebben {name} veranderd in deze oefening.',
				exerciseWillChange: 'Deze oefening wordt in de volgende sessie gewijzigd.',
				intensityChangeTitle: 'Ga je akkoord met een intensiteitswijziging voor {name}?',
				intensityChangeMessage: 'We denken dat je een plateau hebt bereikt bij de huidige oefenintensiteit. Daarom raden we aan je op een andere intensiteit te hertesten om een optimale progressie te garanderen.',
				exerciseChangeTitle: 'Ga je akkoord om {name} in een andere oefening te veranderen?',
				exerciseChangeMessage: 'We raden aan deze oefening op dit punt te vervangen.',
				planUpgradeMessage: 'Gefeliciteerd! Je recente vooruitgang laat zien dat je klaar bent voor een geavanceerder trainingsprogramma.',
				retestThis: 'We bepalen je herhalingsdoel opnieuw in deze sessie.',
				retestNext: 'We bepalen je herhalingsdoel opnieuw in de volgende sessie.',
				switchToTUPThis: 'De oefening schakelt in deze sessie over op Triple Undulating Periodization.',
				switchToTUPNext: 'De oefening schakelt in de volgende sessie over op Triple Undulating Periodization.',
				switchToDUPThis: 'De oefening schakelt in deze sessie over op Dual Undulating Periodization.',
				switchToDUPNext: 'De oefening schakelt in de volgende sessie over op Dual Undulating Periodization.',
				planUpgradeConfirm: 'We upgraden je trainingsschema na deze sessie naar een geavanceerder niveau.',
			},
			repCeiling: {
				title: 'Je hebt 30 herhalingen bereikt',
				switchMessage: 'Meer dan 30 herhalingen levert niet veel spiergroei meer op, en het volgende gewicht op je materiaal is een te grote sprong. Vanaf de volgende training overschakelen op een andere oefening?',
				yes: 'Ja',
				noKeep: 'Nee, 30 herhalingen aanhouden',
			},
			unusualSet: '{setStatText} voor {exerciseName} lijkt ongebruikelijk vergeleken met je vorige invoer.',
			unusualSetRepTest: '{setStatText} voor de herhalingstest van {exerciseName} lijkt ongebruikelijk vergeleken met je vorige invoer.',
			viewOnly: {
				futureWorkoutMessage: 'Deze training staat gepland voor een datum in de toekomst. Voltooi en registreer trainingen op hun geplande dag, idealiter in de sportschool.',
				previousWorkoutMessage: 'Dit is een vorige training. Voel je vrij om correcties aan te brengen.',
				templateMessage: 'Dit is een trainingssjabloon uit je schema. Op de geplande dag zie je de specifieke training met meer details. Voel je vrij om hier zo nodig alvast oefeningen te wijzigen.',
				loggingMessage: 'Registreer de training het best terwijl je in de sportschool bent. Zo kunnen we je de beste begeleiding geven bij elke volgende set.',
			},
		},
		status: {
			exerciseNotOptimal: 'Deze oefening is op dit moment niet optimaal voor je en wordt in de volgende training vervangen.',
			goodJobProgression: 'Goed gedaan! Nu kunnen we je progressie vanaf hier begeleiden.',
			strengthLevelCalculated: 'Goed gedaan! Krachtniveau berekend.',
			strengthCalculatedLighterSets: 'Goed gedaan! Krachtniveau berekend. De rest van de sets zijn lichter om je krachtuithoudingsvermogen te beoordelen.',
			tooManyRepsRetry: 'Rust een paar minuten en gebruik een zwaarder gewicht om dichter bij de doelherhalingen te komen.',
			tooManyRepsNextWorkout: 'We proberen dit in een toekomstige training opnieuw met een zwaarder gewicht om dichter bij de doelherhalingen te komen.',
			tooFewRepsRetry: 'Rust een paar minuten en gebruik een lichter gewicht om dichter bij de doelherhalingen te komen.',
			tooFewRepsNextWorkout: 'We proberen dit in een toekomstige training opnieuw met een lichter gewicht om dichter bij de doelherhalingen te komen.',
			repRangeEstablished: 'Uitstekend! We hebben je doelherhalingsbereik vastgesteld.',
			repRangeEstablishedContinue: 'Uitstekend! We hebben je doelherhalingsbereik vastgesteld. In de volgende sets hoef je dit niet te evenaren. Doe gewoon zoveel herhalingen als je kunt.',
			strengthRetestNextTooHeavy: 'Omdat je aangaf dat de voorgestelde belasting te zwaar voor je is, laten we je de volgende keer je kracht opnieuw testen met een andere methode. Bekijk de testinstructies. Voor vandaag kun je het door jou gekozen gewicht blijven gebruiken.',
			strengthRetestNextTooLight: 'Omdat je aangaf dat de voorgestelde belasting te licht voor je is, laten we je de volgende keer je kracht opnieuw testen met een andere methode. Bekijk de testinstructies. Voor vandaag kun je het door jou gekozen gewicht blijven gebruiken.',
			differentWeightEquipment: 'Omdat je een ander gewicht koos dan voorgesteld, kun je overwegen het materiaal voor deze oefening bij te werken zodat we het de volgende keer goed inschatten.',
			progressionDeload: 'De geplande progressie niet gehaald. Bezig met deloaden...',
			progressionDeloadLastSet: 'De geplande progressie niet gehaald. Je streefgewicht gaat bij de volgende training één stap omlaag.',
			repTargetUpdatedRegular: 'We hebben het herhalingsdoel voor deze oefening bijgewerkt op basis van je huidige voortgang.',
			repTargetUpdatedHighRep: 'We hebben het herhalingsdoel voor de sessie met veel herhalingen in deze oefening bijgewerkt op basis van je huidige voortgang.',
			repTargetUpdatedHeavy: 'We hebben het herhalingsdoel voor de zware sessie in deze oefening bijgewerkt op basis van je huidige voortgang.',
			lastSetNotNeeded: 'De laatste set is niet nodig. Die wordt overgeslagen.',
			lowerThanRecommended: 'Dit gewicht is lager dan het aanbevolen gewicht van {plannedWeight}. Als je van sportschool of materiaal bent veranderd, kun je het materiaal bijwerken zodat we weten wat beschikbaar is.',
			immediateProgression: 'Je doet het geweldig! Laten we het gewicht meteen verhogen en kijken of je daarmee de doelherhalingen haalt.',
			immediateProgressionReps: 'Je doet het geweldig! Laten we het herhalingsdoel verhogen en kijken of je het met dit gewicht haalt.',
			maxedOutEquipment: 'Het lijkt erop dat we je streefgewicht met dit materiaal niet verder kunnen verhogen, dus de volgende keer schakelen we over op een andere oefening. Als je in werkelijkheid wel meer gewicht kunt toevoegen, werk dan je beschikbare materiaal bij.',
			plateauResolved: 'Je hebt een plateau bereikt. {message}',
			plateauDetected: 'Je voortgang is bij dit gewicht al meer dan één sessie gestagneerd.',
			plateauDismissed: 'Plateau genegeerd door gebruiker.',
			volumeAutoregulationIncrease: 'Volumeautoregulatie toegepast. Je trainingsvolume wordt in de volgende training met 1 set verhoogd op basis van je vermoeidheidsindex.',
			volumeAutoregulationDecrease: 'Volumeautoregulatie toegepast. Je trainingsvolume wordt in de volgende training met 1 set verlaagd op basis van je vermoeidheidsindex.',
			volumeAutoregulationPending: 'Op basis van je prestaties raden we aan je setvolume aan te passen.',
			strengthTestFollowupDone: 'Goede set! Je krachttest heeft je progressie voor deze oefening al bijgewerkt, dus houd dit gewicht aan voor de rest van vandaag.',
			repCeilingSwitch: 'Je hebt 30 herhalingen bereikt en het volgende gewicht is een te grote sprong, dus de volgende keer schakelen we over op een andere oefening.',
			repCeilingSwitchSameEquipment: 'Je hebt 30 herhalingen bereikt en het volgende gewicht is een te grote sprong, dus de volgende keer schakelen we over op een andere oefening. Alle alternatieven voor deze oefening gebruiken hetzelfde materiaal, dus overweeg kleinere gewichtsstappen toe te voegen in je materiaalinstellingen.',
			repCeilingHeld: 'Je hebt 30 herhalingen bereikt. Je herhalingsdoel blijft op 30 en we vragen het de volgende keer opnieuw.',
			dropSet: 'Dropset! Verlaag het gewicht voor de volgende sets.',
			dropSetAtFloor: 'Dropset! Lichter kan dit materiaal niet, dus houd dit gewicht aan voor de volgende sets.',
			completeProgressionReset: 'Voer nu de krachttest uit om de reset te voltooien. Als je de training verlaat zonder iets voor de krachttest te registreren, wordt de reset geannuleerd en keer je terug naar de oude waarden.',
			adjustedTargetWeight: 'Het lijkt erop dat je deze oefening meer dan een week niet hebt gedaan. Daarom passen we je streefgewicht hierop aan.',
			adjustedTargetReps: 'Het lijkt erop dat je deze oefening meer dan een week niet hebt gedaan. Daarom passen we je doelherhalingen hierop aan.',
			cappedToRecentPerformance: 'Op basis van je laatste sets leek het geplande gewicht te zwaar voor zoveel herhalingen. We hebben het verlaagd naar wat je nu aankunt.',
			deloadedTargetWeight: 'Je streefgewicht is één stap lager door je laatste deload. Dit is een normale werkset: ga voor je herhalingsdoel.',
			retestRequired: 'Het lijkt erop dat je deze oefening een paar weken niet hebt gedaan. Daarom moet je deze oefening opnieuw testen.',
		},
		instructions: {
			fillInReps: 'Vul je aantal herhalingen voor de set in.',
			fillInWeight: 'Vul het door jou getilde gewicht in.',
			fillInWeightAndReps: 'Vul het door jou getilde gewicht en het aantal herhalingen voor de set in.',
		},
		errors: {
			unableToLoad: 'Kan de training niet laden',
			unableToLoadMessage: 'De training kan op dit moment niet worden geladen, sorry. Probeer het opnieuw. Als het probleem aanhoudt, neem dan contact op met de klantenservice.',
		},
	},
	foods: {
		title: 'Voeding',
		addFoods: 'Voeding toevoegen',
		searchPlaceholder: 'Zoeken...',
		filtersAndSettings: 'Filters en instellingen',
		showFoodValuesBy: 'VOEDINGSWAARDEN TONEN PER',
		servingSize: 'Portiegrootte',
		per100g: '100 g',
		filters: {
			all: 'Alle',
			foods: 'Voeding',
			recipes: 'Recepten',
			meals: 'Maaltijden',
			favorites: 'Favorieten',
			myFoods: 'Mijn voeding',
			loggedBefore: 'Eerder gelogd',
			hideUnverified: 'Ongeverifieerd verbergen',
			hideUnverifiedHint: 'Verbergt voeding toegevoegd door andere leden en Open Food Facts',
			type: 'Type',
			showOnly: 'Alleen tonen',
			source: 'Bron',
			removeFilter: '{filter} verwijderen',
			reset: 'Wissen',
		},
		buttons: {
			createRecipe: 'Recept maken',
			createFood: 'Voedingsmiddel maken',
			addMacros: 'Macro\'s toevoegen',
			new: 'Nieuw',
			filters: 'Filters',
			retrySearch: 'Opnieuw proberen',
			clearFilters: 'Filters Wissen',
			searchCorrection: 'Zoeken naar {phrase}',
			searchTypedInstead: 'In plaats daarvan zoeken naar {phrase}',
			removeFromHistory: 'Uit recente voedingsmiddelen verwijderen',
		},
		badges: {
			recipe: 'Recept',
			meal: 'Maaltijd',
			locked: 'Vergrendeld',
			usedBefore: 'Eerder gelogd',
			liked: 'Vind ik leuk',
			disliked: 'Vind ik niet leuk',
			community: 'Community',
			openFoodFacts: 'Open Food Facts',
			staple: 'Basisvoedingsmiddel',
			noNutritionData: 'Geen voedingswaarden',
			checkValues: 'Controleer waarden',
			checkValuesInfo: 'De vermelde calorieën van dit voedingsmiddel kloppen niet met het eiwit, vet en de koolhydraten, die uitkomen op ongeveer {expectedCalories} kcal per 100 g. Deze invoer klopt mogelijk niet.',
		},
		messages: {
			useSearchBar: 'Gebruik de zoekbalk hierboven om voedingsmiddelen te vinden.',
			removedFromHistory: 'Verwijderd uit je recente voedingsmiddelen.',
			nothingMatchesFilters: 'Geen voedingsmiddelen komen overeen met je filters.',
			clearFiltersOrSearch: 'Wis de filters, of gebruik de zoekbalk hierboven om voedingsmiddelen te vinden.',
			clearFiltersOrCreate: 'Wis de filters, of gebruik de knop + Nieuw om een nieuw voedingsmiddel of recept te maken.',
			noFoodByBarcode: 'Geen voedingsmiddel gevonden voor die barcode. Gebruik de knop hieronder om het aan te maken.',
			noFoodByBarcodeScanLabel: 'Geen voedingsmiddel gevonden voor die barcode.',
			noFoodByBarcodeScanLabelHint: 'Maak een paar foto\'s van de verpakking en wij maken een nieuw voedingsmiddel voor je aan!',
			notFoundWhat: 'Niet kunnen vinden wat je zoekt?',
			searchConnectionTitle: 'Zoekresultaten konden niet worden geladen',
			searchConnectionHint: 'Er lijkt een verbindingsprobleem te zijn. Controleer je internet en probeer het opnieuw.',
			offlineShowingLocalFoods: 'Je bent offline, dus we kunnen de voedingsdatabase niet doorzoeken. Je ziet basisvoedingsmiddelen en voedingsmiddelen die je recent hebt gegeten, beide opgeslagen op dit apparaat.',
			searchUnreachableShowingLocalFoods: 'We konden de voedingsdatabase niet bereiken. Je ziet basisvoedingsmiddelen en voedingsmiddelen die je recent hebt gegeten, beide opgeslagen op dit apparaat.',
			offlineShowingLocalFoodsBarcode: 'Je bent offline, dus we kunnen de voedingsdatabase niet doorzoeken. Je ziet alleen voedingsmiddelen die je recent hebt gegeten, opgeslagen op dit apparaat.',
			searchUnreachableShowingLocalFoodsBarcode: 'We konden de voedingsdatabase niet bereiken. Je ziet alleen voedingsmiddelen die je recent hebt gegeten, opgeslagen op dit apparaat.',
			searchFailedTitle: 'Voedingsmiddelen konden niet worden geladen',
			searchFailedHint: 'Er ging iets mis bij het laden van je voedingsmiddelen. Probeer het opnieuw.',
			wrongFoodScanLabel: 'Niet het juiste voedingsmiddel?',
			wrongFoodScanLabelHint: 'Maak een paar foto\'s van de verpakking en wij maken een nieuw voedingsmiddel voor je aan!',
			useButtonsBelow: 'Gebruik de knop + Nieuw om een nieuw voedingsmiddel of recept te maken.',
			copiedToClipboard: 'Gekopieerd naar klembord',
			didYouMeanLabel: 'Bedoelde je:',
			showingResultsForLabel: 'Dit zijn resultaten voor',
			searchInsteadForLabel: 'Zoek in plaats daarvan naar',
		},
		suggestions: {
			listLabel: 'Voorgestelde zoekopdrachten',
			loading: 'Suggesties zoeken',
			rowLabel: '{phrase}, {count} {{voedingsmiddel|voedingsmiddelen}}',
			stapleRowLabel: '{name}, basisvoedingsmiddel',
		},
	},
	nutrition: {
		labels: {
			nutrient: 'Voedingsstof',
			target: 'Doel',
			actual: 'Werkelijk',
		},
		targets: {
			remaining: 'Resterend',
			logged: 'Gelogd',
		},
		macrosLogged: 'Macro\'s gelogd',
		macrosRemaining: 'Macro\'s resterend',
		nutritionInfo: 'Voedingswaarde-info',
		flexibleNutritionLink: 'Flexibele voeding',
		calorieCyclingLink: 'Calorieën cyclen',
		settings: {
			meals: 'Maaltijden',
		},
		planMyWeek: 'Mijn week plannen',
		charts: {
			loggedCalories: 'Gelogde calorieën',
			targetCalories: 'Doelcalorieën',
		},
		enabledForMealsBoth: 'zijn ingeschakeld voor je maaltijden.',
		enabledForMeals: 'is ingeschakeld voor je maaltijden.',
	},
	errors: {
		userFacing: {
			authFailed: 'Inloggen mislukt na het online komen. Je blijft offline.',
			foodNotExist: 'Voedingsmiddel bestaat niet',
			foodLoadFailedTitle: 'Voedingsmiddel kon niet worden geladen',
			foodLoadFailed: 'Dit voedingsmiddel kon nu niet worden geladen. Controleer je verbinding en probeer het opnieuw.',
			foodDeleteFailed: 'Dit voedingsmiddel kon niet worden verwijderd. Probeer het opnieuw.',
			ingredientListLoadFailed: 'Niet alle voedingsmiddelen in deze maaltijd konden worden geladen. Controleer je verbinding en probeer het opnieuw.',
			noMealOnDayTitle: 'Geen maaltijd om aan toe te voegen',
			noMealOnDay: 'Er is op deze dag geen maaltijd waar je voeding aan kunt toevoegen. Kies een andere dag.',
			splitIntoFoodsFailed: 'Dit kon niet worden opgesplitst in voedingsmiddelen. Mogelijk is een van de ingrediënten niet meer beschikbaar. Probeer het opnieuw.',
			splitTuningFailed: 'Je voedingsmiddelen zijn opgesplitst, maar automatisch afstemmen liep tegen een probleem aan en kon hun hoeveelheden niet aanpassen. Pas ze zelf aan of probeer het opnieuw.',
			confirmRecentMealFailed: 'De voedingsmiddelen van deze maaltijd konden niet worden toegevoegd. Probeer het opnieuw.',
			recentMealCouldNotBeOpened: 'Deze maaltijd kon niet worden geopend, dus er is niets toegevoegd. Mogelijk is hij verwijderd of nog niet helemaal gesynchroniseerd. Probeer het opnieuw.',
			couldNotOpenPage: 'Dit kon niet worden geopend. Mogelijk is het verwijderd of is het nu niet beschikbaar.',
			couldNotLeavePage: 'Dit scherm kon niet worden gesloten. Probeer het opnieuw.',
			exportFailed: 'Het bestand kon niet worden geëxporteerd. Probeer het opnieuw.',
			unsupportedBrowser: 'Je browser wordt mogelijk niet volledig ondersteund',
			noticeUnusual: 'Iets ongewoons opgemerkt?',
			communityAuthFailed: 'Kan niet authenticeren voor toegang tot de community',
			equipmentCannotBeUsed: 'Deze apparatuur kan niet worden gebruikt',
			unsubscribeFailed: 'Uitschrijven mislukt',
			paymentPending: 'Je betaling wacht op verificatie, maar je kunt de app blijven gebruiken',
			resubscribeFailed: 'Opnieuw abonneren mislukt',
			planSwitchFailed: 'Kan niet van schema wisselen',
			sendLoginEmailFailed: 'Verzenden van de inlog-e-mail mislukt. Neem contact op met support.',
			updateWorkoutFailed: 'Je training kon niet worden bijgewerkt. Probeer het opnieuw.',
			paddlePortalFailed: 'Kon het abonnementsportaal niet openen. Probeer het opnieuw.',
			imageReadFailed: 'Kon de geselecteerde afbeelding niet lezen.',
			imageDecodeFailed: 'Kon de geselecteerde afbeelding niet laden.',
			imageTooSmall: 'De geselecteerde afbeelding is te klein. Het minimumformaat is {minSize} px.',
			imageUploadFailed: 'Kon de afbeelding niet uploaden. Controleer je verbinding en probeer het opnieuw.',
		},
		syncRetry: {
			retrying: 'Verbinding maken met je gegevens — momentje...',
			stillRetrying: 'We zijn er nog mee bezig — even geduld!',
		},
	},
	auth: {
		login: 'Inloggen',
		signup: 'Registreren',
		forgotPassword: 'Wachtwoord vergeten',
		email: 'E-mail',
		enterYourEmail: 'Voer je e-mailadres in',
		password: 'Wachtwoord',
		enterYourPassword: 'Voer je wachtwoord in',
		signInReadyTapAgain: 'Inloggen is nu klaar. Tik nog een keer op de knop.',
		enterYourName: 'Voer je naam in',
		chooseYourPassword: 'Kies je wachtwoord',
		loginToAccount: 'Inloggen op je account',
		welcomeToMhPhysique: 'Welkom bij MH Physique',
		dontHaveAccountYet: 'Heb je nog geen account?',
		dontHaveAccount: 'Heb je geen account?',
		dontHaveAccountButton: 'Heb je geen account?',
		learnMore: 'Meer informatie',
		processing: 'Bezig met verwerken',
		loginWithLink: 'Ontvang de link',
		signInByEmail: 'Mail me een inloglink',
		signInWithPassword: 'Inloggen met wachtwoord',
		createAccount: 'Een account maken',
		alreadyHaveAccount: 'Heb je al een account?',
		signUpWithEmail: 'Registreren met e-mail',
		orSignUpWith: 'Of registreer met',
		or: 'OF',
		signIn: 'Inloggen',
		signInWithGoogle: 'Inloggen met Google',
		signInWithApple: 'Inloggen met Apple',
		google: 'Google',
		apple: 'Apple',
		firstLastName: 'Voor- en achternaam',
		choosePassword: 'Kies wachtwoord',
		subscriptionSuccess: 'Abonnement gelukt!',
		subscriptionSuccessCheckEmail: 'We hebben een inloglink gestuurd naar het e-mailadres dat je bij het afrekenen hebt gebruikt. Bekijk je inbox om te beginnen.',
		emailLinkSent: 'E-maillink verzonden',
		emailLinkSentMessage: 'We hebben je een e-mail met een inloglink gestuurd. Zie je de e-mail niet snel? Controleer dan je spam-map.',
		emailLinkContact: 'Als hij er niet is, neem contact op met',
		bySigningIn: 'Door in te loggen ga je akkoord met de',
		bySubscribing: 'Door je te abonneren ga je akkoord met de',
		termsAndConditions: 'Algemene voorwaarden',
		and: 'en',
		privacyPolicy: 'Privacybeleid',
		pricing: 'Prijzen',
		refunds: 'Terugbetalingen',
		eula: 'EULA',
		claim: {
			alreadyHaveAccount: 'Ik heb al een account',
			newToMhPhysique: 'Ik ben hier nieuw',
			createAccount: 'Account maken',
		},
		switchAccount: {
			title: 'Account wisselen',
			message: 'Je bent ingelogd als {currentEmail}. Wisselen naar {newEmail} om toegang te krijgen tot je abonnement?',
			switchButton: 'Wisselen',
			expiredTitle: 'Link verlopen',
			expiredMessage: 'Je inloglink is verlopen. We hebben een nieuwe gestuurd naar {email}.',
			expiredResendFailedMessage: 'Je inloglink is verlopen en we konden op dit moment geen nieuwe naar {email} sturen. Controleer je verbinding en probeer het opnieuw.',
			unfinishedTitle: 'Wisselen niet voltooid',
			unfinishedMessage: 'Wisselen naar {newEmail} duurt te lang, dus je bent nog steeds ingelogd op je huidige account. Als het wisselen alsnog lukt, start de app opnieuw. Zo niet, open de link dan opnieuw.',
		},
		errors: {
			otlExpired: 'De eenmalige link is verlopen. Voer je e-mailadres in om een nieuwe te ontvangen.',
			otlRecent: 'Controleer je inbox. We hebben je onlangs een link gestuurd om in te loggen. Kun je hem niet vinden? We kunnen er nog een sturen.',
			otlAmbiguousAccount: 'We konden je inloglink niet versturen, omdat er meer dan één account op dit e-mailadres staat en we niet kunnen zien welk account van jou is. Neem contact met ons op via {email}, dan lossen we het op.',
			signInTokenCheck: 'Fout bij het controleren van het inlogtoken. Probeer het opnieuw of gebruik een andere methode.',
			useAlternativeTitle: '{provider} gebruiken?',
			useAlternativeMessage: 'Dit account is al geregistreerd via {provider}-inloggen. Wil je {provider} gebruiken om in te loggen?',
			badEmailFormat: 'Ongeldig e-mailadresformaat.',
			passwordResetSent: 'Bekijk je inbox voor instructies om je wachtwoord opnieuw in te stellen. Kom daarna hier terug om in te loggen.',
			popupClosed: 'De pop-up is gesloten. Probeer het opnieuw.',
			firebase: {
				invalidEmail: 'Voer een geldig e-mailadres in.',
				missingEmail: 'Voer je e-mailadres in.',
				userNotFound: 'Geen account gevonden met dit e-mailadres. Controleer je e-mailadres of maak een nieuw account aan.',
				emailAlreadyInUse: 'Er bestaat al een account met dit e-mailadres. Log in plaats daarvan in, of gebruik "Wachtwoord vergeten" als je het vergeten bent.',
				accountExistsWithDifferentCredential: 'Er bestaat al een account met dit e-mailadres, maar het gebruikt een andere inlogmethode. Log in zoals je dat eerder deed, bijvoorbeeld met je e-mailadres en wachtwoord.',
				wrongPassword: 'Onjuist wachtwoord. Probeer het opnieuw.',
				invalidCredential: 'Onjuist e-mailadres of wachtwoord. Probeer het opnieuw.',
				weakPassword: 'Je wachtwoord is te zwak. Kies een sterker wachtwoord.',
				tooManyRequests: 'Te veel pogingen. Wacht een paar minuten en probeer het opnieuw.',
				networkRequestFailed: 'Kan geen verbinding maken. Controleer je internetverbinding en probeer het opnieuw.',
				userDisabled: 'Dit account is uitgeschakeld. Neem voor hulp contact op met support via {email}.',
				operationNotAllowed: 'Deze inlogmethode is nu niet beschikbaar. Probeer een andere methode.',
				popupBlocked: 'De inlog-pop-up is geblokkeerd door je browser. Sta pop-ups voor deze site toe en probeer het opnieuw.',
				requiresRecentLogin: 'Log om veiligheidsredenen opnieuw in.',
				invalidActionCode: 'Deze link is ongeldig of is al gebruikt.',
				expiredActionCode: 'Deze link is verlopen. Vraag een nieuwe aan.',
				genericError: 'Er ging iets mis. Probeer het opnieuw of neem contact op met support via {email}.',
			},
		},
		newAccountMade: {
			title: 'Nieuw account aangemaakt',
			message: 'Door op deze manier in te loggen is er een gloednieuw account aangemaakt, dus het is leeg. Als je je al hebt geabonneerd met een ander e-mailadres, vul dat adres dan in en we sturen je een inloglink.',
			placeholder: 'jij@voorbeeld.com',
			continueAsNew: 'Ik ben hier nieuw',
			findMyAccount: 'Zoek mijn account',
			checking: 'Dat adres controleren...',
			linkSent: 'We hebben een inloglink naar {email} gestuurd. Open die op dit apparaat om terug te gaan naar je account.',
			sameAccount: 'Dat is het adres van het nieuwe account waarop je al bent ingelogd. Als je je met een ander adres hebt geabonneerd, probeer dat dan.',
			noAccount: 'We konden geen account met dat e-mailadres vinden. Controleer de spelling of ga verder met het nieuwe account dat je zojuist hebt aangemaakt.',
			severalAccounts: 'Meerdere accounts gebruiken dat e-mailadres, dus we kunnen niet zien welk account van jou is. Neem contact op met support en we lossen het voor je op.',
			couldNotCheck: 'We konden dat e-mailadres op dit moment niet controleren. Controleer je verbinding en probeer het opnieuw.',
			couldNotSend: 'We konden de inloglink op dit moment niet versturen. Controleer je verbinding en probeer het opnieuw.',
		},
		accountHint: {
			title: 'Ander account',
			message: 'De link die je opende is gestuurd naar {hintEmail}, maar je bent ingelogd als {currentEmail}. Wil je dat we een inloglink sturen naar {hintEmail}?',
			stayButton: 'Ingelogd blijven',
			sendButton: 'Link sturen',
			sending: 'Inloglink wordt verstuurd...',
		},
	},
	settings: {
		sections: {
			training: 'Training',
			nutrition: 'Voeding',
			general: 'Algemeen',
			support: 'Support',
			regional: 'Regionale en weergavevoorkeuren',
			accessibility: 'Toegankelijkheid',
			experimental: 'Experimenteel',
		},
		intakePendingCard: {
			title: 'Maak je profiel af',
			body: 'De meeste opties hier passen je fitnessschema aan, dus ze zijn klaar zodra het is gegenereerd.',
			linkText: 'Ga verder met de intake',
		},
		items: {
			trainingSettings: 'Trainingsinstellingen',
			workouts: 'Trainingen',
			editEquipment: 'Apparatuur bewerken',
			nutritionSettings: 'Voedingsinstellingen',
			mealPlanner: 'Maaltijdplanner',
			foods: 'Voedingsmiddelen',
			appSettings: 'App-instellingen',
			manageSubscription: 'Abonnement beheren',
			coaching: 'Coaching',
			privacyChoices: 'Privacykeuzes',
			admin: 'Beheer',
			help: 'Help',
			feedback: 'Feedback',
			messageCoach: 'Bericht naar coach',
			community: 'Community',
			whatsNew: 'Wat is er nieuw',
			rateTheApp: 'Beoordeel de app',
		},
		installApp: 'App installeren',
		language: 'Taal',
		applyingLanguage: 'Taal toepassen…',
		downloadingLanguage: 'Taal downloaden…',
		languageDownloadFailed: {
			title: 'Kan taal niet wijzigen',
			message: 'We konden {language} niet downloaden voor offline gebruik. Controleer je internetverbinding en probeer het opnieuw.',
		},
		clockMode: 'Klokmodus',
		hour24: '24 uur',
		ampm: 'AM/PM',
		automatic: 'Automatisch',
		decimalSeparator: 'Decimaalteken',
		point: 'Punt (.)',
		comma: 'Komma (,)',
		dateFormat: 'Datumnotatie',
		firstDayOfWeek: 'Eerste dag van de week',
		monday: 'Maandag',
		saturday: 'Zaterdag',
		sunday: 'Zondag',
		nutritionLabelStyle: 'Stijl voedingswaarde-etiket',
		foods: {
			uncaching: 'Voedingsmiddelen uit cache verwijderen...',
		},
		allowCardAnimations: 'Kaartanimaties toestaan',
		headerHideBehavior: 'Koptekst verbergen bij scrollen',
		footerHideBehavior: 'Voettekst verbergen bij scrollen',
		scrollHide: {
			always: 'Altijd',
			never: 'Nooit',
		},
		descriptions: {
			language: 'Kies de taal voor de interface van de app. Tekst die nog niet is vertaald, valt terug op Engels.',
			clockMode: 'We hebben {mode} gedetecteerd als de meest waarschijnlijke klokmodus op basis van je huidige land. Als dat niet overeenkomt met je voorkeuren, stel hier dan handmatig een override in.',
			dateFormat: 'Kies hoe datums in de hele app worden weergegeven. Automatisch gebruikt de landinstelling die op basis van je huidige land is gedetecteerd.',
			firstDayOfWeek: 'Kies welke dag als eerste wordt weergegeven in weekoverzichten. Automatisch gebruikt de landinstelling die op basis van je huidige land is gedetecteerd.',
			decimalSeparator: 'Kies welk symbool wordt gebruikt voor decimalen (bijv. "." of ","). Gebaseerd op je regionale instelling.',
			nutritionLabelStyle: 'Etiketten in Amerikaanse stijl tonen totale koolhydraten inclusief vezels. Etiketten in EU-stijl tonen netto koolhydraten zonder vezels.\n\nDit geldt alleen bij het bewerken van een individueel voedingsmiddel. Op andere plekken in de app tonen we altijd netto koolhydraten (zonder vezels), omdat dat metabool meer steek houdt.',
			cardAnimations: 'Schakel de animaties uit als de beweging je stoort, of als je apparaat het niet goed aankan.',
			headerHideBehavior: 'Bepaal of de koptekst wordt verborgen bij omlaag scrollen. \'Auto\' verbergt alleen koppen met kalenders.',
			footerHideBehavior: 'Bepaal of de onderste navigatie wordt verborgen bij omlaag scrollen. \'Auto\' verbergt alleen de hoofdnavigatiebalk.',
			showSlotName: 'Toon de naam van de spiergroep (slotnaam) onder oefeningsnamen in trainingsoverzichten en oefeningsconfiguratie.',
		},
		notifications: {
			sectionTitle: 'Meldingen',
			description: 'Ontvang herinneringen voor geplande activiteiten. Meldingen worden 10 minuten voor de geplande tijd verstuurd.',
			workout: 'Trainingen',
			workoutDescription: 'Voor elke geplande training',
			meals: 'Maaltijden',
			mealsDescription: 'Voor elke geplande maaltijd',
			weighIn: 'Wegingen',
			weighInDescription: 'Op je geplande wegingsdagen',
			weeklyCheckup: 'Wekelijkse check-up',
			weeklyCheckupDescription: 'Wanneer je wekelijkse check-up aan de beurt is',
			sleep: 'Slaap',
			sleepDescription: 'Voor je geplande tijd om tot rust te komen',
			deviceSettings: 'Meldingsinstellingen van je apparaat',
			deviceSettingsDescription: 'Beheer meldingsrechten in de instellingen van je apparaat',
			content: {
				workout: 'Tijd om te trainen',
				meal: 'Tijd om te eten',
				weighIn: 'Tijd om te wegen',
				weeklyCheckup: 'Tijd voor je wekelijkse check-up',
				sleep: 'Tijd om tot rust te komen',
			},
		},
		testSettings: {
			header: 'Testinstellingen',
			testMode: 'Testmodus',
			locale: 'Landinstelling',
			localeDecimalSeparator: 'Decimaalteken van landinstelling',
			unitSettings: 'Eenheidsinstellingen',
			hintsSeen: 'Tips bekeken',
			helpSeen: 'Hulp bekeken',
			dismissedToasts: 'Weggeklikte meldingen',
			showAllHints: 'Alle tips altijd tonen',
			showAllTutorials: 'Alle tutorials altijd tonen',
			debugFoodSearch: 'Voedselzoekfunctie debuggen',
			debugRestTimerOnWeb: 'Rusttimer op web tonen (debug)',
			debugLog: 'Debuglog',
			debugLogPlaceholder: 'Geen log opgeslagen',
			clearLog: 'Log wissen',
			accountDatabase: 'Accountdatabase',
			cachedFoods: 'Momenteel gecachete voedingsmiddelen: {count}',
			uncacheFoodsNote: 'Voor voedingsmiddelen in userdb die ook in globaldb bestaan, wordt het item uit userdb gewist (zorgt voor een hercache bij volgend gebruik).',
			testSurveyNote: 'Hiermee verschijnt de enquête genaamd "Test survey".',
			testNotificationNote: 'Stuurt een pushmelding naar alle mobiele apparaten die op dit account zijn ingelogd. Komt binnen de komende minuut aan.',
			testNotification: 'Pushmelding testen',
			resetHiddenMessagesNote: 'Brengt elk bericht terug dat je hebt verborgen door op "Nooit meer tonen" te tikken. Zonder dit is er geen manier om dat ongedaan te maken.',
			resetHiddenMessages: 'Verborgen berichten herstellen',
			hiddenMessagesRestored: '{count} verborgen bericht{{|en}} wordt weer getoond.',
			noHiddenMessages: 'Je hebt geen berichten verborgen.',
		},
		experimental: {
			showSlotName: 'Slotnaam tonen',
		},
	},
	dbSnapshots: {
		title: 'Databasemomentopnames',
		createSnapshot: 'Momentopname maken',
		rename: 'Hernoemen',
		download: 'Downloaden',
		noSnapshots: 'Nog geen momentopnames. Maak er een om de huidige databasestatus op te slaan.',
		renameTitle: 'Momentopname hernoemen',
		renamePlaceholder: 'Naam van momentopname',
		deleteConfirmTitle: 'Momentopname verwijderen?',
		deleteConfirmMessage: 'Hiermee wordt de momentopname "{name}" permanent verwijderd.',
		creating: 'Momentopname maken...',
		snapshotInfo: '{date} · {count} docs',
		restore: 'Herstellen',
		restoreConfirmTitle: 'Momentopname herstellen?',
		restoreConfirmMessage: 'Hiermee worden alle huidige gegevens vervangen door de momentopname "{name}". Dit kan niet ongedaan worden gemaakt.',
		restoring: 'Momentopname herstellen...',
		restoreComplete: 'Momentopname "{name}" is succesvol hersteld.',
		restoreFailed: 'De momentopname kon niet worden hersteld. De verbinding is halverwege verbroken, dus je gegevens kunnen een mix zijn van oude en herstelde documenten totdat het synchroniseren klaar is. De app wordt nu opnieuw geladen. Controleer je verbinding en probeer het opnieuw.',
		restoreFailedTitle: 'Herstellen mislukt',
		restoreCleanupFailed: 'De momentopname is op de server hersteld, maar de oude lokale kopie op dit apparaat kon niet worden gewist. Blijf de app op dit apparaat nog NIET gebruiken: wis de opslag van de app (of installeer opnieuw) en open hem weer, zodat de herstelde gegevens opnieuw worden gedownload.',
	},
	dbRestoreJson: {
		title: 'Database herstellen vanuit JSON',
		description: 'Upload een JSON-bestand of plak JSON-gegevens om een gebruikersdatabase te herstellen.',
		chooseFile: 'JSON-bestand kiezen',
		orPaste: 'Of JSON plakken',
		pasteHint: 'Plak een reeks documenten als JSON',
		parseJson: 'JSON verwerken',
		restore: 'Herstellen',
		restoring: 'Database herstellen...',
		invalidJson: 'Ongeldige JSON. Moet een reeks documenten zijn, elk met een _id-veld.',
		confirmTitle: 'Database herstellen?',
		confirmMessage: 'Hiermee worden alle huidige gebruikersgegevens vervangen door {count} documenten. Dit kan niet ongedaan worden gemaakt.',
		fileLoaded: '{count} documenten uit bestand geladen.',
		restoreCompleteTitle: 'Database hersteld',
		restoreCompleteMessage: 'Database is hersteld vanuit JSON ({count} documenten).',
		restoreFailed: 'De database kon niet worden hersteld. De verbinding is halverwege verbroken, dus je gegevens kunnen een mix zijn van oude en herstelde documenten totdat het synchroniseren klaar is. De app wordt nu opnieuw geladen. Controleer je verbinding en probeer het opnieuw.',
		restoreFailedTitle: 'Herstellen mislukt',
		restoreCleanupFailed: 'Je gegevens zijn op de server hersteld, maar de oude lokale kopie op dit apparaat kon niet worden gewist. Blijf de app op dit apparaat nog NIET gebruiken: wis de opslag van de app (of installeer opnieuw) en open hem weer, zodat de herstelde gegevens opnieuw worden gedownload.',
	},
	debug: {
		nextDay: 'Volgende dag',
		more: 'Meer...',
	},
	app: {
		title: 'MH Physique',
		updated: 'Bijgewerkt naar {version}',
		whatsNew: 'Wat is er nieuw?',
		updateAvailable: {
			message: 'Er is een nieuwe versie beschikbaar.',
			action: 'Bijwerken',
			downloading: 'Update downloaden…',
			ready: 'Update gedownload.',
			restart: 'Opnieuw starten',
			upToDate: 'Je bent up-to-date',
			settingsRow: 'Controleren op updates',
		},
		updateRequired: {
			title: 'Werk de app bij',
			message: 'Deze versie van de app wordt niet meer ondersteund. Werk nu bij om oplossingen en nieuwe functies te blijven krijgen.',
			update: 'Bijwerken',
			later: 'Later',
			cardMessage: 'Deze versie wordt niet meer ondersteund. Werk de app bij.',
		},
		starting: 'Bezig met starten...',
		loading: 'Bezig met laden...',
		databaseRecoveryLoading: 'Je gegevens worden hersteld...',
		downloadingExistingData: 'Bestaande gegevens downloaden...',
		openingCommunity: 'Community wordt geopend, even geduld...',
		communityOffline: 'De community heeft een internetverbinding nodig. Maak verbinding met internet en probeer het opnieuw.',
		videoOffline: 'Video\'s hebben een internetverbinding nodig.',
		offlineFirstLoadMessage: 'Je bent offline. Maak verbinding met internet om je account voor het eerst op dit apparaat te laden.',
		offlineFirstLoadChecking: 'Je verbinding wordt gecontroleerd...',
		offlineFirstLoadStillOffline: 'Nog steeds offline. Maak verbinding met internet en probeer het opnieuw.',
		offlineFirstLoadServerUnreachable: 'Je verbinding is terug, maar we konden je account niet bereiken. Probeer het zo dadelijk opnieuw.',
		accountLoadFailedMessage: 'We konden je account niet laden. Controleer je verbinding en probeer het opnieuw.',
		splashStuckMessage: 'Dit duurt langer dan gewoonlijk. Controleer je verbinding en probeer het opnieuw.',
		splashStuckOfflineMessage: 'Je lijkt offline te zijn. Maak opnieuw verbinding met internet en probeer het dan opnieuw.',
		retry: 'Opnieuw proberen',
		communityTitle: 'Community',
		communityFirstTime: 'Als je de Community voor het eerst opent, kan het even duren om een account voor je aan te maken. Alvast bedankt voor je geduld.',
		screenshotHelp: 'Gebruik deze knop om de schermafbeelding te maken. Je kunt hem verslepen als hij in de weg zit.',
		screenshotCaptureFailed: 'We konden de schermafbeelding niet maken. Je tekst staat er nog, dus je kunt hem zonder versturen.',
		darkModeConflictTitle: 'Samsung-conflict met donkere modus',
		darkModeConflictMessage: 'Deze app staat altijd in de donkere modus. Samsung Internet legt zijn eigen donkere modus daar bovenop, waardoor de app onleesbaar wordt. Open het browsermenu en tik op "Sites in licht thema" of op "Instellingen > Labs > Donker thema van website gebruiken".',
		darkModeConflictButton: 'Oké, dat heb ik gedaan',
		serverConnectionDifficulty: 'Moeite met verbinden met de server...',
		serverBehindAccountVersion: 'Deze server gebruikt een oudere versie dan je account nodig heeft. Probeer het over een paar minuten opnieuw.',
	},
	appInstallSheet: {
		title: 'Download de MH Physique-app',
		body: 'Een snellere, soepelere ervaring — trainingen, maaltijden loggen en voortgang bijhouden, direct op je telefoon.',
		openInAppCta: 'Openen in MH Physique',
		openInAppLink: 'Heb je de app al? Open hem',
		continueInBrowser: 'Doorgaan in browser',
		dontShowAgain: 'Niet meer tonen',
		notRightNow: 'Nu even niet?',
	},
	progress: {
		title: 'Voortgang',
		filters: 'Filters',
		measurements: 'Metingen',
		exportAsCsv: 'Exporteren als CSV',
		noData: 'Geen gegevens',
		lostPerWeek: 'verloren per week',
		gainedPerWeek: 'aangekomen per week',
		filterHeaders: {
			bodyComposition: 'Lichaamssamenstelling',
			nutrition: 'Voeding',
			chartDisplaySettings: 'Weergave-instellingen grafiek',
		},
		chartTitles: {
			bodyComposition: 'Voortgang lichaamssamenstelling',
			nutrition: 'Voortgang voeding',
		},
		filterOptions: {
			showAverage: 'Gemiddelde tonen',
			showAverageDescription: 'Middelt de laatste 7 dagen aan datapunten om dagelijkse schommelingen glad te strijken',
			showPoints: 'Punten tonen',
			showPointsDescription: 'Toont datapunten als cirkels op de grafieklijnen',
		},
		axisTitles: {
			weight: 'Gewicht ({unit})',
			waist: 'Taille ({unit})',
			caloriesKcal: 'Calorieën (kcal)',
			day: 'Dag',
			month: 'Maand',
		},
		trendLegend: {
			falling: 'Dalend',
			rising: 'Stijgend',
			flat: 'Stabiel',
			uncertain: 'Onduidelijk',
			mayChange: 'Kan nog veranderen',
		},
	},
	intro: {
		start: 'Starten',
		next: 'Volgende',
		back: 'Terug',
		skip: 'Intro overslaan',
		slide1: {
			title: 'Je complete fitnesscoach in je broekzak',
			text: 'Adaptieve training en voeding komen samen in één krachtige app. Je programma evolueert mee met je voortgang, zodat je zeker spieren opbouwt, sterker wordt en vet verliest.',
		},
		slide2: {
			title: 'Log je trainingen en zie je voortgang groeien',
			text: 'Je programma past zich na elke sessie aan om bij je prestaties te passen. Is het te makkelijk, dan dagen we je uit. Is het te veel, dan schroeven we terug om je te helpen herstellen.',
		},
		slide3: {
			title: 'Moeiteloze voeding voor jouw doelen',
			text: 'Je voedingsplan wordt continu bijgewerkt.\nDoor experts ontworpen maaltijden halen het giswerk weg uit het behalen van je doelen.',
		},
		slide4: {
			title: 'Altijd aangepast aan jou',
			text: 'Je plan evolueert terwijl je sterker wordt en past zich naadloos aan om je op koers te houden.\nLiever een andere oefening of wil je je eigen maaltijd?\nPas je plannen aan wanneer je maar wilt.',
		},
	},
	customizeHomepage: {
		title: 'Startpagina aanpassen',
		sections: {
			dailyLog: 'Dagelijks logboek',
			progress: 'Voortgang',
		},
		options: {
			wakeUp: 'Wakker worden',
			weighIn: 'Wegen',
			workout: 'Training',
			meals: 'Maaltijden',
			sleep: 'Slaap',
			goal: 'Doel',
			bodyComposition: 'Lichaamssamenstelling',
			nutrition: 'Voeding',
			coachingTips: 'Coachingtips',
		},
	},
	home: {
		tabs: {
			dailyLog: 'Dagelijks logboek',
			progress: 'Voortgang',
		},
		buttons: {
			logActivity: 'Activiteit loggen',
			logMeal: 'Maaltijd loggen',
			logWorkout: 'Training loggen',
			weighIn: 'Wegen',
			barcodeScan: 'Streepjescode scannen',
			labelScan: 'Etiket scannen',
		},
		hints: {
			nutritionTargetsWaiting: 'Voedingsdoelen zijn beschikbaar zodra je foto\'s zijn beoordeeld. Dit duurt niet langer dan 48 u.',
			offlineNow: 'Je bent offline. Het synchroniseren met de cloud wordt hervat zodra je weer verbinding hebt.',
		},
		messages: {
			noScheduleForDay: 'Er is geen schema voor deze dag.',
		},
		emptyState: {
			allHidden: {
				title: 'Alle items verborgen',
				subtext: 'Je hebt alle items in dit gedeelte verborgen. Gebruik de knop hieronder om aan te passen wat hier verschijnt.',
			},
			customizeButton: 'Startpagina aanpassen',
		},
		alerts: {
			workoutTimeLabel: 'Trainingstijd',
		},
		settingsMenu: {
			customizeDashboard: 'Dashboard aanpassen',
		},
		progress: {
			goalCard: {
				title: 'Doel',
				target: 'Streefwaarde',
				progress: 'Voortgang',
				fatLoss: 'Vetverlies',
				weightLoss: 'Gewichtsverlies',
				weightGain: 'Gewichtstoename',
				estimatedValueTooltip: 'De huidige waarde wordt algoritmisch geschat op basis van je metingen van de afgelopen twee weken. De getoonde verandering is het verschil sinds je dit doel hebt ingesteld.',
				growthMindset: 'Groeimindset',
				growthMindsetInfo: 'Een groeimindset richt zich op consistentie en trainingsvoortgang. Het doel is kracht en spieren opbouwen.',
				start: 'Start',
				goal: 'Doel',
				onTrack: 'Op koers',
				offTrack: 'Uit koers',
				undetermined: 'Onbepaald',
				notEnoughData: 'We hebben nog niet genoeg metingen om je voortgang te beoordelen. Blijf je wegingen en lichaamsvetmetingen loggen.',
				measureMoreOften: 'We hebben meer lichaamsvetmetingen nodig (tailleband of huidplooimeter) om te bepalen of je op koers ligt of niet.',
				dataErratic: 'Je metingen schommelen sterk, waardoor het moeilijk is om een duidelijke trend te bepalen. Probeer onder consistente omstandigheden te meten.',
				weightTooFlat: 'Je gewichtsmetingen zijn verdacht identiek geweest. Controleer of je weegschaal goed werkt.',
				insufficientFatnessConfidence: 'We zijn nog niet zeker van je lichaamsvettrend. Voeg nog een paar metingen toe (tailleband of huidplooimeter) voordat we je plan aanpassen.',
				nutritionAdjusted: 'Voeding {N1} {{dag|dagen}} geleden aangepast. Blijf loggen — de beoordeling wordt over ongeveer {N2} {{dag|dagen}} hervat.',
				nutritionAdjustedToday: 'Voeding vandaag aangepast. Blijf loggen — de beoordeling wordt over ongeveer {N2} {{dag|dagen}} hervat.',
				planJustStarted: 'Plan {N1} {{dag|dagen}} geleden gestart. Blijf loggen — de beoordeling begint over ongeveer {N2} {{dag|dagen}}.',
				planJustStartedToday: 'Plan vandaag gestart. Blijf loggen — de beoordeling begint over ongeveer {N2} {{dag|dagen}}.',
			},
			bodyComposition: {
				title: 'Lichaamssamenstelling',
			},
			nutrition: {
				title: 'Voeding',
			},
			coachingTips: {
				title: 'Coachingtips',
				noTips: 'Je doet het geweldig! Ga zo door.',
			},
		},
	},
	editTrainingGoal: {
		title: 'Trainingsdoelen bewerken',
		primaryGoal: 'Hoofddoel',
		method: 'Methode',
		targetUnit: 'Doeleenheid',
		targetUnitDescription: 'Kies hoe je je progressie wilt volgen',
		goalWeight: 'Streefgewicht',
		goalBodyFat: 'Streefwaarde lichaamsvet',
		growthMindset: 'Groeimindset',
		growthMindsetDescription: 'Een groeimindset richt zich op consistentie en trainingsprogressie. Het doel is kracht en spieren opbouwen.',
		fixedTarget: 'Vast doel',
		fixedTargetDescription: 'Laat de app je progressie volgen ten opzichte van een streefgewicht of lichaamsvetpercentage.',
		weight: 'Gewicht',
		bodyFatPercent: 'Lichaamsvet %',
		fatLoss: 'Vetverlies',
		muscleGrowth: 'Spiergroei',
		update: 'Bijwerken',
		updateAlert: {
			title: 'Trainingsdoel bijwerken',
			message: 'Als je je doel wijzigt, moet je trainingsschema mogelijk volledig opnieuw worden opgebouwd en herstart.',
			updateGoal: 'Doel bijwerken',
		},
	},
	consent: {
		cookies: {
			header: 'Cookies zonder calorieën, de beste soort cookies.',
			message: 'Door op "Alle cookies accepteren" te klikken, ga je ermee akkoord dat MH Physique cookies op je apparaat kan opslaan en informatie kan delen in overeenstemming met ons ',
			privacyPolicy: 'Privacybeleid',
			customize: 'Aanpassen',
			customizeHeader: 'Cookies aanpassen',
			saveSettings: 'Instellingen opslaan',
			acceptAll: 'Alle cookies accepteren',
			rejectAll: 'Alles weigeren',
			required: 'Vereist',
			types: {
				functionality: {
					name: 'Functionaliteit',
					description: 'Maakt opslag mogelijk die de functionaliteit ondersteunt die nodig is voor de goede werking van de website of app, zoals taalinstellingen.',
				},
				security: {
					name: 'Beveiliging',
					description: 'Maakt opslag mogelijk die verband houdt met beveiliging, zoals authenticatiefunctionaliteit, fraudepreventie en andere gebruikersbescherming.',
				},
				personalization: {
					name: 'Personalisatie',
					description: 'Maakt opslag mogelijk die verband houdt met personalisatie, zoals videoaanbevelingen.',
				},
				advertising: {
					name: 'Advertenties',
					description: 'Helpt MH Physique groeien: laat onze advertentiepartners weten hoe je de app gebruikt, zodat onze advertenties de juiste mensen bereiken en we kunnen zien welke werken.',
					gpcNotice: 'Advertenties staan uit omdat je browser een Global Privacy Control-signaal heeft verzonden.',
				},
				performance: {
					name: 'Prestaties',
					description: 'Maakt opslag mogelijk, zoals cookies, die verband houdt met de prestaties van de website en de app, zoals welke opties vaker worden gebruikt. We gebruiken dit om de app te verbeteren.',
				},
			},
			chooseEach: 'Kies aan of uit voor elke optie om je instellingen op te slaan.',
		},
		user: {
			header: 'Voorwaarden en overeenkomsten',
			subtitle: 'Open de onderstaande links en lees de voorwaarden zorgvuldig. Door verder te gaan, bevestig je dat je de volgende voorwaarden hebt gelezen en ermee akkoord gaat.',
			updatedHeader: 'We hebben onze Voorwaarden en ons Privacybeleid bijgewerkt',
			updatedSubtitle: 'We hebben onze voorwaarden bijgewerkt. Bekijk ze en ga akkoord om verder te gaan.',
			later: 'Later',
			updatedCard: 'We hebben onze Voorwaarden en ons Privacybeleid bijgewerkt.',
			updatedCardAction: 'Bekijken',
			reviewOffline: 'Je bent offline. Maak verbinding met internet om het bijgewerkte beleid te bekijken.',
			additionalOptions: 'Aanvullende opties:',
			acceptAll: 'Alles accepteren',
			tosLabel: 'Servicevoorwaarden',
			healthLabel: 'Gezondheidsdisclaimer',
			privacyLabel: 'Privacybeleid',
			researchLabel: 'Help de app te verbeteren door geanonimiseerde fitnessgegevens te delen voor analyse.',
			marketingLabel: 'Blijf op de hoogte van app-tips, nieuwe functies en af en toe een aanbieding.',
			advertisingLabel: 'MH Physique helpen groeien: onze advertentiepartners laten weten hoe ik de app gebruik, zodat onze advertenties de juiste mensen bereiken en we kunnen zien welke werken.',
			continue: 'Doorgaan',
			details: 'Details',
			requiredError: 'Je moet akkoord gaan met de Servicevoorwaarden, het Privacybeleid en de Gezondheidsdisclaimer om verder te gaan.',
			persistFailed: 'We konden je akkoord niet opslaan. Controleer je verbinding en probeer het opnieuw.',
		},
	},
	profile: {
		title: 'Gebruikersprofiel',
		signOut: 'Uitloggen',
		profileSection: 'Profiel',
		subscriptionSection: 'Abonnement',
		subscription: 'Abonnement',
		subscriptionType: 'Type',
		subscriptionTypeMonthly: 'Maandelijks',
		subscriptionTypeYearly: 'Jaarlijks',
		renewalDate: 'Verlengingsdatum',
		expiresOn: 'Verloopt op',
		renewalPrice: 'Verlengingsprijs',
		emailSupport: 'E-mailsupport',
		switchPlanPromo: 'Je huidige plan is "{current}". Stap over naar "{other}" voor {price} en bespaar {saving}!',
		perpetualLicense: '{type}-licentie',
		refreshingStatus: 'Abonnementsstatus vernieuwen...',
		subscriptionInfoError: 'Kon abonnementsgegevens niet laden. Open deze pagina opnieuw om het nog eens te proberen.',
		coachCoversMembership: 'Het plan van je coach dekt op dit moment je Premium-lidmaatschap. Daarnaast betaal je ook je eigen abonnement.',
		boostYourGains: 'Boost je resultaten!',
		upgradeToPremium: 'Upgrade naar Premium en ontgrendel alle functies, waaronder geavanceerde trainingsschema\'s, gedetailleerde progressieregistratie en gepersonaliseerde voedingsplannen.',
		upgradeNow: 'Nu upgraden',
		trialEndsOn: 'Je proefperiode eindigt op {date}',
		trialCancelInfo: 'Als je nu opzegt, kun je Premium-functies blijven gebruiken tot je proefperiode eindigt.',
		cancelSubscription: 'Abonnement opzeggen',
		trialCanceled: 'Je proefperiode is opgezegd en eindigt op {date}',
		trialPaused: 'Je proefperiode wordt gepauzeerd op {date}',
		trialResumeInfo: 'Je kunt je abonnement op elk moment hervatten voordat de proefperiode eindigt.',
		resumeSubscription: 'Abonnement hervatten',
		currentPlanWithSaving: 'Je huidige plan is "{current}". Je kunt overstappen naar "{other}" voor {price} en {saving} besparen!',
		currentPlan: 'Je huidige plan is "{current}". Je kunt overstappen naar "{other}" voor {price}.',
		switchToPlan: 'Overstappen naar {plan}',
		paymentFailing: 'Je laatste betaling is niet gelukt. We blijven het proberen en je abonnement blijft ondertussen actief. Als de betaling blijft mislukken, stopt je abonnement op {date}.',
		paymentProcessing: 'Je betaling wordt verwerkt.',
		paymentProcessingHelp: 'Dit duurt meestal maar een paar minuten. Kom binnenkort nog eens terug.',
		subscriptionEnds: 'Je abonnement eindigt op {date}',
		resubscribeInfo: 'Je kunt je abonnement op elk moment hervatten om te blijven genieten van Premium-functies.',
		support: 'Support',
		reportIssueInfo: 'Leek de app niet goed te werken, of weet je niet zeker wat je nu moet doen? Misschien staat het antwoord dat je zoekt hier. Anders kun je het gerust bespreken met anderen in onze <a href="https://community.mh-physique.app/" target="_blank">Community</a>.',
		reportIssueInfoFeedback: 'Als het je niet lukt om je feedback met de bovenstaande knoppen te versturen, kun je ons ook per e-mail bereiken.',
		termsAndConditions: 'Algemene voorwaarden',
		privacyPolicy: 'Privacybeleid',
		healthDisclaimer: 'Gezondheidsdisclaimer',
		refundPolicy: 'Terugbetalingsbeleid',
		menu: {
			logout: 'Uitloggen',
			deletePrivateData: 'Privégegevens verwijderen',
		},
		deleteData: {
			title: 'Weet je het zeker?',
			message: 'Hiermee worden al je privégegevens verwijderd van de servers en van dit apparaat. Je account en abonnement blijven behouden, maar al je trainings- en voedingsgeschiedenis gaat voorgoed verloren. Let op: sommige gegevens kunnen nog op andere apparaten blijven staan als je daar eerder op hebt ingelogd.',
			deleteButton: 'VERWIJDEREN',
			deleting: 'Alle gebruikersgegevens verwijderen...',
			error: 'Kan het account niet wissen. Probeer het later opnieuw.',
		},
		signOutOfflineWarning: {
			title: 'Uitloggen zonder te uploaden?',
			message: 'Sommige van je recente wijzigingen zijn nog niet naar de cloud geüpload. Als je nu uitlogt, worden die wijzigingen van dit apparaat verwijderd en kunnen ze niet worden hersteld. Om ze te behouden, blijf je ingelogd, zorg je voor een werkende internetverbinding en geef je de app even de tijd om het uploaden te voltooien voordat je uitlogt.',
			signOutAnyway: 'Toch uitloggen',
		},
		reportProblemEmail: {
			subject: 'Issue-name-goes-here',
		},
		contactSupport: {
			title: 'Contact met support',
			message: 'Bereik ons per e-mail via {email}. Kopieer het onderstaande adres of open je e-mailapp om een bericht te beginnen.',
			copyAddress: 'Adres kopiëren',
			openMailApp: 'E-mailapp openen',
			close: 'Sluiten',
			copied: 'Support-e-mailadres gekopieerd',
			copyFailed: 'Kon niet kopiëren. Kopieer het hierboven getoonde adres handmatig.',
		},
		resubscribe: {
			confirm: 'Wil je je abonnement hervatten?',
			success: 'Je hebt je abonnement succesvol hervat. We moeten de app opnieuw starten om de wijzigingen toe te passen.',
			confirmPaused: 'Je abonnement hervatten? Dit start een nieuwe factureringsperiode en brengt nu je opgeslagen betaalmethode in rekening, tenzij je nog betaalde tijd over hebt.',
		},
		manageSubscription: {
			title: 'Abonnement beheren',
			emailSent: 'We hebben een inloglink naar je e-mail gestuurd. Gebruik deze om toegang te krijgen tot het accountportaal van PayPro Global om je abonnement te beheren, facturen te bekijken en betaalmethoden bij te werken.',
		},
		googlePlayCancel: {
			confirm: 'Je abonnement opzeggen? Je houdt toegang tot het einde van je huidige factureringsperiode.',
			confirmButton: 'Abonnement opzeggen',
			success: 'Je abonnement is opgezegd. Je behoudt toegang tot {date}.',
			error: 'Kon abonnement niet opzeggen. Probeer het opnieuw.',
		},
		paddleStaleState: 'Je abonnement is elders gewijzigd, dus deze actie is niet meer van toepassing. Open deze pagina opnieuw om de huidige status te zien.',
		paddleCancel: {
			confirm: 'Je abonnement opzeggen? Je houdt toegang tot het einde van je huidige factureringsperiode.',
			confirmImmediate: 'Je abonnement opzeggen? Je abonnement is gepauzeerd, dus opzeggen beëindigt het meteen.',
			confirmButton: 'Abonnement opzeggen',
			successImmediate: 'Je abonnement is opgezegd.',
			error: 'Kon abonnement niet opzeggen. Probeer het opnieuw.',
			successScheduled: 'Je abonnement is opgezegd. Je behoudt toegang tot het einde van je huidige factureringsperiode.',
			alreadyScheduled: 'Je abonnement staat al gepland om opgezegd te worden, dus je hoeft verder niets te doen. Je behoudt toegang tot het einde van je huidige factureringsperiode.',
		},
		subscriptionPausesOn: 'Je abonnement wordt gepauzeerd op {date}',
		subscriptionPaused: 'Je abonnement is gepauzeerd. Hervat het wanneer je wilt om je toegang terug te krijgen.',
		appleCancel: {
			confirm: 'Om je abonnement op te zeggen, openen we het abonnementsbeheer van Apple, waar je het kunt opzeggen.',
			confirmButton: 'Abonnement beheren',
			success: 'Als je hebt opgezegd in het abonnementsbeheer van Apple, blijft je toegang behouden tot het einde van je huidige factureringsperiode.',
			error: 'Kon abonnementsbeheer niet openen. Je kunt je abonnement beheren in de Instellingen van je apparaat, onder je Apple-account.',
		},
		appleResume: {
			confirm: 'Om je abonnement te hervatten, openen we het abonnementsbeheer van Apple, waar je automatische verlenging weer kunt inschakelen.',
			confirmButton: 'Abonnement beheren',
			success: 'Als je automatische verlenging weer hebt ingeschakeld in het abonnementsbeheer van Apple, wordt je abonnement automatisch verlengd.',
			error: 'Kon abonnementsbeheer niet openen. Je kunt je abonnement beheren in de Instellingen van je apparaat, onder je Apple-account.',
		},
		subscribedViaOtherPlatform: 'Je abonnement wordt beheerd via {provider}. Open dat platform om je abonnement te beheren.',
		subscribedViaWeb: 'Je lidmaatschap wordt op het web beheerd. Log in op onze website om wijzigingen aan te brengen.',
		webMembershipProblem: 'We konden de gegevens van je abonnement niet laden, dus we kunnen het hier nu niet wijzigen. Je abonnement loopt via onze website — log daar in om het te beheren, of neem contact op met support en we helpen je verder.',
		switchPlan: {
			confirm: 'Wil je je plan wijzigen naar {plan} voor {price}?',
			confirmNoPrice: 'Wil je je plan wijzigen naar {plan}? Het prijsverschil voor de rest van je huidige periode wordt meteen in rekening gebracht of terugbetaald, via je opgeslagen betaalmethode.',
			success: 'Je bent succesvol van plan gewisseld. We moeten de app opnieuw starten om de wijzigingen toe te passen.',
			scheduledConfirm: 'Je plan wisselt naar "{plan}" wanneer je huidige abonnementscyclus eindigt op {date}.',
			error: 'Kon niet van plan wisselen.',
			trialNotSupported: 'Van plan wisselen is beschikbaar nadat je proefperiode eindigt. Je kunt van plan wisselen zodra je eerste betaling is verwerkt, of nu opzeggen en een ander plan aanschaffen wanneer de proefperiode verloopt.',
			grantedPriceWouldBeLost: 'Je hebt een speciale prijs die we met je hebben afgesproken, en die prijs geldt alleen voor je huidige plan. Van plan wisselen zou je terugzetten op de standaardprijs, dus neem contact op met support, dan wisselen wij je om met behoud van je prijs.',
			notYetConfirmed: 'Je planwijziging is doorgevoerd in de winkel. We konden hem zojuist niet helemaal bevestigen, maar hij zou binnen een paar minuten vanzelf moeten worden toegepast. Je hoeft het niet opnieuw te proberen.',
		},
		pendingPlanChange: 'Je plan staat gepland om op {date} te wisselen naar "{plan}".',
		pausesOn: 'Pauzeert op',
	},
	intake: {
		title: {
			updateProgram: 'Trainingsschema bijwerken',
		},
		steps: {
			basicInfo: 'Basisgegevens',
			bodyComposition: 'Lichaamssamenstelling',
			strength: 'Kracht',
			lifestyle: 'Levensstijl',
			advancedTraining: 'Geavanceerde training',
			schedule: 'Schema',
			nutritionOptions: 'Voedingsopties',
			goals: 'Doelen',
			trainingVolume: 'Trainingsvolume',
			energyBalance: 'Energiebalans',
			programOverview: 'Schemaoverzicht',
			firstWorkoutHandoff: 'Aan de slag',
		},
		step: 'Stap {current} van {total}',
		validation: {
			selectOption: 'Selecteer een optie',
			checkInputs: 'Controleer je invoer en zorg dat alle verplichte velden correct zijn ingevuld.',
			gender: 'Geef je geslacht op. Voeding en trainingsplanning worden voor een groot deel bepaald door geslachtskenmerken.',
			age: 'We moeten je leeftijd weten om het programma daarop af te stemmen.',
			ageMinimum: 'Je moet 18 jaar of ouder zijn om deze app te gebruiken.',
			ageTooOld: 'Zo oud kun je onmogelijk zijn.',
			birthdayFuture: 'Oh, hallo, beste bezoeker uit de toekomst. Probeer er nog eens een. :)',
			height: 'Vul je lengte in',
			bodyMeasurements: 'Vinger-, pols- en enkelmaten zijn belangrijk voor verschillende genetische indicatoren. Tik op de infoknop hierboven als je er meer over wilt weten.',
			weight: 'Geef je huidige gewicht op.',
			chooseOption: 'Kies een van de opties.',
			weekdaySelection: 'Kies ja of nee voor elke dag van de week.',
			trainingDaysAtLeastOne: 'Selecteer de dagen waarop je meestal traint.',
			bothTimes: 'Vul beide tijden in. Ze hoeven niet precies te kloppen.',
			unknownField: 'Onbekend veld',
			internalError: 'Interne fout [{code}]',
			strengthTooGoodToBeTrue: 'Dat klinkt te mooi om waar te zijn. Kun je die getallen nog even controleren?',
			strengthTestsNotLoaded: 'Tik op Opnieuw proberen, of tik op Overslaan om verder te gaan zonder krachtcijfers.',
		},
		strength: {
			liftingStatsOptional: 'Krachtcijfers (optioneel)',
			liftingStatsNote1: 'Vul het maximale gewicht x herhalingen in dat je schat momenteel te kunnen tillen, of recente persoonlijke records.',
			liftingStatsNoteHighlight: 'Hoe dichter bij een one-rep max (1RM), hoe beter.',
			liftingStatsNote2: 'Als je geen idee hebt, laat je die oefening leeg.',
			addedWeightOnly: 'Vul alleen het extra gewicht boven je lichaamsgewicht in. Als er geen is, vul dan 0 in.',
			skipExerciseReason: 'Waarom wil je deze oefening overslaan?',
			neverTrained: 'Ik heb dit nog nooit getraind.',
			injuryOrEquipment: 'Ik moet het vermijden vanwege een blessure of gebrek aan uitrusting.',
			skipEstimate: 'Schatting overslaan',
			selectExercisePlaceholder: 'Selecteer oefening',
			loadFailed: 'De krachttests konden niet worden geladen. Controleer je internetverbinding en tik op Opnieuw proberen, of tik op Overslaan om verder te gaan zonder krachtcijfers.',
		},
		nutrition: {
			morningAppetite: 'Ochtendeetlust',
			morningAppetiteQuestion: 'Heb je \'s ochtends van nature honger?',
			mealFrequency: 'Maaltijdfrequentie',
			mealFrequencyDescription: 'Selecteer hoeveel maaltijden je per dag van plan bent te eten. (Tip: voor de beste resultaten eet je op vaste tijden en vermijd je snacken tussen maaltijden door.)',
		},
		nutritionOptions: {
			header: 'Voedingsopties',
			macroTargets: 'Macrodoelen',
			enabled: 'Ingeschakeld',
			enabledNote: 'Ik wil dat de app macro- en caloriedoelen voorschrijft en de doelen bijwerkt op basis van mijn progressie.',
			disabled: 'Uitgeschakeld',
			disabledNote: 'Ik wil niet dat de app mijn macrodoelen bepaalt.',
			macroTracking: 'Macro\'s bijhouden',
			trackInApp: 'In de app bijhouden',
			trackInAppNote: 'Ik houd mijn maaltijden bij in deze app.',
			trackElsewhere: 'Elders bijhouden',
			trackElsewhereNote: 'Ik houd mijn maaltijden bij op papier of in een andere app (of helemaal niet).',
			trackingType: 'Type registratie',
			flexibleNutrition: 'Flexibele voeding',
			flexibleNutritionNote: 'Je werkt met flexibele bereiken voor je macro\'s. De exacte macroverdeling heeft vaak geen grote invloed op je resultaten.',
			fixedTargets: 'Vaste doelen',
			fixedTargetsNote: 'De app stelt exacte macronutriëntdoelen in voor elke maaltijd.',
		},
		goals: {
			physiqueGoal: 'Fysiekdoel',
			physiqueGoalQuestion: 'Wat is je belangrijkste fitnessdoel?',
			bareMinimum: 'Absolute minimum',
			bareMinimumNote: 'Train met minimaal volume om je huidige spiermassa te behouden.',
			balanced: 'Gebalanceerde full-body ontwikkeling',
			balancedNote: 'Dit is onze standaardaanbeveling. Het geldt voor de meeste recreatieve sporters, atleten en bodybuilders.',
			lowerBodyNote: 'Deze optie is populair onder vrouwen die hun onderlichaam willen benadrukken, waaronder Bikini Fitness- en Wellness-atletes.',
			lowerBodyFocus: 'Focus op onderlichaam',
			lowerBodyFocusNote: 'Deze optie is populair onder vrouwen die hun onderlichaam willen benadrukken, waaronder Bikini Fitness- en Wellness-atletes.',
			custom: 'Aangepast',
			customNote: 'Laat mij voor elke spiergroep beslissen hoe ik die aanpas.',
			customizationNote: 'Je kunt je trainingsfocus voor elke spiergroep aanpassen.',
			bodyPartCustomization: 'Lichaamsdeel aanpassen',
			lowerBody: 'Onderlichaam',
			upperBody: 'Bovenlichaam',
			primaryGoal: 'Hoofddoel',
			trainingVolume: 'Trainingsvolume',
			maximize: 'Maximaliseren',
			maintain: 'Behouden',
			shrink: 'Verkleinen',
			decideForMe: 'Beslis voor mij',
			decideForMeDescription: 'Laat de app de beste aanpak bepalen op basis van je huidige situatie',
			fatLoss: 'Vetverlies',
			fatLossDescription: 'Richt je op het verliezen van lichaamsvet terwijl je spiermassa behoudt',
			muscleGrowth: 'Spiergroei',
			muscleGrowthDescription: 'Richt je op het opbouwen van spiermassa',
		},
		training: {
			selectDaysNote: 'Om te beginnen selecteer je de dagen die je gebruikelijke schema weergeven. Je kunt ze later nog verplaatsen als dat nodig is.',
			volumeDescription: 'Dit verwijst naar het totale wekelijkse trainingsvolume voor de spiergroepen die je wilt laten groeien. Spiergroepen die geen prioriteit hebben voor groei krijgen een lager wekelijks volume.',
			currentPlanVolume: 'Huidig schema: {volume} sets/week',
			setsPerWeek: 'Sets per week:',
			recommendSwitchToMuscleGrowth: 'Je lichaamsvet is nu laag genoeg om je op spieropbouw te richten. We raden je aan je doel te wijzigen naar Spiergroei.',
			recommendSwitchToFatLoss: 'Je lichaamsvet is nu zo hoog dat vet verliezen voorop moet staan. We raden je aan je doel te wijzigen naar Vetverlies.',
			slowAndSteady: 'Rustig en gestaag',
			slowAndSteadyDescription: 'Volhoudbaarheid is voor mij het belangrijkst. Zolang ik de goede kant op ga, maakt het tempo van vooruitgang me niet uit.',
			balanced: 'Gebalanceerd',
			balancedDescription: 'Ik wil een redelijke balans vinden tussen goede resultaten in verhouding tot de inspanning en volhoudbaarheid.',
			maximumEffort: 'Maximale inzet',
			maximumEffortDescription: 'Ik doe wat er nodig is om maximale resultaten te behalen (zonder mijn gezondheid in gevaar te brengen).',
			overreachingWarning: 'Waarschuwing: slechte risico-batenverhouding bij zulke hoge volumes. Er is een groot risico op overbelasting en blessures voor relatief weinig extra vooruitgang.',
			calorie: 'Calorie',
			calorieDeficit: 'Calorietekort:',
			calorieSurplus: 'Caloriesurplus:',
		},
		advancedLabels: {
			progressionTesting: 'Progressietest',
			slot: 'Slot',
			sets: 'Sets',
			level: 'Niveau',
			otherSlotsLevel: 'Niveau andere slots',
			intensityPeriodization: 'Intensiteit/periodisering',
			slotIntensitiesJSON: 'Slot Intensities JSON',
		},
		labels: {
			gender: 'Geslacht',
			male: 'Man',
			female: 'Vrouw',
			birthdate: 'Geboortedatum',
			height: 'Lengte',
			weight: 'Gewicht',
			bodyfat: 'Lichaamsvetpercentage',
		},
		alerts: {
			progressSaved: 'Je voortgang wordt onderweg opgeslagen. Je kunt het formulier op elk moment verlaten en later hervatten.',
			recalculateNeeded: 'Je hebt wijzigingen gemaakt die andere instellingen beïnvloeden. Je moet opnieuw berekenen voordat je bepaalde tabbladen kunt openen en je programma kunt bijwerken.',
		},
		updateOptions: {
			title: 'Werk je programma bij',
			intro: 'Je hebt een paar instellingen gewijzigd. Kies wat je wilt bijwerken.',
			workoutsTitle: 'Je trainingen',
			workoutsRebuild: 'Mijn programma opnieuw opbouwen',
			workoutsRebuildNote: 'Bouwt nieuwe trainingen op basis van je nieuwe instellingen.',
			workoutsRebuildNoteWithCustomizations: 'Bouwt nieuwe trainingen op basis van je nieuwe instellingen. Oefeningen die je zelf hebt gewisseld worden vervangen.',
			workoutsVolumesOnly: 'Alleen mijn aantal sets bijwerken',
			workoutsVolumesOnlyNote: 'Houdt je oefeningen. Past aan hoeveel sets je van elke oefening doet.',
			workoutsKeep: 'Mijn huidige trainingen behouden',
			workoutsKeepNote: 'Er verandert niets aan je training.',
			nutritionTitle: 'Je voeding',
			nutritionUpdate: 'Mijn caloriedoel bijwerken',
			nutritionUpdateNote: 'Berekent je dagelijkse calorieën opnieuw op basis van je nieuwe instellingen.',
			nutritionKeep: 'Mijn caloriedoel behouden',
			nutritionKeepNote: 'Je dagelijkse calorieën blijven op {target}.',
			nutritionKeepNoteNoTarget: 'Je dagelijkse calorieën blijven zoals ze zijn.',
			warnKeepEnergyBalance: 'Je nieuwe tekort of surplus verandert je dagelijkse calorieën niet, omdat je je huidige doel behoudt.',
			warnKeepGoal: 'Je hebt je doel gewijzigd. Als je je caloriedoel behoudt, blijf je eten wat voor je vorige doel was berekend.',
			warnKeepBodyData: 'Je caloriedoel blijft berekend met je vorige gewicht en lichaamsvet.',
			scrollToMessages: 'Scroll omlaag om te lezen wat er verandert',
			warnKeepActivityLevel: 'Je hebt gewijzigd hoe actief je bent, maar als je je doel behoudt blijven je dagelijkse calorieën berekend voor je vorige activiteitsniveau.',
			warnUpdateReplacesTarget: 'Je doel van {target} wordt vervangen door {recommended}. Je kunt het opnieuw instellen op het scherm met je dagelijkse voedingsdoel.',
			warnUpdateReplacesTargetUnknown: 'Je doel van {target} wordt vervangen door een nieuw berekend doel. Je kunt het opnieuw instellen op het scherm met je dagelijkse voedingsdoel.',
		},
		buttons: {
			next: 'Volgende',
			back: 'Terug',
			skip: 'Overslaan',
			saveAndUpdate: 'Opslaan en bijwerken',
			recalculate: 'Opnieuw berekenen',
		},
		lifestyle: {
			activityLevel: 'Activiteitsniveau, inclusief cardio en sport',
			sedentary: 'Zittend',
			sedentaryNote: 'Voorbeeld: je hebt een kantoorbaan met gewone dagelijkse taken.',
			somewhatActive: 'Enigszins actief',
			somewhatActiveNote: 'Voorbeeld: je hebt een lange woon-werkreis per fiets, of gaat af en toe joggen of doet wat sport, maar bent verder grotendeels zittend.',
			active: 'Actief',
			activeNote: 'Voorbeeld: je bent fulltime personal trainer, letterlijk het grootste deel van de dag op de been, of je doet veel sport naast krachttraining.',
			veryActive: 'Zeer actief',
			veryActiveNote: 'Voorbeeld: je hebt een baan met lichamelijk werk en/of doet veel fysiek veeleisende activiteiten naast krachttraining.',
			stressLevel: 'Stressniveau',
			mildStress: 'Slechts af en toe/milde stress',
			mildStressNote: 'Voorbeeld: student buiten de tentamenperiode.',
			averageStress: 'Gemiddelde stress',
			averageStressNote: 'Voorbeeld: fulltime werk met deadlines en woon-werkverkeer.',
			highStress: 'Hoge stress',
			highStressNote: 'Voorbeeld: zeer hectische werkomgeving met veel verantwoordelijkheid.',
		},
		advanced: {
			myoReps: 'Myo-reps',
			myoRepsPrefer: 'Voorkeur (tijdbesparend)',
			myoRepsPreferNote: 'Je trainingen zijn zo kort mogelijk, rekening houdend met je doelen en persoonlijke progressie. Dit omvat het gebruik van myo-reps wanneer dat gerechtvaardigd is.',
			myoRepsAvoid: 'Vermijden (klassieke training)',
			myoRepsAvoidNote: 'Gebruik alleen klassieke straight sets voor alle oefeningen. Myo-reps worden niet automatisch toegepast. Je kunt ze echter altijd later inschakelen voor geschikte oefeningen.',
			automatic: 'Automatisch',
			myoRepsAutomaticNote: 'Myo-reps worden voor je toegepast wanneer ze specifiek voordelig zijn.',
			rmTesting: 'Spierspecifieke hypertrofiemethode (RM-testen)',
			rmTestingPrefer: 'Voorkeur',
			rmTestingPreferNote: 'Je voert voor de meeste oefeningen een krachttest uit, en samen bepalen we je persoonlijke doelherhalingen.',
			rmTestingAvoid: 'Vermijden',
			rmTestingAvoidNote: 'We geven je een herhalingsdoel voor elke oefening, en je vindt het juiste gewicht tijdens je eerste trainingen. Je kunt later alsnog geautoreguleerde doelherhalingen inschakelen.',
			calorieCycling: 'Caloriecycling',
			calorieCyclingOn: 'Aan',
			calorieCyclingOnNote: 'Voor gevorderde sporters die zeer bekend zijn met het bijhouden van hun macro\'s, kan de app meer voedingsstoffen verdelen over je anabole vensters (de maaltijden na je trainingen) en minder voedingsstoffen buiten de anabole vensters. Volgens sommig onderzoek verbetert dit de nutriëntenverdeling - de verhouding van spier tot vet die je aankomt.',
			calorieCyclingOff: 'Uit (eenvoudiger)',
			calorieCyclingOffNote: 'Dit verdeelt je macro\'s gelijkmatig over de week zonder nutriënttiming, in if-it-fits-your-macros-stijl.',
			myoRepsTooltip: 'Een tijdbesparende techniek met een activatieset gevolgd door korte rust-pauze mini-sets om de spierstimulus te maximaliseren.',
			rmTestingTooltip: 'Krachttests om je doelherhalingen te autoreguleren (ideaal voor gevorderde sporters).',
			calorieCyclingTooltip: 'Verdeelt meer voedingsstoffen rond je trainingen en minder daarbuiten om de nutriëntenverdeling te verbeteren.',
		},
		schedule: {
			trainingFrequency: 'Trainingsfrequentie',
			daysPerWeek: 'Dagen per week:',
			mealsPerDay: 'Maaltijden per dag:',
			hoursPerNight: 'Uren per nacht:',
			sleep: 'Slaap',
			sleepDescription: 'Hoeveel uur slaap krijg je gemiddeld per nacht? Wees realistisch!',
		},
		firstWorkout: {
			heading: 'Je schema is klaar.',
			subheading: 'Dit gebeurt er nu:',
			step1: 'Een korte krachttest bepaalt je startgewichten.',
			step2: 'Vervolgens werkt de app je training en voeding elke week bij, op basis van hoe je presteert.',
			startButton: 'Start je eerste training',
			finishLaterButton: 'Afronden, ik begin later',
		},
		planOverview: {
			successAlert: 'Je gepersonaliseerde programma is klaar, geoptimaliseerd voor je trainings- en voedingsdoelen.',
			keepingProgramAlert: 'Je huidige trainingsprogramma blijft ongewijzigd. Je andere instellingen zijn bijgewerkt.',
			nutritionPlan: 'Voedingsschema',
			nutritionGoal: 'Je primaire doel is momenteel ingesteld op',
			nutritionGoalSuffix: 'De volgende voedingsdoelen zijn ontworpen om je dat doel te helpen bereiken:',
			dailyAverageCalories: 'Dagelijks gemiddelde calorieën',
			dailyAverageTooltip: 'Je gemiddelde calorie-inname over meerdere dagen, geen dagelijks doel.',
			mealCalories: 'Maaltijdcalorieën',
			mealCaloriesTooltip: 'Doelcalorieën per gemiddelde maaltijd. Weektotalen zijn belangrijker dan nauwkeurigheid per maaltijd.',
			cutMealCalories: 'Cut-maaltijdcalorieën',
			cutMealTooltip: 'Doelcalorieën voor maaltijden buiten je anabole venster.',
			bulkMealCalories: 'Bulk-maaltijdcalorieën',
			bulkMealTooltip: 'Doelcalorieën voor maaltijden na krachttraining.',
			macroTabs: {
				day: 'Dag',
				bulkMeal: 'Bulk-maaltijd',
				cutMeal: 'Cut-maaltijd',
				perDay: 'Per dag',
				perMeal: 'Per maaltijd',
			},
			macroTitles: {
				estimatedDailyAverage: 'Geschatte dagelijkse gemiddelde macro\'s',
				bulkMeal: 'Bulk-maaltijd macro\'s',
				cutMeal: 'Cut-maaltijd macro\'s',
				daily: 'Dagelijkse macro\'s',
				meal: 'Maaltijdmacro\'s',
			},
			macroMin: '(min)',
			macroMax: '(max)',
			protein: 'Eiwit',
			carbs: 'Koolhydraten',
			fat: 'Vet',
			fiber: 'Vezels',
			workouts: 'Trainingen ({count})',
			workoutsDescription: 'De volgende trainingen zijn voor je ontworpen, je doorloopt ze elke week afwisselend.',
			learnMoreProgramming: 'Meer lezen over de redenering achter de programmering',
			edit: 'Bewerken',
			gainWeightQuicker: 'Bij hogere percentages kom je sneller aan, maar te hoog gaan betekent dat je vet aankomt.',
			loseWeightQuicker: 'Bij hogere percentages val je sneller af, maar te snel afvallen brengt het risico op spierverlies met zich mee.',
			currentPlan: 'Huidig schema: {percent}%',
			muscleLossWarning: 'Verlies van spiermassa is waarschijnlijk bij je huidige keuze.',
			fatGainWarning: 'Overmatige vettoename is waarschijnlijk bij je huidige keuze.',
		},
		dedication: {
			slowAndSteady: 'Rustig en gestaag',
			slowAndSteadyNote: 'Volhoudbaarheid is voor mij het belangrijkst. Zolang ik de goede kant op ga, maakt het tempo van vooruitgang me niet uit.',
			balanced: 'Gebalanceerd',
			balancedNote: 'Ik wil een redelijke balans vinden tussen goede resultaten in verhouding tot de inspanning en volhoudbaarheid.',
			maximumEffort: 'Maximale inzet',
			maximumEffortNote: 'Ik doe wat er nodig is om maximale resultaten te behalen (zonder mijn gezondheid in gevaar te brengen).',
		},
		trainingSplit: {
			title: 'Trainingsindeling',
			optimal: 'Optimaal',
			optimalNote: 'De app optimaliseert je trainingsfrequentie per spiergroep, zonder beperkt te worden door een vast schema.',
			pushPullLegs: 'Push / Pull / Benen',
			pushPullLegsNote: 'Je wisselt af tussen trainingen met push-oefeningen, dan pull-oefeningen en dan het onderlichaam.',
			upperLower: 'Boven / Onder',
			upperLowerNote: 'Je wisselt af tussen trainingen voor het bovenlichaam en voor het onderlichaam.',
			fullBody: 'Full body',
			fullBodyNote: 'Je traint elke grote spiergroep in elke training.',
			availableAtFrequency: 'Beschikbaar vanaf {minimum} trainingen per week',
		},
		testMode: {
			options: 'Testmodus-opties',
			novice: 'Beginner',
			intermediate: 'Gemiddeld',
			advanced: 'Gevorderd',
			initial: 'Initieel',
		},
		loading: {
			analyzingFitness: 'Fitnessdoelen en -niveau analyseren.\nDit kan een minuut of twee duren.',
			generatingProgram: 'Aangepast trainingsprogramma genereren.\nDit kan een minuut of twee duren.',
			finishingPlan: 'Je schema en planning afronden...',
		},
		errors: {
			internalError: 'Interne fout [{code}]. Vernieuw de pagina en probeer het opnieuw.',
			couldntGeneratePlan: 'Kon geen fitnessschema genereren.',
			subscriptionRequired: 'Je abonnement is niet actief, mogelijk omdat de betaling niet is gelukt. Probeer opnieuw een abonnement af te sluiten om door te gaan.',
		},
		notes: {
			bodyfatEstimate: 'Wat is de beste schatting van je lichaamsvetpercentage die je kunt maken?',
			immutableStats: 'De informatie in dit gedeelte kan niet meer worden bewerkt zodra je het intakeformulier hebt voltooid. Als je deze informatie later wilt wijzigen, moet je je gegevens wissen en je account opnieuw aanmaken in Instellingen.',
		},
	},
	fatalError: {
		title: {
			whoops: 'Oeps...',
			testError: 'Test fatale fout',
			storageNotResponding: 'De opslag van je apparaat reageert niet',
		},
		messages: {
			cantAccessData: 'Kan geen toegang krijgen tot lokale offline gegevens.',
			testError: 'Er is een test fatale fout opgetreden.',
			appFailedToStart: 'App kon niet starten.',
			lockdownMode: 'Op je apparaat is de lockdownmodus ingeschakeld.',
			serverError: 'Kan geen verbinding maken met de server.',
			localStorageWedged: 'De app kan de offline kopie van je gegevens op dit apparaat niet bereiken. Je account en alles wat al gesynchroniseerd is, staan veilig op onze servers.',
			resetLocalDataOffer: 'Helpt dat niet, dan kun je op dit apparaat helemaal opnieuw beginnen. Alles wat al gesynchroniseerd is, wordt opnieuw gedownload; wat je op dit apparaat hebt vastgelegd en nog niet gesynchroniseerd was, gaat verloren.',
		},
		help: {
			tryAgainLater: 'Probeer het later opnieuw.',
			retryOrLogout: 'Als opnieuw proberen niet helpt, probeer dan uit te loggen en weer in te loggen.',
			testError: 'Even testen, negeer dit.',
			retryOrRelogin: 'Probeer het opnieuw, of probeer uit te loggen en weer in te loggen.',
			disableLockdown: 'Schakel de lockdownmodus op je apparaat uit en probeer het opnieuw, of neem contact op met support als het probleem daarna blijft bestaan.',
			storageForceQuitIos: 'Het tabblad sluiten helpt niet. Sluit de app helemaal af (veeg hem weg uit het overzicht van geopende apps) en open hem opnieuw.',
			storageRestartApp: 'Sluit de app helemaal af en open hem opnieuw.',
			storageRestartBrowser: 'Sluit je browser af en open hem opnieuw. Open daarna de app opnieuw.',
		},
		buttons: {
			retry: 'Opnieuw proberen',
			logout: 'Uitloggen',
			resetLocalData: 'Opnieuw beginnen op dit apparaat',
		},
		support: {
			prefix: 'Als het bovenstaande niet helpt en het probleem blijft bestaan, neem dan contact op met',
		},
		alerts: {
			resetLocalDataTitle: 'Opnieuw beginnen op dit apparaat?',
			resetLocalDataMessage: 'Je account is veilig en alles wat al gesynchroniseerd is, wordt opnieuw gedownload. Wat je op dit apparaat hebt vastgelegd en nog niet gesynchroniseerd was, gaat verloren.',
		},
	},
	calorieChange: {
		decrease: 'Verlagen',
		increase: 'Verhogen',
		self: {
			less: '{percent}% minder dan de {base} kcal die je opgaf is {kcal} kcal.',
			more: '{percent}% meer dan de {base} kcal die je opgaf is {kcal} kcal.',
			same: 'Gelijk aan de {base} kcal die je opgaf.',
		},
		coach: {
			less: '{percent}% minder dan de opgegeven {base} kcal is {kcal} kcal.',
			more: '{percent}% meer dan de opgegeven {base} kcal is {kcal} kcal.',
			same: 'Gelijk aan de opgegeven {base} kcal.',
		},
		belowMinimum: '{kcal} kcal ligt onder {minimum} kcal, het laagste doel dat de app zou instellen. Je getal wordt gebruikt zoals je het hebt ingevuld. De app kan het verhogen naar {minimum} kcal wanneer het plan opnieuw wordt berekend.',
	},
	nextIntake: {
		title: 'Inname volgende week',
		now: 'Nu {kcal} kcal/dag',
		sourceLogged: 'Gemiddelde dagelijkse inname vorige week (gelogd)',
		sourceTargetSelf: 'Je caloriedoel, opgegeven als inname van vorige week',
		sourceTargetCoach: 'Hun caloriedoel, opgegeven als inname van vorige week',
		sourceCustom: 'Zelf ingevuld als inname van vorige week',
		recommendedChange: 'Aanbevolen: {change} kcal/dag ({percent}%) → {kcal} kcal/dag',
		recommendedChangeNoPercent: 'Aanbevolen: {change} kcal/dag → {kcal} kcal/dag',
		recommendedKeep: 'Aanbevolen: {kcal} kcal/dag aanhouden',
	},
	bodyCompOverview: {
		progressCheck: 'Voortgangscheck',
		statusOnTrack: 'Op schema',
		statusOffTrack: 'Niet op schema',
		statusUndetermined: 'Nog geen oordeel',
		statusInfoHome: {
			onTrack: 'Beoordeeld op de laatste 14 dagen: je voortgang past bij je doel, dus je plan hoeft niet te veranderen.',
			offTrack: 'Beoordeeld op de laatste 14 dagen: je voortgang past niet bij je doel, dus je plan moet veranderen.',
			undetermined: 'De app kan de laatste 14 dagen nog niet beoordelen, bijvoorbeeld na een planwijziging of met te weinig metingen.',
		},
		statusInfoCheckup: {
			onTrack: 'Beoordeeld op de 14 dagen voor deze check-up: je plan hoefde niet te veranderen.',
			offTrack: 'Beoordeeld op de 14 dagen voor deze check-up: je plan moest veranderen.',
			undetermined: 'Deze check-up kon de 14 dagen ervoor niet beoordelen, bijvoorbeeld na een planwijziging of met te weinig metingen.',
		},
		fatTrendDown: 'Je lichaamsvet daalt',
		fatTrendUp: 'Je lichaamsvet stijgt',
		fatTrendUnclear: 'Je lichaamsvet heeft geen duidelijke richting',
		notEnoughFatReadings: 'Te weinig huidplooi- of taillemetingen voor een trend',
		notEnoughWeighIns: 'Te weinig wegingen voor een trend',
		readFromSkinfolds: 'afgelezen aan je huidplooien',
		readFromWaist: 'afgelezen aan je taille',
		trendWithSource: '{trend}, {source}.',
		skinfoldsWord: 'huidplooien',
		waistWord: 'taille',
		perWeek: '{value} {unit}/wk',
		ofBodyWeightPerWeek: 'van lichaamsgewicht per week',
		ofBodyWeightGainedPerWeek: 'van lichaamsgewicht aangekomen per week',
		ofBodyWeightLostPerWeek: 'van lichaamsgewicht verloren per week',
		countedFrom: 'De check telde metingen vanaf {date}.',
		judgedOnLast14Days: 'Het oordeel is gebaseerd op de laatste 14 dagen. Deze kaart toont de trend over de periode die je hebt gekozen.',
		periodTrendOnly: 'Trend over de periode die je hebt gekozen.',
		storedAtCheckup: 'Zoals beoordeeld toen deze check-up werd afgerond.',
		weightResponse: 'Gewichtsreactie',
		atKcal: 'Bij {kcal} kcal/dag',
		baselineLogged: 'Gelogd gemiddelde',
		baselineTarget: 'Caloriedoel',
		baselineCustom: 'Zelf ingevuld',
		intakeReportedOn: '{how}, opgegeven bij de check-up van {date}.',
		fillsAfterFirstCheckup: 'Wordt ingevuld na je eerste wekelijkse check-up.',
		weightNow: 'Laatste weging {value} {unit}',
		energyIntake: 'Energie-inname',
		avgKcalPerDay: 'gem. {kcal} kcal/dag',
		daysCounted: '{counted} van {total} dagen',
		checkupWeek: 'Check-upweek {from} - {to}',
		legendLogged: 'Gelogde calorieën',
		legendTarget: 'Doelcalorieën',
		mean: 'Gemiddelde',
		valueWithUnit: '{value} {unit}',
		readingsInRange: '{count} metingen in deze periode',
		adherence: 'Naleving',
		adherenceCalories: 'Calorieën',
		adherenceTrainingDays: 'Trainingsdagen',
		adherenceDaysLogged: 'Dagen gelogd',
		ofTargetKcal: '/ {target} kcal',
		percentOfTarget: '{percent}% van doel',
		kcalPerDay: 'kcal/dag',
		ofTotal: 'van {total}',
		noWorkoutsPlanned: 'Die week waren er geen trainingen gepland.',
		noWeighIns: 'Geen wegingen in deze periode.',
		noFatReadings: 'Nog geen huidplooi- of taillemetingen.',
		loadFailed: 'Het overzicht kon niet worden geladen.',
		retry: 'Opnieuw proberen',
	},
	trainingOverview: {
		title: 'Trainingsoverzicht',
		notAvailable: 'Deze pagina is niet beschikbaar.',
		deletedExercise: 'Verwijderde oefening',
		otherSessions: 'Andere sessies',
		noLongerInWorkout: 'Niet meer in deze training',
		columnExercise: 'Oefening',
		columnSets: 'Sets',
		columnLastSession: 'Laatste sessie',
		showingSessions: '{shown} van {total} {{sessie|sessies}} getoond',
		showEarlier: 'Eerdere Tonen',
		showLater: 'Latere Tonen',
		phoneNote: 'Laatste sessie {date} · tik op een oefening voor de geschiedenis',
		skipped: 'overgeslagen',
		noWorkouts: 'Geen gelogde trainingen in de laatste {weeks} weken.',
		noSessions: 'Nog geen sessies.',
		olderDownloading: 'Oudere trainingen worden nog gedownload.',
		loadFailed: 'Het trainingsoverzicht kon niet worden geladen.',
		retry: 'Opnieuw proberen',
		marks: {
			same: 'Gelijk',
			down: 'Lager',
		},
		markInfo: {
			same: 'Hetzelfde gewicht en dezelfde herhalingen in de eerste set als de vorige keer',
			down: 'Minder gewicht, of hetzelfde gewicht met minder herhalingen, in de eerste set dan de vorige keer',
		},
		tags: {
			heavy: 'Zwaar',
			medium: 'Gemiddeld',
			light: 'Licht',
			test: 'Test',
			deload: 'Deload',
			break: 'Pauze',
			cap: 'Begrensd',
		},
		tagInfo: {
			heavy: 'Zware dag',
			medium: 'Gemiddelde dag',
			light: 'Lichte dag',
			test: 'Kracht- of herhalingstest',
			deload: 'Lichter na een deload',
			break: 'Lichter na een trainingspauze',
			cap: 'De app hield het gewicht op wat je nu aankunt',
		},
		menu: {
			exerciseSettings: 'Oefeninginstellingen',
			history: 'Geschiedenis',
			editWorkouts: 'Trainingen bewerken',
		},
		programChanged: 'Het schema is gewijzigd terwijl je aan het bewerken was. Er is niets opgeslagen.',
		saveFailed: 'De oefeninginstellingen konden niet worden opgeslagen. Probeer het opnieuw.',
		openOverview: 'Trainingsoverzicht openen',
		upToToday: 'Training tot en met vandaag',
		tabTraining: 'Training',
		checkupCount: '{same} gelijk, {down} lager',
	},
	dateRange: {
		week: 'Week',
		month: 'Maand',
		quarter: 'Kwartaal',
		year: 'Jaar',
		all: 'Alles',
		twoWeeks: '2 wk',
		fourWeeks: '4 wk',
		eightWeeks: '8 wk',
		twelveWeeks: '12 wk',
	},
	dayItems: {
		titles: {
			weighIn: 'Weging',
			weeklyCheckup: 'Wekelijkse controle',
			wakeUp: 'Opstaan',
			sleep: 'Slaap',
			restDay: 'Rustdag',
			meal: 'Maaltijd {number}',
			workout: 'Training',
			workoutNamed: 'Training {name}',
		},
		text: {
			reviewYourWeek: 'Bekijk je week',
		},
		alerts: {
			rescheduleWorkout: 'Je hebt momenteel geen geplande training voor morgen. Wil je deze training naar morgen verplaatsen?',
		},
		warnings: {
			daysSinceLastWeighIn: 'Het is {days} {{dag|dagen}} geleden sinds je laatste weging.',
			weeksSinceLastWeighIn: 'Het is {weeks} {{week|weken}} geleden sinds je laatste weging.',
			longTimeSinceLastWeighIn: 'Het is lang geleden sinds je laatste weging.',
			logWeightLink: 'Gewicht loggen',
			planUpdateNeeded: 'Je voortgang geeft aan dat je trainingsprogramma moet worden bijgewerkt om aan te sluiten bij je huidige niveau.',
			updateProgramLink: 'Programma bijwerken',
			pendingWorkout: 'Je hebt een onafgemaakte training van',
			unfinishedWeeklyCheckup: 'Je hebt een onafgemaakte wekelijkse controle van',
			firstWorkoutReminder: 'Je eerste training is op {day}. Vergeet niet om weer in te loggen!',
			coachLapseManageInApp: 'Abonnement Beheren',
			coachLapseManageInStore: 'Werk dit abonnement bij in de abonnementsinstellingen van je appstore om het actief te houden.',
			coachPaymentFailedTitle: 'Je coachbetaling is niet gelukt',
			coachPaymentFailed: 'We konden je coachabonnement niet innen. We blijven het proberen, maar als het niet lukt, eindigt je toegang op {date}.',
			coachPaymentFailedNoDate: 'We konden je coachabonnement niet innen. We blijven het proberen, maar als het niet lukt, verlies je je toegang.',
			coachNotRenewingTitle: 'Je coachabonnement wordt niet verlengd',
			coachNotRenewing: 'Je coachabonnement staat niet meer ingesteld op verlengen. Je houdt toegang tot {date}.',
			coachNotRenewingNoDate: 'Je coachabonnement staat niet meer ingesteld op verlengen.',
			coachPlanStoppedTitle: 'Je coachabonnement is niet actief',
			coachPlanStopped: 'Je coachabonnement is niet actief. Er is niets verwijderd — alles komt terug zodra het abonnement weer actief is.',
			coachClientsWillLoseAccess: 'Dit raakt ook {count} van je cliënten, die de Premium-toegang die het dekt verlie{{st|zen}}.',
			coachClientsLostAccess: 'Dit raakt ook {count} van je cliënten, die geen Premium-toegang meer via jou {{heeft|hebben}}.',
			memberPaymentFailedTitle: 'Je laatste betaling is niet gelukt',
			memberPaymentFailed: 'We konden je betaling niet verwerken. We blijven het proberen en je abonnement blijft ondertussen actief. Als de betaling blijft mislukken, stopt je abonnement op {date}.',
			memberPaymentFailedNoDate: 'We konden je betaling niet verwerken. We blijven het proberen en je abonnement blijft ondertussen actief. Als de betaling blijft mislukken, stopt je abonnement.',
			memberPaymentFailedViewMembership: 'Abonnement Bekijken',
		},
		success: {
			weightChange: 'Je geschatte gewichtsverandering is {direction} {amount}{unit} / week.',
			viewProgress: 'Voortgang bekijken',
		},
		info: {
			notEnoughWeightData: 'We hebben nog een paar wegingen nodig om je wekelijkse trend te schatten.',
		},
		badges: {
			mealPlanner: 'Maaltijdplanner',
			mealPlannerInfo: 'Deze maaltijd is gegenereerd met de Maaltijdplanner, ontworpen om aan te sluiten bij je macrodoelen. De voedingsstoffen liggen dicht bij je doelen, al zorgen kleine variaties voor flexibiliteit en variatie in voeding.',
			macrosMatch: 'Op schema',
			macrosMatchInfo: 'De macro\'s van deze maaltijd liggen binnen 5% van je doelen. Goed gedaan!',
		},
		buttons: {
			logMacrosManually: 'Macro\'s handmatig loggen',
			reschedule: 'Opnieuw plannen',
			markAsComplete: 'Markeer klaar',
			addFood: 'Voeding toevoegen',
			logWeight: 'Gewicht loggen',
			resume: 'Hervatten',
			start: 'Starten',
			done: 'Klaar',
		},
		skippedWorkout: {
			message: 'Training verplaatst naar {date}.',
			moveToToday: 'Naar vandaag verplaatsen',
			moveToTodayButton: 'Naar vandaag verplaatsen',
			restore: 'Herstellen',
		},
		noWorkout: {
			nextWorkout: 'Volgende training is op {day}.',
			message: 'Train vandaag als je wilt.',
		},
	},
	unsavedChanges: {
		title: 'Wijzigingen toepassen?',
		alerts: {
			incompleteData: 'De gegevens zijn onvolledig en kunnen niet worden opgeslagen. Wat wil je doen?',
			applyChanges: 'Je hebt niet-opgeslagen wijzigingen. Wil je die toepassen voordat je weggaat?',
		},
		errors: {
			saveFailed: 'Je wijzigingen konden niet worden opgeslagen. Je werk staat er nog - probeer het opnieuw.',
		},
		buttons: {
			keepEditing: 'Verder bewerken',
		},
		discard: {
			feedbackTitle: 'Je feedback weggooien?',
			feedbackMessage: 'Je hebt dit nog niet verstuurd. Als je nu weggaat, is wat je hebt geschreven weg.',
			coachMessageTitle: 'Je bericht weggooien?',
			coachMessageMessage: 'Je hebt dit nog niet verstuurd. Als je nu weggaat, is wat je hebt geschreven weg.',
			noteTitle: 'Je notitie weggooien?',
			noteMessage: 'Je hebt deze notitie nog niet opgeslagen. Als je nu weggaat, is wat je hebt geschreven weg.',
			brandingTitle: 'Je merkwijzigingen weggooien?',
			brandingMessage: 'Je hebt deze nog niet opgeslagen. Als je nu weggaat, worden je logo, kleur en naam weer wat ze waren.',
			checkupTitle: 'Wekelijkse check-up verlaten?',
			checkupMessage: 'Je bent nog niet klaar. Als je nu weggaat, zijn de antwoorden die je hebt ingevuld weg.',
			coachTargetTitle: 'Je caloriedoel weggooien?',
			coachTargetMessage: 'Je hebt het nog niet toegepast. Als je nu weggaat, is het getal dat je hebt ingevuld weg.',
			nutritionPlanTitle: 'Je calorie- en macrowijzigingen weggooien?',
			nutritionPlanMessage: 'Je hebt ze nog niet opgeslagen. Als je nu weggaat, worden de waarden weer wat ze waren.',
			ingredientTitle: 'Je wijzigingen aan dit ingrediënt weggooien?',
			ingredientMessage: 'Je hebt ze nog niet opgeslagen. Als je nu weggaat, wordt de hoeveelheid weer wat die was.',
		},
	},
	training: {
		startWorkout: 'Training starten',
		resumeWorkout: 'Training hervatten',
		openWorkout: 'Training openen',
		skipWorkout: 'Vandaag overslaan',
		editWorkout: 'Training {letter} bewerken',
		editWorkoutShort: 'Training bewerken',
		changeWorkout: {
			title: 'Andere training',
			description: 'Kies welke training je op deze datum wilt uitvoeren.',
			menuOption: 'Andere training',
		},
		workoutChangedInfo: 'Deze wijziging wordt pas opgeslagen wanneer je de training start en minstens één set voltooit. Anders wordt hij teruggezet nadat je de app hebt vernieuwd.',
		noWorkout: 'Geen training gepland voor deze dag',
		noWorkoutScheduled: 'Geen training gepland',
		nextWorkoutOn: 'Je volgende training is op {day}.',
		trainAnyway: 'Wil je vandaag toch trainen?',
		trainToday: 'Vandaag trainen',
		workout: 'Training',
		trainingProgram: {
			muscleVolume: 'Spiervolume',
			workoutLetter: 'Training {letter}',
			sets: 'Sets',
			myoReps: 'Myo-reps',
			rmTesting: 'RM-testen',
			set: 'Set',
			notCountedTitle: 'Nog niet meegeteld',
			notCountedExplanation: 'Voor deze oefeningen is geen "Meest vergelijkbare oefening" ingesteld, dus we kunnen niet bepalen welke spieren ze trainen. Tik op een oefening om dit in te stellen en hem mee te tellen in het volume hierboven.',
			notCountedUntrackedTitle: 'Niet gemeten in dit schema',
			notCountedUntrackedExplanation: 'Deze oefeningen trainen een lichaamsdeel dat dit trainingsschema niet meet, dus ze kunnen niet bij de totalen hierboven worden opgeteld. Je doet en logt ze gewoon zoals altijd.',
			notCountedSummary: '{count} niet meegeteld',
		},
		goals: {
			muscleGrowth: 'Spiergroei',
			bodyRecomposition: 'Lichaamsrecompositie',
		},
		emptyProgramDay: {
			message: 'Deze training heeft nog geen oefeningen.',
			editLink: 'Oefeningen toevoegen',
		},
	},
	schedule: {
		warnings: {
			mealBeforeWorkout: 'Je kunt nuchter trainen, maar we raden aan om minstens één maaltijd voor de training te eten.',
			mealAfterWorkout: 'Minstens één maaltijd na een training helpt om de spiergroei te maximaliseren.',
			minTimeBetweenMeals: 'Als er minder dan 3 uur tussen twee maaltijden zit, kun je overwegen ze samen te voegen tot één.',
			oneMealCloseToWo: 'Een maaltijd binnen 1 uur voor of na de training is nuttig.',
			prePostWoMealDistance: 'We raden aan om je training tussen twee maaltijden te plaatsen, met niet meer dan 5 uur tussen die maaltijden.',
			shortFeedingWindow: 'Intermittent fasting is prima, maar we raden aan om je totale dagelijkse eetvenster (de tijd tussen de eerste en de laatste maaltijd) minstens 8 uur lang te houden.',
			workoutTimingIrregular: 'Train wanneer je kunt, maar we raden aan om elke (trainings)dag rond ongeveer dezelfde tijd te trainen.',
			mealTimingIrregular: 'Je kunt eten wanneer je wilt, maar we raden aan om elke dag rond ongeveer dezelfde tijden te eten.',
			sleepTimingIrregular: 'Als je kunt, raden we aan om elke dag rond ongeveer dezelfde tijden te gaan slapen en op te staan.',
			shortSleep: 'Als je meer kunt slapen, doe dat dan waarschijnlijk. Minstens 8 uur per nacht wordt sterk aanbevolen.',
		},
		tips: 'Planningstips',
	},
	editFood: {
		labelScanLowConfidence: 'Lage betrouwbaarheid — controleer de voedingsstoffen handmatig',
		labelScanJsonRepaired: 'AI-antwoord werd afgekapt — sommige voedingsstoffen ontbreken mogelijk',
		placeholders: {
			enterName: 'Naam invoeren',
		},
		labels: {
			servingSize: 'Portiegrootte',
			servingSizes: 'Maten',
			measureName: 'Naam van de maat',
			valuesPer: 'Per',
			instructions: 'Bereidingswijze',
			labelStyle: 'Labelstijl',
			details: 'Details',
			source: 'Bron:',
			barcode: 'Barcode',
			noBarcode: 'Geen barcode',
			macros: 'Macro\'s',
			nutrients: 'Voedingsstoffen',
			usLabel: 'VS-label',
			euLabel: 'EU-label',
			serving: 'Portie',
			portion: 'portie',
			perPortionOfWeight: '{per} {portion} van {weight}',
			foodName: 'Naam voedingsmiddel',
			image: 'Afbeelding',
			nutritionFacts: 'Voedingswaarden',
			nutritionInformation: 'Voedingsinformatie',
			hideAdditionalNutrients: 'Extra voedingsstoffen verbergen',
			showAdditionalNutrients: 'Extra voedingsstoffen tonen',
			description: 'Beschrijving',
		},
		buttons: {
			addServingSize: 'Maat toevoegen',
			addImage: 'Afbeelding toevoegen',
			scanBarcode: 'Barcode scannen',
			log: 'Loggen',
			duplicate: 'Dupliceren',
			delete: 'Verwijderen',
			editFood: 'Voedingsmiddel bewerken',
			scanRecipe: 'Recept scannen',
			useScannedBarcode: 'Die ik heb gescand',
			useBarcodeOnLabel: 'Die op het etiket',
			useAnyway: 'Toch gebruiken',
			doubleCheck: 'Even dubbelchecken',
			share: 'Recept delen',
			unshare: 'Delen stoppen',
			importRecipe: 'Importeren naar mijn recepten',
			recipeImported: 'Recept geïmporteerd',
			linkCopied: 'Link gekopieerd',
			updateAvailable: 'Update beschikbaar',
			refreshFromOriginal: 'Vernieuwen',
			originalUnavailable: 'Origineel recept niet meer beschikbaar',
			importedRecipe: 'Geïmporteerd recept',
			recipeRefreshed: 'Recept bijgewerkt',
			sharedRecipeInfo: 'Dit recept is met jou gedeeld.',
			shareFailed: 'Het recept kon niet worden gedeeld. Probeer het opnieuw.',
			unshareFailed: 'Het delen van het recept kon niet worden gestopt. Probeer het opnieuw.',
			shareIngredientsFailed: 'Sommige ingrediënten konden niet worden gepubliceerd. Het gedeelde recept werkt mogelijk niet correct voor anderen.',
		},
		titles: {
			newRecipe: 'Nieuw recept',
			newFood: 'Nieuw voedingsmiddel',
		},
		tabs: {
			overview: 'Overzicht',
			ingredients: 'Ingrediënten',
		},
		nutrients: {
			calories: 'Calorieën',
			totalFat: 'Totaal vet',
			saturatedFat: 'Verzadigd vet',
			transFat: 'Transvet',
			cholesterol: 'Cholesterol',
			sodium: 'Natrium',
			totalCarbohydrate: 'Totaal koolhydraten',
			dietaryFiber: 'Voedingsvezels',
			totalSugars: 'Totaal suikers',
			includesAddedSugars: 'Waarvan toegevoegde suikers',
			protein: 'Eiwit',
			vitaminD: 'Vitamine D',
			calcium: 'Calcium',
			iron: 'IJzer',
			potassium: 'Kalium',
			energy: 'Energie',
			fat: 'Vet',
			saturates: 'verzadigde vetzuren',
			carbohydrate: 'Koolhydraten',
			sugars: 'suikers',
			fiber: 'Vezels',
			salt: 'Zout',
		},
		alerts: {
			inconsistentValues: 'De waarden lijken inconsistent!',
			confirmDelete: 'Weet je zeker dat je dit {type} wilt verwijderen?',
			removeBarcode: 'Barcode verwijderen',
			removeBarcodeMessage: 'Wil je de barcode {barcode} van dit voedingsmiddel verwijderen?',
			confirmScannedBarcode: 'Is dit hetzelfde product?',
			confirmScannedBarcodeMessage: 'Je hebt barcode {barcode} gescand, maar op dit etiket is geen barcode gevonden. Moet dit nieuwe voedingsmiddel die barcode krijgen?',
			barcodeMismatch: 'Twee verschillende barcodes',
			barcodeMismatchMessage: 'Je hebt {scanned} gescand, maar op het etiket staat {onLabel}. Welke hoort bij dit voedingsmiddel?',
			foodSourceBody: '{attribution}\n\n{trustNote}',
		},
		errors: {
			caloriesInconsistent: 'Calorieën komen niet overeen met de macronutriëntwaarden! Verwacht rond de {expectedCalories} kcal.',
			nameRequired: 'Naam van het voedingsmiddel is verplicht.',
			ingredientRequired: 'Er moet minstens één ingrediënt worden toegevoegd.',
			portionRequired: 'Portiegrootte is verplicht.',
			nutrientMissing: 'Belangrijke voedingsstof ontbreekt.',
			measureWeightRequired: 'Voer het gewicht in grammen in',
		},
		messages: {
			barcodeExists: 'Barcode bestaat al bij dit voedingsmiddel.',
		},
		types: {
			recipe: 'recept',
			food: 'voedingsmiddel',
		},
		foodSources: {
			appRecipe: {
				name: 'MH Physique-recept',
				shortName: 'Recept',
				description: 'Recept aangeleverd en gecontroleerd door het team van de MH Physique-app.',
			},
			community: {
				name: 'Door de community gemaakt voedingsmiddel',
				shortName: 'Community',
				description: 'Voedingsmiddel gemaakt door de community van de MH Physique-app.',
			},
			staple: {
				name: 'MH Physique basisvoedingsmiddel',
				shortName: 'Basis',
				description: 'Een veelgebruikt voedingsmiddel, gecontroleerd door het MH Physique-team en samengesteld uit betrouwbare voedingsdatabases.',
			},
		},
		sourceFoods: {
			header: 'Samengesteld uit Deze Voedingsmiddelen',
			row: '{name} ({database})',
			nameUnavailable: 'Naam Niet Beschikbaar',
		},
		trustLevel: {
			official: 'Dit is **zeer nauwkeurige** voedingsinformatie uit geverifieerde databases.',
			crowdsource: 'Deze voedingsinformatie komt uit een openbaar bewerkbare database. Fouten zijn vaak mogelijk. **Controleer de waarden zelf voordat je ze gebruikt!**',
			community: 'Deze voedingsinformatie is aangeleverd door de community van de MH Physique-app. Dit is meestal van hoge kwaliteit, maar fouten zijn mogelijk. **Controleer de waarden zelf voordat je ze gebruikt!**',
		},
	},
	editMeal: {
		basedOn: 'Gebaseerd op {name}, {day}',
		recipeInstructions: 'Bereidingswijze van {name}',
		macrosLogged: 'Gelogde macro\'s',
		macrosRemaining: 'Resterende macro\'s',
		dayMacrosLogged: 'Gelogde dagmacro\'s',
		dayMacrosRemaining: 'Resterende dagmacro\'s',
		instructions: 'Bereidingswijze',
		skippedNotice: 'Je hebt deze maaltijd overgeslagen, dus het eten erin telt niet mee voor de totalen van de dag.',
		buttons: {
			clear: 'Wissen',
			saveAsRecipe: 'Opslaan als recept',
			copyFrom: 'Kopiëren van een dag',
			scanMeal: 'Maaltijd scannen',
		},
		addToMeal: {
			title: 'Toevoegen aan deze maaltijd',
			addFoodsDescription: 'Zoek voedingsmiddelen, recepten en maaltijden',
			scanBarcode: 'Streepjescode scannen',
			scanBarcodeDescription: 'Een verpakt product',
			scanLabel: 'Etiket scannen',
			scanLabelDescription: 'Fotografeer de voedingswaardetabel',
			logMacrosManuallyDescription: 'Typ de getallen direct in',
			scanMealDescription: 'Fotografeer je bord',
			autoSuggestionsDescription: 'Vult de maaltijd aan tot je resterende doelen',
			copyFromDescription: 'Dezelfde maaltijd op een andere dag',
			short: {
				addFoods: 'Toevoegen',
				scanBarcode: 'Streepjescode',
				scanLabel: 'Etiket',
				logMacrosManually: 'Macro\'s',
				scanMeal: 'Maaltijd',
				autoSuggestions: 'Suggesties',
				copyFrom: 'Kopiëren',
			},
		},
		placeholders: {
			recipeName: 'Voer receptnaam in',
		},
		labels: {
			recipeName: 'Receptnaam',
		},
		alerts: {
			clearMealTitle: '{mealName} wissen?',
			deleteMealTitle: '{mealName} verwijderen?',
			clearMealMessage: 'Weet je zeker dat je de inhoud van deze maaltijd wilt wissen?',
			deleteMealMessage: 'Weet je zeker dat je deze maaltijd wilt verwijderen?',
			cannotTuneTitle: 'Kan niet afstemmen',
			cannotTuneMessage: 'Deze maaltijd kan niet worden afgestemd op je doelen.\n\nAutomatisch afstemmen verandert hoeveel er van elk voedingsmiddel in de maaltijd zit, dus het heeft ruimte nodig om mee te werken. Voeg een ander voedingsmiddel toe, of een uit een andere groep.',
			splitRecipesTitle: 'Recepten splitsen?',
			splitRecipesMessage: 'Om een recept af te stemmen, moet het in afzonderlijke ingrediënten worden gesplitst. Wil je dat nu doen?',
			splitAndTune: 'Splitsen en afstemmen',
			tuneSuccessTitle: 'Afstemtips',
			tuneSuccessMessage: 'De maaltijd is zo goed mogelijk afgestemd, maar kan met deze ingrediënten niet volledig aan de doelen voldoen.\n\nAutomatisch afstemmen werkt het best met een volledige maaltijd die een redelijke mix van eiwit, vet, koolhydraten en idealiter vezelbronnen bevat.',
			mealOnTarget: 'De maaltijd zit nu op doel',
			copyFromNoMatchTitle: 'Niets om te kopiëren',
			copyFromNoMatchMessage: 'Er is geen {mealName} geregistreerd op de dag die je hebt gekozen. Kies een andere dag of voeg de voedingsmiddelen zelf toe aan deze maaltijd.',
			cannotTuneLockedTitle: 'Niets meer om af te stemmen',
			cannotTuneLockedMessage: 'Een deel van deze maaltijd is vergrendeld of is met de hand als macro\'s ingevoerd, en automatisch afstemmen kan geen van beide veranderen. Wat overblijft is niet genoeg om mee te werken.\n\nOntgrendel een voedingsmiddel, of vervang een handmatige invoer door een echt voedingsmiddel, en probeer het opnieuw.',
		},
		toasts: {
			mealTuned: 'De maaltijd is afgestemd.',
			undoTuneFailed: 'De maaltijd kon niet worden teruggezet zoals hij was.',
			mealAlreadyOptimal: 'Deze maaltijd zit al zo dicht bij je doelen als automatisch afstemmen kan komen.',
		},
		errors: {
			couldNotSizeSuggestions: 'De maaltijdsuggesties konden nu niet op je doelen worden afgestemd. Probeer het opnieuw.',
			autoTuneFailed: 'Automatisch afstemmen liep tegen een probleem aan en kon deze maaltijd niet afstemmen. Probeer het opnieuw.',
		},
	},
	mealPlan: {
		title: 'Maaltijdplanner',
		dailyMacroTargets: 'Dagelijkse macrodoelen',
		emptyState: {
			selectDatesTitle: 'Selecteer data om te beginnen',
			selectDatesSubtext: 'De maaltijdplanner genereert automatisch maaltijden die passen bij je dagelijkse macrodoelen. Selecteer de dagen waarvoor je maaltijden wilt genereren.',
		},
		labels: {
			startDate: 'Startdatum',
			numberOfDays: 'Aantal dagen',
		},
		duration: {
			days7: '7 dagen',
			days14: '14 dagen',
			untilSunday: 'Tot volgende zondag',
			untilSaturday: 'Tot volgende zaterdag',
		},
		buttons: {
			generateMeals: 'Maaltijden genereren',
			favorite: 'Favoriet',
			dontSuggest: 'Niet meer voorstellen',
			copyMeals: 'Maaltijden kopiëren',
			acceptAll: 'Alles accepteren',
			editMeal: 'Maaltijd bewerken',
			viewDetails: 'Details bekijken',
		},
		exitDialog: {
			title: 'Maaltijdplanner verlaten',
			message: 'Je hebt nog niet al je maaltijden voor de geselecteerde periode gepland. Hoe wil je verdergaan?',
			saveAndExit: 'Mijn huidige maaltijdselecties opslaan.',
			keepPlanning: 'Doorgaan met het plannen van de rest van mijn maaltijden.',
			discardAndExit: 'Afsluiten en mijn wijzigingen niet opslaan.',
		},
		errors: {
			saveFailed: 'Je maaltijdplan kon niet worden opgeslagen. Je geplande dagen staan er nog — probeer het opnieuw.',
			dayCouldNotBeOpened: '{day} kon niet worden geopend om te plannen en is overgeslagen. Je andere dagen blijven zoals ze zijn.',
		},
		copyDialog: {
			title: 'Maaltijd naar andere dagen kopiëren',
			message: 'Selecteer de dagen waarnaar je {meals} wilt kopiëren.',
			selectAll: 'Alles selecteren',
			copyButton: 'Maaltijden kopiëren',
			multipleMeals: '{count} maaltijden',
		},
	},
	mealSuggestions: {
		title: 'Maaltijdsuggesties',
		replaceMealTitle: 'Maaltijd vervangen',
		match: 'Match',
		targets: 'Doelen',
		buttons: {
			viewRecipe: 'Recept bekijken',
			addMeal: 'Maaltijd toevoegen',
			replace: 'Vervangen',
		},
		errors: {
			serviceUnavailable: 'Kan de maaltijdplanningsservice niet bereiken, probeer het later opnieuw.',
			recipeLibraryNotReady: 'Je receptenbibliotheek wordt ingesteld — probeer het over een minuut opnieuw.',
		},
	},
	editNutritionPlan: {
		title: 'Voedingsschema bewerken',
		description: 'Bewerk je voedingsschema alleen als je op basis van je eigen registratie weet hoeveel calorieën en macro\'s je zou moeten binnenkrijgen.',
		caloriesLabel: 'Calorieën',
		macronutrients: 'Macronutriënten',
		autoAdjustLabel: 'Macro\'s automatisch aanpassen',
		autoAdjustTooltip: 'Als dit aanstaat, worden je macronutriëntdoelen automatisch herberekend om optimale verhoudingen te behouden wanneer je je caloriedoel wijzigt. Als dit uitstaat, blijven de macrodoelen vast, ongeacht wijzigingen in calorieën.',
		proteinLabel: 'Eiwit',
		carbsLabel: 'Koolhydraten',
		fatLabel: 'Vet',
		fiberLabel: 'Vezels',
		recommendedHint: 'Aanbevolen: {value}',
		carbFatRatioLabel: 'Verhouding koolhydraten/vet calorieën',
		resetRecommended: 'Waarden herstellen',
		calorieOvershoot: 'Macrodoelen overschrijden je caloriedoel',
		couldNotComputeTargets: 'We konden je voedingsdoelen nu niet berekenen, dus dit scherm kan niet worden geopend. Probeer het zo meteen opnieuw.',
	},
	addMacros: {
		title: 'Macro\'s handmatig registreren',
		defaultFoodName: 'Mijn eigen voedingsmiddel',
		labels: {
			foodName: 'Naam voedingsmiddel',
		},
		placeholders: {
			enterFoodName: 'Voer naam voedingsmiddel in',
		},
		warnings: {
			caloriesMismatch: 'Calorieën komen niet overeen met de opgegeven macro\'s',
		},
	},
	reschedule: {
		labels: {
			date: 'Datum',
			weighIn: 'Weging',
			wakeUp: 'Opstaan',
			time: 'Tijd',
			item: 'Item',
			meal: 'Maaltijd',
		},
		weighInHelpText: 'Weeg jezelf nuchter in de ochtend nadat je naar het toilet bent geweest.',
		weekdaySelect: {
			placeholder: 'Selecteer weekdag',
			currentBadge: 'Huidige',
		},
		options: {
			thisDayOnly: {
				title: 'Alleen op deze dag toepassen',
				description: 'Alleen toepassen op deze {weekday}.',
			},
			allDays: {
				title: 'Op alle dagen toepassen',
				descriptionWakeUp: 'Maak dit mijn opsta-tijd voor alle dagen.',
				descriptionWorkout: 'Maak dit mijn trainingstijd voor alle trainingen.',
				description: 'Maak dit mijn {itemName}-tijd voor alle dagen.',
			},
			thisWeekday: {
				title: 'Op deze weekdag toepassen',
				descriptionWorkout: 'Verplaats deze training permanent naar deze tijd op {weekday}.',
				descriptionWakeUp: 'Maak dit mijn opsta-tijd op {weekday}en.',
				description: 'Maak dit mijn {itemName}-tijd op {weekday}en.',
			},
		},
		title: '{item} opnieuw plannen',
		titleWakeUpWeighIn: 'Opstaan & weging opnieuw plannen',
		errors: {
			timeAlreadyUsed: 'Deze tijd wordt al gebruikt door Maaltijd {mealNumber}. Kies een andere tijd.',
		},
	},
	pinnedNote: {
		viewTitle: 'Vastgezette notities',
		description: 'Vastgezette notities blijven zichtbaar telkens wanneer je deze oefening doet.',
		placeholder: 'Bijv. Schrijf materiaaltips of herinneringen op die je altijd bij de hand wilt hebben.',
		title: 'Vastgezette notitie maken',
		titleEdit: 'Vastgezette notitie bewerken',
	},
	setNote: {
		viewTitle: 'Setnotitie',
		title: 'Setnotitie',
		titleEdit: 'Setnotitie bewerken',
		description: 'Een setnotitie is voor 1 specifieke set van een training. Je kunt hem bekijken op de trainingspagina en in de oefeningsgeschiedenis.',
		placeholder: 'Bijv. Notities over deze specifieke set...',
	},
	editIngredient: {
		title: 'Ingrediënt bewerken',
		logMacrosTitle: 'Macro\'s handmatig registreren',
		viewDetails: 'Details bekijken',
		details: 'Details',
		date: 'Datum',
		meal: 'Maaltijd',
		foodName: 'Naam voedingsmiddel',
		amount: 'Hoeveelheid',
		foods: 'Voedingsmiddelen',
		splitTitle: 'Opsplitsen in afzonderlijke voedingsmiddelen',
		splitDescription: 'Dit recept wordt momenteel als één item geregistreerd. Wil je het opsplitsen in de afzonderlijke ingrediënten zodat je de hoeveelheden kunt aanpassen?',
		splitIntoFoods: 'Opsplitsen in voedingsmiddelen',
		splitAndAutoTune: 'Opsplitsen & voedingsmiddelen automatisch afstemmen',
		splitMealDescription: 'Splits deze maaltijd op in afzonderlijke voedingsmiddelen en stem hun hoeveelheden automatisch af op je doelen.',
		splitMealDescriptionNoTargets: 'Splits deze maaltijd op in afzonderlijke voedingsmiddelen zodat je hun hoeveelheden kunt aanpassen.',
		splitTuneNoSolutionToast: 'Je voedingsmiddelen zijn opgesplitst, maar automatisch afstemmen vond geen hoeveelheden die bij je doelen passen. Voeg een ander voedingsmiddel toe, of pas de hoeveelheden zelf aan.',
		splitTuneNoSolutionLockedToast: 'Je voedingsmiddelen zijn opgesplitst, maar een deel van deze maaltijd is vergrendeld of met de hand als macro\'s ingevoerd, en automatisch afstemmen kan geen van beide veranderen. Ontgrendel een voedingsmiddel of vervang een handmatige invoer, en probeer het opnieuw.',
		caloriesMismatchWarning: 'Op basis van de hoeveelheid macronutriënten zou dit voedingsmiddel ongeveer {expectedCalories} calorieën moeten bevatten.',
		foodAddedToast: '{food} {amount} toegevoegd aan {meal}',
		foodAddedToastNoDestination: '{food} {amount} toegevoegd',
		undoFailedToast: 'Dat voedingsmiddel kon niet meer worden verwijderd — de maaltijd is gewijzigd sinds je het toevoegde.',
		inconsistentNutrientsWarning: 'De vermelde calorieën van dit voedingsmiddel kloppen niet met het eiwit, vet en de koolhydraten, die uitkomen op ongeveer {expectedCalories} kcal per 100 g. Controleer de cijfers voordat je het logt, of kies een andere invoer.',
		refuseHint: {
			withParts: 'Weeg het zonder {parts}. Ongeveer {percent}% van het gewicht bij aankoop wordt niet gegeten.',
			percentOnly: 'De waarden gelden voor het eetbare deel. Ongeveer {percent}% van het gewicht bij aankoop wordt niet gegeten.',
			partsOnly: 'Weeg het zonder {parts}.',
			withPartsRough: 'Weeg het zonder {parts} voor een nauwkeurige hoeveelheid. Weeg je het vooraf, dan gaat er meestal ongeveer {percent}% af, maar dit verschilt sterk.',
			percentOnlyRough: 'De waarden gelden voor het eetbare deel. Weeg het na het schoonmaken voor een nauwkeurige hoeveelheid: er gaat meestal ongeveer {percent}% af, maar dit verschilt sterk.',
		},
		refuseParts: {
			shell: 'schaal',
			tail: 'staart',
			bone: 'bot',
			skin: 'vel',
			fat: 'vet',
			peel: 'schil',
			pit: 'pit',
			seeds: 'zaden',
			core: 'kern',
			stem: 'steel',
			leaves: 'buitenste bladeren',
			rind: 'korst',
			pod: 'peul',
			husk: 'schutbladeren',
			cob: 'kolf',
			top: 'bovenkant',
			root: 'wortel',
			trimmings: 'afsnijdsels',
		},
		weighedWith: {
			withParts: 'Gewogen met {parts}',
			asBought: 'Gewogen zoals gekocht',
		},
		weighedWithNote: {
			typical: 'Geteld als {weight} gegeten: {percent}% van het gewicht gaat eraf.',
			rough: 'Geteld als ongeveer {weight} gegeten: meestal gaat er ongeveer {percent}% af, maar dit verschilt sterk.',
		},
	},
	ingredientSearch: {
		addFood: 'Voedingsmiddel toevoegen',
		customFood: 'Eigen voedingsmiddel',
		emptyState: {
			title: 'Selecteer voedingsmiddelen voor je maaltijd',
			titleRecipe: 'Nog geen voedingsmiddelen toegevoegd',
		},
		buttons: {
			clearMeal: 'Maaltijd wissen',
			lock: 'Vergrendelen',
			unlock: 'Ontgrendelen',
			viewAll: 'Alles bekijken',
			addFoods: 'Voedingsmiddelen toevoegen',
			logMacrosManually: 'Macro\'s handmatig registreren',
			autoSuggestions: 'Auto-suggesties',
			editServingSize: 'Portiegrootte bewerken',
			viewFoodDetails: 'Details voedingsmiddel bekijken',
			splitIntoFoods: 'Opsplitsen in voedingsmiddelen',
			lockFood: 'Voedingsmiddel vergrendelen',
			unlockFood: 'Voedingsmiddel ontgrendelen',
			removeFood: 'Voedingsmiddel verwijderen',
			reorder: 'Volgorde wijzigen',
			done: 'Klaar',
		},
		tooltips: {
			lockFood: 'Door een voedingsmiddel te vergrendelen, wordt het niet gewijzigd bij het automatisch afstemmen van de maaltijd.',
		},
		alerts: {
			removeTitle: 'Ingrediënt verwijderen?',
			removeMessage: 'Weet je zeker dat je {name} wilt verwijderen?',
		},
		errors: {
			foodDoesNotExist: 'Voedingsmiddel bestaat niet',
		},
		titleMeal: 'Voedingsmiddelen',
		repeatMeal: {
			sectionTitle: 'Een recente maaltijd herhalen',
			lastTimeIn: 'Vorige keer bij {meal}',
			add: 'Opnieuw Toevoegen',
			addedToast: '{count} {{voedingsmiddel|voedingsmiddelen}} toegevoegd aan {meal}',
			addedToastNoDestination: '{count} {{voedingsmiddel|voedingsmiddelen}} toegevoegd',
			undoFailedToast: 'Die voedingsmiddelen konden niet worden verwijderd — de maaltijd is veranderd sinds je ze toevoegde.',
			couldNotRepeatToast: 'Die maaltijd kon niet worden toegevoegd — hij bevat geen voedingsmiddelen meer.',
		},
		splitToast: 'Opgesplitst in {count} {{voedingsmiddel|voedingsmiddelen}}',
		splitUndoFailedToast: 'Het opsplitsen kon niet ongedaan worden gemaakt — de maaltijd is sindsdien veranderd.',
	},
	editExercise: {
		titles: {
			createExercise: 'Oefening maken',
			editExercise: '{name} bewerken',
			viewExercise: '{name}',
			relativeStrengthStandard: 'Relatieve krachtstandaard',
			absoluteStrengthStandard: 'Absolute krachtstandaard ({gender})',
		},
		labels: {
			name: 'Naam',
			id: 'ID',
			shortName: 'Korte naam',
			advancedSettings: 'Geavanceerde instellingen',
			instructions: 'Instructies',
			videoUrl: 'Video-URL',
			equipmentTemplate: 'Materiaal',
			bodyweightPercent: 'Lichaamsgewicht %',
			myoRep: 'Myo-rep-oefening?',
			rmTesting: 'RM-testen gebruiken?',
			referenceExercise: 'Referentieoefening',
			oneRMFactor: '1RM-factor %',
			bodyWeight: 'Lichaamsgewicht',
			similarExercise: 'Meest vergelijkbare oefening',
		},
		placeholders: {
			exerciseName: 'Voer naam oefening in',
			shortName: 'Voer korte naam in',
			instructions: 'Voer instructies voor de oefening in',
			videoUrl: 'Plak een YouTube- of Vimeo-link',
			selectTemplate: 'Selecteer...',
			selectExercise: 'Selecteer oefening',
		},
		hints: {
			bodyweightPercent: 'Het percentage van je lichaamsgewicht dat je tijdens de beweging tilt.',
			similarExercise: 'Dit bepaalt de doelspieren.',
		},
		buttons: {
			addImage: 'Afbeelding toevoegen',
			previewInstructions: 'Instructies vooraf bekijken',
			addAbsoluteStandard: 'Absolute standaard toevoegen',
			addRelativeStandard: 'Relatieve standaard toevoegen',
			addWeightCategory: 'Gewichtscategorie toevoegen',
			importExercise: 'Importeren',
			refreshFromOriginal: 'Bijwerken',
			revertToOriginal: 'Terug naar origineel',
			checkForUpdate: 'Controleren op update',
		},
		messages: {
			exerciseNotFound: 'Deze oefening is niet langer beschikbaar.',
			exerciseUnreadable: 'Deze oefening kon nu niet worden geladen. Ga terug en probeer het zo meteen opnieuw.',
			sharedWithYou: 'Deze oefening is met jou gedeeld.',
			youOwnThisExercise: 'Jij bent de auteur van deze oefening.',
			updateAvailable: 'Er is een bijgewerkte versie van deze oefening beschikbaar.',
			originalUnavailable: 'De originele gedeelde oefening is niet langer beschikbaar.',
			importedExercise: 'Geïmporteerde oefening',
			basedOn: 'Gebaseerd op: {name}',
		},
		toasts: {
			exerciseImported: 'Oefening geïmporteerd',
			importFailed: 'Importeren van oefening mislukt',
			exerciseRefreshed: 'Oefening bijgewerkt',
			refreshFailed: 'Bijwerken van oefening mislukt',
			exerciseCustomized: 'Oefening aangepast',
			revertedToOriginal: 'Teruggezet naar origineel.',
			originalNoLongerAvailable: 'Origineel is niet langer beschikbaar.',
			couldNotReachExercises: 'Je oefeningen konden nu niet worden opgehaald. Probeer het zo meteen opnieuw.',
			checkForUpdateOffline: 'Kon niet controleren op updates — je lijkt offline te zijn.',
			partialUpdateApplied: '{count} wijziging(en) toegepast vanuit de bron.',
			saveFailed: 'Opslaan van oefening mislukt',
		},
		alerts: {
			saveAndExit: {
				title: 'Opslaan en afsluiten?',
				message: 'Weet je zeker dat je je bewerkingen wilt opslaan en de pagina wilt afsluiten?',
			},
			revertToOriginal: {
				title: 'Terug naar origineel?',
				message: 'Je wijzigingen verwerpen en het origineel herstellen?',
			},
			updateAvailable: {
				title: 'Update beschikbaar',
				acceptButton: 'Wijzigingen accepteren',
				ignoreButton: 'Negeren',
				cancelButton: 'Annuleren',
				updateRevisionButton: 'Revisie bijwerken',
				noVisibleChangesBody: 'Geen zichtbare wijzigingen voor de gebruiker.',
				alreadyUpToDateToast: 'Al up-to-date',
				pickerApplyButton: 'Toepassen ({count})',
				pickerIgnoreButton: 'Negeren',
				pickerCheckboxHint: 'Selecteer de wijzigingen die je uit de bron wilt overnemen.',
				pickerCurrentDescription: 'Huidige beschrijving',
				pickerUpdatedDescription: 'Bijgewerkte beschrijving',
				toggledOn: 'Ingeschakeld',
				toggledOff: 'Uitgeschakeld',
				descriptionChanged: 'Beschrijving gewijzigd',
				standardChanged: 'Krachtstandaard gewijzigd',
				empty: '(leeg)',
				fieldDiffLabels: {
					name: 'Naam',
					shortname: 'Korte naam',
					description: 'Beschrijving',
					videoUrl: 'Video-URL',
					bw_pc: 'Lichaamsgewicht %',
					allowMyoReps: 'Myo-reps toegestaan',
					avoidRMTesting: 'RM-testen vermijden',
					standard: 'Krachtstandaard',
					equipmentTemplateId: 'Materiaal',
					similarExerciseId: 'Vergelijkbare oefening',
				},
			},
		},
		errors: {
			invalidName: 'Ongeldige naam',
			unknownButton: 'Onbekende knop voor materiaalbewerking {button}',
		},
	},
	exerciseSwitch: {
		titles: {
			changeExercise: 'Oefening wijzigen',
			addExercise: 'Oefening toevoegen',
			pickExercise: 'Oefening kiezen',
		},
		placeholders: {
			searchExercise: 'Typ een naam van een oefening...',
		},
		filters: {
			all: 'Alle',
			recommended: 'Aanbevolen',
			myExercises: 'Mijn oefeningen',
			suggested: 'Voorgesteld',
			filterByCategory: 'Filteren op categorie',
		},
		messages: {
			recommendationInfo: 'We bevelen de volgende oefeningen aan als vervanging, van meest tot minst aanbevolen.',
		},
		buttons: {
			statsAndNotes: 'Statistieken en notities',
			description: 'Beschrijving',
			modify: 'Aanpassen',
			delete: 'Verwijderen',
			share: 'Delen',
			checkForUpdate: 'Controleren op update',
			update: 'Bijwerken',
			createExercise: 'Oefening aanmaken',
			save: 'Opslaan',
			add: 'Toevoegen',
		},
		indicators: {
			updateAvailable: 'Update beschikbaar',
		},
		emptyState: {
			noResultsTitle: 'Geen resultaten gevonden',
			noResultsSubtext: 'Probeer een andere zoekterm',
		},
		alerts: {
			deleteExercise: {
				title: 'Oefening verwijderen',
				message: 'Weet je zeker dat je "{name}" wilt verwijderen? {extra}',
				neverUsed: 'De oefening is nooit in een training gebruikt, dus wordt hij definitief verwijderd.',
				wasUsed: 'De oefening is in een training gebruikt. Hij wordt als verwijderd gemarkeerd en verschijnt niet meer in de lijst met oefeningen, maar je kunt hem later terugzetten.',
			},
		},
		removeExercise: {
			title: 'Oefening verwijderen',
			message: 'Weet je zeker dat je {exercise} uit training {workout} wilt verwijderen?',
		},
		linkWorkouts: {
			title: 'Progressie delen?',
			message: '{exercise} staat al in {workouts}. Als je de oefening hier ook gebruikt, delen beide trainingen één progressie: dezelfde gewichten en herhalingen, en een latere wijziging aan deze oefening in de ene training verandert ook de andere.',
			workoutName: 'training {workout}',
			share: 'Progressie delen',
		},
		alreadyInWorkout: {
			title: 'Staat al in deze training',
			message: '{exercise} staat al in training {workout}. Kies een andere oefening, of verwijder in plaats daarvan de oefening die je wilt wijzigen.',
		},
		errors: {
			workoutNotFound: 'Training {workoutId} niet gevonden',
			noSelectedItem: 'Geen item geselecteerd bij het accepteren van de oefeningwissel',
		},
		coachBadge: {
			label: 'Coach',
			info: 'Van je coach {coachName}',
			infoNoName: 'Van je coach',
		},
	},
	editTrainingProgram: {
		labels: {
			sets: '{count} {{set|sets}}',
		},
	},
	editWorkouts: {
		title: 'Trainingen bewerken',
		setsCount: '{count} sets',
		rmTesting: 'RM-testen',
		myoReps: 'Myo-reps',
		repsCount: '{count} herhalingen',
		suggestedRepsCount: '~{count} herhalingen',
		dupRepsCount: '{heavy}/{light} herhalingen',
		suggestedDupRepsCount: '~{heavy}/{light} herhalingen',
		tupRepsCount: '{heavy}/{medium}/{light} herhalingen',
		suggestedTupRepsCount: '~{heavy}/{medium}/{light} herhalingen',
		buttons: {
			save: 'Opslaan',
			revert: 'Terugdraaien',
			deleteWorkout: 'Training {name} verwijderen',
		},
		menu: {
			volumeOptimization: 'Volumeoptimalisatie',
			scanWorkout: 'Training scannen',
			removeExercise: 'Oefening verwijderen',
			moveExercise: 'Oefening verplaatsen',
			moveExerciseTo: 'Oefening verplaatsen naar...',
			workoutName: 'Training {name}',
		},
		deleteWorkout: {
			confirmTitle: 'Training verwijderen',
			confirmMessage: 'Weet je zeker dat je training {name} wilt verwijderen? Alle oefeningen in deze training worden verwijderd.',
			cannotDeleteTitle: 'Kan niet verwijderen',
			cannotDeleteMessage: 'Je moet minstens één training hebben.',
		},
		removeExercise: {
			cannotRemoveLastTitle: 'Kan niet verwijderen',
			cannotRemoveLastMessage: 'Je plan heeft minstens één oefening nodig, anders zijn al je workouts leeg. Voeg eerst een andere oefening toe, of wissel deze om voor een andere oefening.',
		},
		revert: {
			title: 'Wijzigingen terugdraaien',
			message: 'Kies hoe je je wijzigingen wilt terugdraaien:',
			undoMessage: 'Hiermee maak je alle wijzigingen van deze sessie ongedaan.',
			undoButton: 'Ongedaan maken',
			undoSession: 'Sessiewijzigingen ongedaan maken',
			restoreOriginal: 'Oorspronkelijk schema terugzetten',
			noChangesTitle: 'Geen wijzigingen',
			noChangesMessage: 'Je hebt in deze sessie geen wijzigingen aangebracht.',
			notAvailableTitle: 'Niet beschikbaar',
			notAvailableMessage: 'Er is geen back-up van het oorspronkelijke schema beschikbaar voor schema\'s die vóór deze functie zijn aangemaakt.',
			confirmRestoreTitle: 'Oorspronkelijk schema terugzetten',
			confirmRestoreMessage: 'Hiermee zet je je trainingen terug naar het schema van de intake of de laatste schema-update. Alle wijzigingen die daarna zijn aangebracht, gaan verloren.',
			restoreButton: 'Terugzetten',
		},
		toast: {
			exerciseMoved: 'Oefening verplaatst naar training {workout}. ',
			view: 'Bekijken',
		},
		alerts: {
			reoptimizeConfirm: {
				message: 'Wil je dat de app het aantal sets voor je oefeningen aanpast zodat ze overeenkomen met je wekelijkse doelvolume per spiergroep? Je oefeningvolgorde en trainingssplit blijven ongewijzigd. Alleen je sets per oefening veranderen.',
				yes: 'Ja, mijn volume heroptimaliseren',
				no: 'Nee, mijn oefeningvolumes niet aanpassen',
			},
			reoptimizeResult: {
				title: 'Volume geheroptimaliseerd',
				noChanges: 'Je aantal sets komt al overeen met je doelen.',
			},
			reoptimizeLoading: 'Volume heroptimaliseren...',
		},
		exercisesLoadFailed: {
			title: 'Je oefeningen konden niet worden geladen',
			message: 'Je oefeningen konden nu niet worden geladen. Controleer je verbinding en tik op Opnieuw proberen.',
			saveRefused: 'Je oefeningen konden niet worden geladen, dus er is nog niets opgeslagen. Je wijzigingen blijven bewaard. Controleer je verbinding en probeer het opnieuw.',
		},
		emptyWorkout: {
			title: 'Lege training',
			message: 'Training {name} heeft geen oefeningen. Voeg er een oefening aan toe of verwijder de training. Een lege training zou als een lege dag in je schema verschijnen.',
			messageSeveral: 'Trainingen {names} hebben geen oefeningen. Voeg er oefeningen aan toe of verwijder ze. Een lege training zou als een lege dag in je schema verschijnen.',
			deleteSeveral: 'Lege trainingen verwijderen',
		},
	},
	exerciseConfiguration: {
		loadFailed: {
			title: 'Oefening kon niet worden geladen',
			message: 'Deze oefening kon nu niet worden geladen. Controleer je verbinding en probeer het opnieuw.',
		},
		labels: {
			muscleGroup: 'Spiergroep',
			myoReps: 'Myo-reps',
			equivalentVolume: 'Equivalent volume',
			volume: 'Volume',
			myoRepsVolume: 'Myo-reps-volume',
			rmTesting: 'RM-testen',
			repTarget: 'Herhalingsdoel',
			heavyRepTarget: 'Herhalingsdoel (zwaar)',
			mediumRepTarget: 'Herhalingsdoel (gemiddeld)',
			lightRepTarget: 'Herhalingsdoel (licht)',
			toBeDetermined: 'Nog te bepalen',
		},
		options: {
			avoid: 'Vermijden',
			prefer: 'Voorkeur',
			auto: 'Automatisch',
		},
		buttons: {
			save: 'Opslaan',
		},
		myoRepsVolumeOneSeries: '1 activatieset en {minisets} minisets',
		myoRepsVolumeMultipleSeries: '{count} reeksen van activatieset + {minisets} minisets',
		repTargetInfo: 'Het herhalingsdoel wordt bepaald tijdens je volgende training voor deze oefening.',
		repTargetInfoRMTesting: 'Het herhalingsdoel wordt bepaald nadat het RM-testen is voltooid.',
		repTargetHint: {
			atLeast: 'Moet minstens {min} herhalingen zijn',
			atMost: 'Mag hoogstens {max} herhalingen zijn',
			between: 'Moet tussen {min} en {max} herhalingen liggen',
			dupBanner: 'Zware en lichte sessies gebruiken verschillende herhalingsdoelen. Houd ze minstens {gap} herhalingen uit elkaar.',
			tupBanner: 'Zware, gemiddelde en lichte sessies gebruiken verschillende herhalingsdoelen. Houd aangrenzende sessies minstens {gap} herhalingen uit elkaar.',
		},
		toast: {
			repTargetRequired: 'Herhalingsdoel mag niet leeg zijn.',
			repTargetTooLow: 'Het herhalingsdoel moet minstens {min} herhalingen zijn voor deze oefening.',
			dupLightTooLow: 'Het lichte herhalingsdoel moet minstens {min} herhalingen zijn (zwaar + {gap}).',
			dupHeavyTooHigh: 'Het zware herhalingsdoel mag hoogstens {max} herhalingen zijn (licht - {gap}).',
			tupLightTooLow: 'Het lichte herhalingsdoel moet minstens {min} herhalingen zijn (gemiddeld + {gap}).',
			tupMediumTooHigh: 'Het gemiddelde herhalingsdoel mag hoogstens {max} herhalingen zijn (licht - {gap}).',
			tupMediumTooLow: 'Het gemiddelde herhalingsdoel moet minstens {min} herhalingen zijn (zwaar + {gap}).',
			tupHeavyTooHigh: 'Het zware herhalingsdoel mag hoogstens {max} herhalingen zijn (gemiddeld - {gap}).',
		},
		coach: {
			intensity: 'Intensiteit',
			oneTarget: 'Eén doel',
			nextSessionOnly: 'Alleen volgende sessie',
			nextWeight: 'Volgend gewicht',
			nextMinReps: 'Volgend minimum aantal herhalingen',
			dayHeavy: 'Zware dag',
			dayMedium: 'Gemiddelde dag',
			dayLight: 'Lichte dag',
			dayOne: 'Elke sessie',
			comesNext: 'Deze dag komt hierna, in de volgende sessie met {exercise}.',
			nextSessionNote: 'De app stelt deze na elke sessie in. Een wijziging geldt alleen voor de volgende sessie.',
			lastSession: 'Laatste sessie: {weight} × {reps} op {date}.',
			calculatedFrom: 'Gewichten berekend op basis van de beste recente set, {weight} × {reps} op {date}. Je kunt ze aanpassen.',
			strengthTestNext: 'Wordt bepaald door een krachttest in de volgende sessie.',
			calculateWeights: 'Gewichten berekenen',
			historyUnreadable: 'De recente trainingen konden niet worden gelezen, dus de intensiteit kan nu niet worden gewijzigd. Probeer het later opnieuw.',
			minRepsInvalid: 'Moet minstens 1 herhaling zijn, of leeg.',
			strengthAtLastDeload: 'Kracht bij laatste deload',
			deloadStrength: '{strength}. Er is sprake van een plateau als een deload onder {limit} uitkomt.',
			deloadStrengthNone: 'Nog geen.',
			plateauWaiting: 'Plateauvraag wacht sinds {date}. {client} heeft nog niet geantwoord. Door de intensiteit of de oefening te wijzigen, wordt de vraag beantwoord.',
			plateauWillAnswer: 'Opslaan beantwoordt de plateauvraag die sinds {date} wacht. {client} krijgt de vraag niet.',
			volumeWaiting: 'Volumevraag wacht sinds {date}. {client} heeft nog niet geantwoord. Door het volume te wijzigen, wordt de vraag beantwoord.',
			volumeWillAnswer: 'Opslaan beantwoordt de volumevraag die sinds {date} wacht. {client} krijgt de vraag niet.',
			setAside: 'Tijdelijk uitgeschakeld',
			setAsideNone: 'Nee',
			setAsidePlateau: '{exercise} is op {date} tijdelijk uitgeschakeld na een plateau, tot {until}.',
			setAsideWeakness: '{exercise} is op {date} tijdelijk uitgeschakeld na een zwakteresultaat, tot {until}.',
			bringBackNow: 'Nu terugzetten',
			broughtBack: '{exercise} is weer beschikbaar zodra je opslaat.',
			changes: 'Wijzigingen',
			changesNone: 'Nog geen wijzigingen.',
			changeBy: '{who}: {what}',
			app: 'App',
			event: {
				plateau: 'Plateau gedetecteerd',
				deload: 'Deload',
				weakness: 'Zwakteresultaat',
				volumeUp: 'Volume met 1 set verhoogd',
				volumeDown: 'Volume met 1 set verlaagd',
			},
			field: {
				scheme: 'Intensiteit {before} → {after}',
				targetReps: '{day} doelherhalingen {before} → {after}',
				targetWeight: '{day} volgend gewicht {before} → {after}',
				minReps: '{day} volgend minimum aantal herhalingen {before} → {after}',
				volume: 'Volume {before} → {after} sets',
				myo: 'Myo-reps gewijzigd',
				rmTesting: 'RM-testen gewijzigd',
				setAsideCleared: 'Uitgeschakelde oefening teruggezet',
				plateauAnswered: 'Plateauvraag beantwoord',
				volumeQuestionAnswered: 'Volumevraag beantwoord',
				none: '–',
			},
			advanced: 'Geavanceerd',
			plateauWaitingSelf: 'Plateauvraag wacht sinds {date}. Door de intensiteit of de oefening te wijzigen, wordt de vraag beantwoord.',
			plateauWillAnswerSelf: 'Opslaan beantwoordt de plateauvraag die sinds {date} wacht.',
			volumeWaitingSelf: 'Volumevraag wacht sinds {date}. Door het volume te wijzigen, wordt de vraag beantwoord.',
			volumeWillAnswerSelf: 'Opslaan beantwoordt de volumevraag die sinds {date} wacht.',
		},
	},
	equipment: {
		sections: {
			incrementWeights: 'Incrementgewichten',
			barbellWeight: 'Halterstanggewicht',
			stackedWeights: 'Gestapelde gewichten',
			dumbbellWeights: 'Dumbbellgewichten',
			plates: 'Schijven',
		},
		stack: {
			additionalMicroloading: 'Extra "microloading"-schijven (meestal magnetisch) die je zo nodig aan deze stapel kunt bevestigen. Maak één invoer per schijf.',
			additionalMicroloadingWeights: 'Extra "microloading"-schijven (meestal magnetisch) die je zo nodig aan de gewichten kunt bevestigen. Maak één invoer per schijf.',
			unsortedWeights: 'De gewichten zijn niet gesorteerd. Ze worden bij het opslaan opnieuw geordend. Of je kunt rechts op Opschonen drukken om het nu te doen.',
		},
		labels: {
			template: '[Sjabloon]',
			usedIn: 'Gebruikt in: {exercises}',
			minimumWeight: 'Minimumgewicht',
			weightIncrement: 'Gewichtsincrement',
			bar: 'Stang',
			from: 'Van:',
			to: 'Tot:',
			increments: 'Incrementen:',
			collarWeightOptional: 'Klemgewicht (optioneel)',
			individualWeight: 'Individueel gewicht',
			noPlatesYet: 'Nog geen schijven',
			filters: 'Filters',
			equipmentType: 'Apparatuurtype',
			details: 'Details',
			name: 'Naam',
			units: 'Eenheden',
			microPlatesOptional: 'Microschijven (optioneel)',
			platesSummary: '{count} x {weight} schijven',
			platesSummaryPairs: '{count} x {weight} paren',
			numberOfPairs: 'Aantal paren',
			numberOfPlates: 'Aantal schijven',
			myEquipmentName: 'Mijn {name}',
		},
		summary: {
			manual: 'Handmatig opgegeven met minimaal {min} en stappen van {inc}',
			bar: '{bar} halterstang met {plates} schijven (in paren)',
			barWithCollars: '{bar} halterstang met {collars} sluitveren en {plates} schijven (in paren)',
			stack: 'Stackmachine die kiest uit {weights}',
			freePlates: 'Losse schijven: {plates}',
			withMicroloading: '{base} met microloading {plates}',
			noPlates: 'geen schijven',
			unknown: 'Onbekende apparatuur',
		},
		templates: {
			barbell: 'Halterstang',
			dumbbells: 'Dumbbells',
			plainPlates: 'Gewone schijven',
			freePlates: 'Losse schijven',
			kettlebells: 'Kettlebells',
			cableMachine: 'Kabelmachine',
			customIncrements: 'Eigen stappen',
		},
		titles: {
			changeEquipment: 'Apparatuur wijzigen',
			equipment: 'Apparatuur',
			createEquipment: 'Apparatuur aanmaken',
		},
		placeholders: {
			search: 'Zoeken',
			enterName: 'Voer een naam in',
			noStackedWeights: 'Geen gestapelde gewichten ingesteld. Voeg er hieronder een toe.',
			noWeightsSet: 'Geen gewichten ingesteld. Voeg er hieronder een toe.',
			selectTemplate: 'Selecteren...',
		},
		filters: {
			all: 'Alle',
			suggested: 'Voorgesteld',
			showTemplates: 'Sjablonen tonen',
			showMine: 'Die van mij tonen',
		},
		descriptions: {
			barPlates: 'Alle paren schijven die je voor deze stang beschikbaar hebt. Maak één invoer per paar.',
			plates: 'Losse schijven zonder stang (bijvoorbeeld om op een machine te leggen of aan een riem te hangen). Schijven worden één voor één gebruikt, niet in paren.',
			stack: 'Gestapelde gewichten in een vaste volgorde. Meestal op een machine. Met microloading-schijven als je die hebt.',
			manual: 'Gebruik dit voor gewichten die je zelf handmatig samenstelt. Je moet alle mogelijke gewichten in de opgegeven incrementen kunnen samenstellen.',
		},
		notes: {
			barWeight: 'Gewicht van de stang zelf.',
			bothCollars: 'Beide klemmen samen wegen {weight}',
			keepEmptyCollars: 'Laat leeg als je heel lichte of geen klemmen gebruikt (zoals in de meeste sportscholen).',
		},
		buttons: {
			delete: 'Verwijderen',
			duplicate: 'Dupliceren',
			modify: 'Wijzigen',
			create: 'Aanmaken',
			createEquipment: 'Apparatuur aanmaken',
			addStackedWeight: 'Gestapeld gewicht toevoegen',
			addDumbbells: 'Dumbbells toevoegen',
		},
		messages: {
			wouldYouLike: 'Wil je',
			noEquipmentDefined: 'Je hebt nog geen apparatuur gedefinieerd.',
			showingOnlyCustom: 'Alleen je aangepaste apparatuur wordt getoond. Er zijn {count} items verborgen.',
			toCreateEquipment: 'kun je gebruiken om je apparatuur aan te maken',
		},
		emptyState: {
			noResultsTitle: 'Geen resultaten gevonden',
			noResultsSubtext: 'We konden niets vinden dat overeenkomt met je zoekopdracht. Pas je zoektermen of filters aan en zoek opnieuw.',
			chooseTemplate: {
				title: 'Kies een sjabloon om te beginnen',
				subtext: 'Selecteer hierboven een apparatuursjabloon om extra velden te ontgrendelen en je nieuwe apparatuurtype aan te maken.',
			},
		},
		links: {
			showTemplates: 'de sjablonen tonen',
		},
		alerts: {
			deleteEquipment: {
				title: 'Apparatuur verwijderen?',
				subtitle: 'Weet je zeker dat je {name} wilt verwijderen?',
				usedBy: 'De apparatuur wordt gebruikt in: {exercises}',
			},
		},
		errors: {
			unknownMode: 'Onbekende apparatuurzoekmodus {mode}',
			unknownButton: 'Onbekende apparatuurzoekknop {button}',
			attemptToApplyTemplate: 'Poging om sjabloon {id} als apparatuur toe te passen',
		},
		tutorial: {
			nameEquipment: 'Dit is je nieuwe apparatuur op basis van een officieel sjabloon. Geef het een naam die je herkent.',
			adjustValues: 'Dit zijn slechts voorbeeldwaarden. Zorg dat je ze aanpast aan jouw specifieke apparatuur!',
			saveEquipment: 'Als je zeker weet dat de apparatuur klopt, tik hier om ze op te slaan.',
		},
		validation: {
			invalidName: 'Ongeldige naam',
			incrementHelp: 'Stel de "stap" in op de kleinste hoeveelheid waarmee je het gewicht kunt verhogen. Als de kleinste schijf op een halterstang bijvoorbeeld 0,5 kg is, stel de stap dan in op 1 kg - want je moet er twee schijven op leggen.',
			minimumHelp: 'Stel het minimum in op het laagste gewicht dat je voor deze oefening kunt gebruiken. Bijvoorbeeld het gewicht van een lege halterstang.',
			barWeightRequired: 'Stanggewicht is verplicht.',
			unknownField: 'Onbekend veld',
			unknownEquipmentType: 'Onbekend type apparatuur',
		},
	},
	subscribe: {
		title: 'Abonneren',
		restorePurchases: 'Aankopen herstellen',
		subscriptionTerms: 'De betaling wordt aan het einde van een gratis proefperiode in rekening gebracht op je Apple ID-account. Het abonnement wordt automatisch verlengd tegen de vermelde prijs, tenzij het minstens 24 uur voor het einde van de huidige periode wordt opgezegd. Beheer of annuleer het op elk moment in je Apple ID-instellingen.',
		privacyPolicy: 'Privacybeleid',
		eula: 'EULA',
		titles: {
			selectSubscription: 'Abonnement selecteren',
			tryFree: 'Probeer {period} gratis',
			payment: 'Betaling',
			subscribe: 'Abonneren',
			startFreeTrial: 'Gratis proefperiode starten',
		},
		messages: {
			paymentInitiated: 'Het lijkt erop dat je een betaling bent gestart die je nog niet volledig hebt bevestigd.',
			confirmPayment: 'Bevestig de betaling bij je bank en ',
			thisPage: ' deze pagina.',
			paymentIssues: 'Bij problemen met betalingen kun je gerust contact opnemen met ',
			subscriptionInactive: 'Je abonnement is inactief. Als je je abonnement wilt verlengen, werk dan je betaalgegevens bij.',
			coachLapsedTitle: 'Je Premium-toegang is gepauzeerd',
			coachLapsed: '{coachName} verzorgde je Premium-toegang en die toegang is nu gepauzeerd.',
			coachLapsedNoName: 'Je coach verzorgde je Premium-toegang en die toegang is nu gepauzeerd.',
			coachLapsedStillConnected: 'Je bent nog steeds verbonden met je coach. Er is niets aan je coaching veranderd en je toegang komt automatisch terug zodra de dekking van je coach weer actief is.',
			coachLapsedSubscribe: 'Je kunt hieronder ook je eigen abonnement starten.',
			noExpiration: 'Je abonnement heeft geen vervaldatum, dus je hoeft het niet te verlengen.',
			ifPersists: 'Als dit blijft gebeuren, neem contact op met ',
			alreadyHaveAccountPrefix: 'Heb je al een account?',
			signIn: 'Inloggen',
			crossPlatform: 'Je abonnement is actief. Gebruik het apparaat waarop je je hebt geabonneerd om het te beheren.',
			membershipPaused: 'Je lidmaatschap is gepauzeerd, dus het is momenteel niet actief. Hervat het vanuit je profiel in plaats van een nieuw abonnement te kopen.',
			crossPlatformWeb: 'Je abonnement is actief. Log in op onze website om het te beheren.',
			signedInAsPrefix: 'Je bent ingelogd als',
			signedInAsSuffix: '.',
			alreadyHaveSubscriptionPrefix: 'Betaald met een ander e-mailadres?',
			alreadyHaveSubscriptionLink: 'Vraag een inloglink aan',
			alreadyHaveSubscriptionSuffix: 'voor dat account.',
			installAppPromptTitle: 'Je abonnement is actief',
			installAppPromptBody: 'Wil je MH Physique ook op je telefoon gebruiken?',
			continueAfterPurchase: 'Doorgaan',
			noStoreProductsTitle: 'Abonnementsopties konden niet worden geladen',
			noStoreProductsBody: 'We konden de abonnementsopties op dit apparaat nu niet laden. Ons team is op de hoogte gebracht. Probeer het later opnieuw, of neem contact met ons op voor hulp bij het afsluiten van een abonnement.',
		},
		links: {
			reload: 'opnieuw laden',
		},
		labels: {
			savePrefix: 'Bespaar',
			trialDisclosure: '{period} gratis proefperiode, daarna {price}/{recurrence}',
		},
		recurrence: {
			month: 'maand',
			year: 'jaar',
		},
		trialPeriod: {
			days: '{count} {{dag|dagen}}',
			weeks: '{count} {{week|weken}}',
			months: '{count} {{maand|maanden}}',
			years: '{count} {{jaar|jaar}}',
		},
		code: {
			hint: 'Code van een vriend, toegangscode of actiecode',
			hintApp: 'Een toegangscode',
			friendApplied: 'Code van je vriend toegepast: je eerste maand is gratis.',
			removeCode: 'Code verwijderen',
			notRecognised: 'We herkennen deze code niet. Controleer hem en probeer het opnieuw.',
			newAccountsOnly: 'Deze aanbieding geldt alleen voor nieuwe accounts.',
			ownCode: 'Je kunt je eigen code niet gebruiken.',
			alreadyReferred: 'Je hebt al een uitnodiging van een vriend gebruikt.',
			alreadyUsed: 'Deze code is al gebruikt.',
			addsNothing: 'Deze code voegt niets toe aan je toegang.',
			notValidYet: 'Deze code kan nog niet worden gebruikt. Probeer het over {days} {{dag|dagen}} opnieuw.',
			tryAgain: 'Er is iets misgegaan. Probeer het opnieuw.',
			mistyped: 'Deze code lijkt niet te kloppen. Controleer hem op typefouten.',
			incomplete: 'Deze code lijkt onvolledig. Controleer hem op typefouten.',
			signedOutFriend: 'Dit lijkt een uitnodigingscode van een vriend. Maak een account aan of log in om hem te gebruiken.',
			signedOutAccess: 'Dit lijkt een toegangscode. Maak een account aan of log in om hem in te wisselen.',
			appOnly: 'De regels van Google Play staan geen actiecodes toe bij aankopen in de app.',
			confirmTitle: 'Deze code inwisselen?',
			confirmMessage: 'Deze toegangscode wordt toegevoegd aan {email}. Hij geeft toegang zonder betaling en kan één keer worden gebruikt.',
		},
		promo: {
			haveCode: 'Heb je een code?',
			codePlaceholder: 'Code',
			applyButton: 'Toepassen',
			appliedOneNamed: '{name}-code {code} toegepast: {percent}% korting op {period} van {plan}',
			appliedOne: 'Code {code} toegepast: {percent}% korting op {period} van {plan}',
			appliedSeveralNamed: '{name}-code {code} toegepast: bekijk de actieprijzen hieronder',
			appliedSeveral: 'Code {code} toegepast: bekijk de actieprijzen hieronder',
			periodYear: 'het eerste jaar',
			periodMonth: 'de eerste maand',
			planYearly: 'Jaarlijks',
			planMonthly: 'Maandelijks',
			percentOff: '{percent}% korting',
			perMonth: '{price} per maand',
			thenYear: 'eerste jaar, daarna de normale prijs van {plan}',
			thenMonth: 'eerste maand, daarna de normale prijs van {plan}',
			planTrial: 'Begint met {period} gratis',
			moneyBack: 'Geen proefperiode bij de actieprijs: je betaalt vandaag en krijgt binnen 30 dagen je geld terug, zonder vragen. De actie eindigt op {date}.',
			expired: 'Deze code is verlopen',
			ended: 'De actie is afgelopen',
			checkFailed: 'De code kon niet worden gecontroleerd. Probeer het opnieuw.',
		},
		notes: {
			billingInfo: 'In rekening gebracht aan het begin van elke cyclus. Abonnementen worden automatisch verlengd. Wijzig van abonnement of zeg op elk moment op.',
			billingInfoTrial: '{period} gratis, daarna in rekening gebracht aan het begin van elke cyclus. Abonnementen worden automatisch verlengd. Wijzig van abonnement of zeg op elk moment op.',
		},
		alerts: {
			emailMismatch: {
				title: 'E-mailadres komt niet overeen',
				message: 'Je kunt niet betalen met een ander e-mailadres dan het e-mailadres van je account. Gebruik het e-mailadres van je account of log eerst uit.',
			},
			accountExists: {
				title: 'Account bestaat al',
				message: 'Dit e-mailadres is al gekoppeld aan een account. We moeten je eerst inloggen...',
			},
			cantVerifyEmail: {
				title: 'Kan e-mailadres niet verifiëren',
				message: 'Kan onze registratieserver niet bereiken. Probeer het later opnieuw of neem contact op met [support@mh-physique.app](mailto:support@mh-physique.app).',
			},
			checkEmail: {
				sendLinkTitle: 'Vraag een inloglink aan',
				message: 'Vul het e-mailadres in waarmee je hebt betaald, dan sturen we er een inloglink naartoe.',
				sendLink: 'Link versturen',
				resendFailedTitle: 'E-mail versturen mislukt',
				resendFailedMessage: 'We konden de inlogmail niet versturen. Controleer je verbinding en probeer het opnieuw.',
			},
			pricingFailed: {
				title: 'Prijzen laden mislukt',
				message: 'Kan de abonnementsprijzen niet laden. Controleer je verbinding en probeer het opnieuw.',
			},
			pricingOffline: {
				title: 'Je bent offline',
				message: 'Abonnementen kunnen niet worden geladen zonder internetverbinding. Maak verbinding met internet en probeer het opnieuw.',
				tryAgain: 'Opnieuw proberen',
			},
			pricingUnavailable: {
				title: 'Kon abonnementen niet laden',
				message: 'De abonnementen konden niet worden geladen. Een adblocker of netwerkbeperking blokkeert ze mogelijk. Probeer het opnieuw, of schakel eventuele adblockers voor deze site uit.',
			},
			checkoutUnavailable: {
				title: 'Kon afrekenen niet openen',
				message: 'Het betaalformulier kon niet worden geopend. Er is niets afgeschreven. Probeer het opnieuw. Blijft dit gebeuren, neem dan contact op met support@mh-physique.app.',
			},
			purchaseFailed: {
				title: 'Aankoop van abonnement mislukt',
				message: 'Kan de aankoop van het abonnement niet voltooien. Probeer het opnieuw.',
			},
			purchaseNotYetConfirmed: {
				title: 'Aankoop voltooid — activeren',
				message: 'Je aankoop is gelukt. We konden hem zojuist niet helemaal bevestigen, maar hij zou binnen een paar minuten vanzelf actief moeten worden. Je hoeft niet opnieuw te kopen. Is hij nog niet actief? Open de app dan opnieuw of tik op Aankopen herstellen.',
			},
			restoreFailed: {
				title: 'Herstellen mislukt',
				message: 'Geen bestaande aankopen gevonden. Als je denkt dat dit een fout is, neem dan contact op met de klantenservice.',
			},
			restoreNotYetConfirmed: {
				title: 'Herstellen bezig',
				message: 'De winkel heeft je aankoop gevonden, maar we konden hem zojuist niet helemaal bevestigen. Hij zou binnen een paar minuten vanzelf actief moeten worden. Je hoeft niet opnieuw te kopen.',
			},
			alreadyLinked: {
				title: 'Abonnement gekoppeld aan een ander account',
				message: 'Dit winkelabonnement is al gekoppeld aan {email}. Om het te gebruiken, log je uit en log je in met dat account.',
				signOut: 'Uitloggen',
				unknownAccount: 'een ander account',
			},
			otherAccount: {
				title: 'Aankoop gedaan met een ander account',
				message: 'Deze aankoop is gedaan terwijl je was ingelogd met een ander MH Physique-account. Log in met dat account om het te gebruiken. Bestaat dat account niet meer? Neem dan contact op met de klantenservice, dan helpen we je aan toegang op dit account.',
			},
			storeRefused: {
				title: 'Aankoop kon niet worden bevestigd',
				message: 'De store heeft ons verzoek om deze aankoop te bevestigen niet geaccepteerd, dus de aankoop is niet aan je account toegevoegd. Koop niet opnieuw. Is er bij jou iets afgeschreven? Neem dan contact op met support@mh-physique.app, dan lossen we het op.',
			},
			registrationSlow: {
				title: 'Registratie van betaling vertraagd',
				message: 'Je betaling lijkt te zijn verwerkt, maar de registratie duurt langer dan verwacht. Tik op Opnieuw proberen om te herladen. Als het probleem aanhoudt, neem dan contact op met support@mh-physique.app.',
			},
			paymentBeingConfirmed: {
				title: 'Betaling wordt bevestigd',
				message: 'Je betaling wordt nog bevestigd. Je ontvangt een e-mail zodra deze is verwerkt.',
			},
		},
		temporaryInfoCard: {
			message: 'Betaling wordt bevestigd — je betaling staat in de handmatige controlewachtrij van PayPro. Je hebt volledige toegang terwijl we wachten. De meeste controles zijn binnen enkele minuten klaar.',
		},
		errors: {
			unexpectedCheckout: 'Onverwachte gebeurtenis tijdens het afrekenen.',
			checkoutAwaitingProcessing: 'Je betaling wordt nog verwerkt. Heb je de betaling bij je bank bevestigd?',
			checkoutDeclined: 'De betaling is geweigerd door je bank of betaalprovider.',
		},
	},
	unsubscribe: {
		title: 'Waarom vertrek je?',
		reasons: {
			highPrice: 'De prijs is te hoog.',
			noLongerNeed: 'Ik heb dit product niet meer nodig',
			notSatisfied: 'Ik ben niet tevreden met het product.',
			switchedProduct: 'Ik ben overgestapt naar een ander product',
			notPriority: 'Het heeft nu geen prioriteit.',
			mistake: 'Ik heb me per ongeluk geabonneerd.',
			anotherPlan: 'Ik stap over naar een ander abonnement.',
			other: 'Andere redenen.',
		},
		placeholders: {
			customReason: 'Ik wou dat je... (Leg hier je reden uit.)',
		},
		buttons: {
			unsubscribe: 'Opzeggen',
		},
		alerts: {
			success: 'Je hebt je abonnement succesvol opgezegd. Je abonnement stopt op {date}.',
			alreadyCanceled: 'Je abonnement is al opgezegd. Er is geen verdere actie nodig.',
			unsubscribeFailed: {
				title: 'We konden nu niet opzeggen',
				message: 'Je abonnement is nog steeds actief. Probeer het over een moment opnieuw, of neem contact op met de klantenservice als dit blijft gebeuren.',
				retry: 'Opnieuw proberen',
				contactSupport: 'Contact opnemen met klantenservice',
			},
		},
	},
	redeemCode: {
		title: 'Code inwisselen',
		labels: {
			enterCode: 'Voer code in:',
		},
		placeholders: {
			codeFormat: 'ABCD-EFGH-1234-56789',
		},
		notes: {
			codeWillBeRedeemed: 'De code die je invoert wordt toegepast op je account: \'\'{email}\'\'.',
		},
		buttons: {
			redeem: 'Inwisselen',
		},
		loading: {
			redeemingCode: 'Code inwisselen...',
		},
		alerts: {
			successfullyRedeemed: 'Succesvol ingewisseld!',
		},
		errors: {
			loginFailed: 'De sleutel lijkt geldig, maar het opnieuw inloggen is om een onbekende reden mislukt. Herstart de app en probeer het opnieuw of neem contact op met de klantenservice.',
			activationFailed: 'De sleutel lijkt geldig, maar de activering is om een onbekende reden mislukt. Herstart de app en probeer het opnieuw of neem contact op met de klantenservice.',
		},
	},
	referral: {
		settings: {
			inviteRow: 'Vriend uitnodigen',
		},
		disclosure: 'De vriend die jou heeft uitgenodigd ziet wanneer je je aanmeldt, wanneer je begint met trainen en of je een abonnement neemt.',
		invite: {
			headerTitle: 'Je bent uitgenodigd',
			checking: 'Je uitnodiging controleren...',
			title: '{name} geeft je een gratis maand',
			subtitle: 'Een gratis maand op de app van Menno Henselmans. Begin wanneer je er klaar voor bent.',
			startButton: 'Start mijn gratis maand',
			continueButton: 'Doorgaan',
			invalidTitle: 'Deze uitnodigingslink is niet meer geldig.',
			invalidSubtitle: 'Vraag je vriend om een nieuwe link, of maak een account aan zonder link.',
			invalidButton: 'Account aanmaken',
		},
		hub: {
			title: 'Geef een vriend een gratis maand',
			subtitle: 'Stuur iemand een gratis maand op de app. Als diegene het volhoudt, weet je dat jij ervoor hebt gezorgd dat hij of zij goed traint.',
			messageLabel: 'Jouw bericht',
			linkLabel: 'Jouw uitnodigingslink',
			codeLabel: 'Of geef ze deze code',
			defaultMessage: 'Ik gebruik de trainingsapp van Menno Henselmans. Hier is een gratis maand als je hem wilt proberen:',
			shareButton: 'Deel je uitnodiging',
			copiedToClipboard: 'Uitnodiging gekopieerd naar je klembord.',
			copyFailed: 'We konden je uitnodiging niet kopiëren. Je kunt de link hierboven selecteren en handmatig kopiëren.',
			loadFailed: 'We konden je uitnodigingslink niet ophalen. Controleer je verbinding en probeer het opnieuw.',
			retryButton: 'Opnieuw proberen',
			wereYouInvited: {
				title: 'Ben jij uitgenodigd?',
				subtitle: 'Voer de code van je vriend in, dan leggen we vast wie jou heeft uitgenodigd.',
				placeholder: 'Voer code in',
				submitButton: 'Code toepassen',
				accepted: 'Bedankt. We hebben vastgelegd wie jou heeft uitgenodigd.',
				refusals: {
					unknownInvite: 'We herkennen die code niet. Vraag het na bij de vriend die hem naar je heeft gestuurd.',
					selfReferral: 'Dat is je eigen code. Stuur hem naar een vriend.',
					alreadyReferredByAnother: 'Er staat al iemand anders geregistreerd als de vriend die jou heeft uitgenodigd.',
					hasSubscription: 'Deze aanbieding geldt alleen voor gloednieuwe accounts.',
					accountTooOld: 'Deze aanbieding geldt alleen voor gloednieuwe accounts.',
					inviterGone: 'Die code is van niemand meer.',
					unexpectedError: 'Er is iets misgegaan. Probeer het opnieuw.',
				},
			},
			friends: {
				title: 'Vrienden die jij hebt binnengehaald',
				count: '{count} {{vriend|vrienden}} tot nu toe',
				empty: 'Nog niemand. Deel je uitnodiging en ze verschijnen hier.',
				loadFailed: 'We konden je vrienden niet laden. Controleer je verbinding en probeer het opnieuw.',
				noName: 'Een vriend',
				statusJoined: 'Aangemeld',
				statusTraining: 'Traint',
				statusMember: 'Lid',
			},
		},
		subscribe: {
			freeMonthApplied: 'Je gratis maand van je vriend is toegepast.',
		},
	},
	bodyfatInput: {
		errors: {
			missingSkinfold: 'Voer minstens één waarde in voor de huidplooi \'{skinfold}\'.',
			genderRequired: 'Geef je geslacht op om het lichaamsvet te kunnen berekenen.',
			tapeAllValues: 'Voer alle waarden voor de meetlintmeting in.',
			tapeInvalid: 'Ongeldige gegevens voor de meetlintmeting.',
			noMethod: 'Geen methode gekozen om het lichaamsvet% te berekenen.',
			valuesOutOfRange: 'Controleer deze waarden nog even. Als ze kloppen, zoek dan hulp bij een medisch professional.',
		},
		methods: {
			visual: 'Visueel',
			caliper: 'Huidplooitang',
			tape: 'Meetlint',
		},
		descriptions: {
			visual: 'Gebruik de onderstaande afbeeldingen om je percentage te schatten.',
		},
		labels: {
			bodyFatPercentage: 'Lichaamsvetpercentage',
			take5Measurements: 'Meet elke huidplooi 5 keer.',
			neckCircumference: 'Nekomtrek',
			abdomenCircumference: 'Buikomtrek',
			waistCircumference: 'Tailleomtrek',
			hipsCircumference: 'Heupomtrek',
		},
		helpText: {
			neckCircumference: 'Meet onder de adamsappel op het smalste punt.',
			abdomenCircumference: 'Meet rond de navel op het breedste punt.',
			waistCircumference: 'Meet rond of boven de navel op het smalste punt.',
			hipsCircumference: 'Meet rond het breedste punt van de heupen/bilspieren.',
		},
		links: {
			howToMeasure: 'Hoe meet ik huidplooien?',
		},
		warnings: {
			roughEstimate: 'Een meetlint is verrassend nuttig om je lichaamsvetniveau bij te houden, maar als je een huidplooitang kunt bemachtigen, is die nog nuttiger.',
		},
	},
	sendCoachMessage: {
		title: 'Bericht aan coach',
		placeholder: 'Schrijf een bericht aan je coach...',
		addScreenshot: 'Screenshot toevoegen',
		send: 'Verzenden',
		sentDescription: 'Je coach ontvangt je bericht per e-mail.',
	},
	sendFeedback: {
		title: 'Feedback verzenden',
		headers: {
			howCanWeHelp: 'Hoe kunnen we je vandaag helpen?',
		},
		messages: {
			thankYouForFeedback: 'Bedankt voor je feedback! We hebben je een e-mailbevestiging gestuurd.',
			couldNotSend: 'We konden je feedback niet versturen. Je bericht staat er nog: controleer je verbinding en probeer het opnieuw.',
			noTitle: 'Geen titel',
		},
		buttons: {
			submit: 'Feedback verzenden',
			addScreenshot: 'Screenshot toevoegen',
		},
		writeFeedback: {
			title: 'Schrijf je feedback',
			subtitle: 'We nemen indien nodig contact met je op via {email}.',
		},
		types: {
			question: {
				title: 'Stel een vraag',
				description: 'We helpen je graag met al je vragen.',
				placeholder: 'Vraag ons alles over je programma of over de app in het algemeen, dan reageren we zo snel mogelijk.',
			},
			like: {
				title: 'Ik vind iets leuk',
				description: 'We horen graag dat je iets in onze app leuk vindt.',
				placeholder: 'Laat ons weten wat je leuk vindt aan de app of aan je programma.',
			},
			dislike: {
				title: 'Ik vind iets niet leuk',
				description: 'Als je iets niet leuk vindt, laat ons dan weten hoe we het kunnen verbeteren.',
				placeholder: 'Laat ons weten wat je niet leuk vindt aan de app of aan je programma.',
			},
			issue: {
				title: 'Meld een probleem',
				description: 'Een bug gevonden? Laat het ons weten en we lossen het zo snel mogelijk op.',
				placeholder: 'Beschrijf hoe het probleem eruitziet en hoe je het kunt reproduceren (indien mogelijk).',
			},
			suggestion: {
				title: 'Doe een suggestie',
				description: 'We zoeken altijd naar manieren om onze app te verbeteren. Laat ons weten hoe we het beter kunnen doen.',
				placeholder: 'Laat ons weten wat je graag in de app zou willen zien, of hoe we het kunnen verbeteren.',
			},
		},
	},
	flagContent: {
		title: 'Inhoud melden',
		reasons: {
			offensive: 'Aanstootgevend of ongepast',
			offensiveDesc: 'Bevat scheldwoorden, haatzaaiende taal of expliciet materiaal',
			spam: 'Spam',
			spamDesc: 'Reclame, onzinnige of dubbele inhoud',
			incorrect: 'Onjuiste informatie',
			incorrectDesc: 'Voedingsgegevens zijn duidelijk verkeerd of misleidend',
			other: 'Anders',
			otherDesc: 'Iets anders dat hierboven niet vermeld staat',
		},
		submit: 'Melding verzenden',
		otherTitle: 'Beschrijf het probleem',
		otherPlaceholder: 'Beschrijf het probleem...',
		success: 'Melding verzonden. Bedankt!',
		error: 'Kon melding niet verzenden. Probeer het opnieuw.',
		menuButton: 'Melden',
	},
	helpPage: {
		title: 'Help',
		placeholders: {
			searchKnowledgeBase: 'Waar heb je hulp bij nodig?',
		},
		messages: {
			noMatchesTitle: 'Geen zoekresultaten gevonden',
			noMatchesSubtext: 'Kun je niet vinden wat je zoekt? Pas je zoekopdracht aan, of neem contact op door <a href="mailto:support@mh-physique.app">de klantenservice te e-mailen</a> of <a href="https://community.mh-physique.app/" target="_blank">lid te worden van de community</a> om hulp te krijgen van ons team en andere gebruikers.',
		},
		faq: {
			title: 'Veelgestelde vragen',
		},
	},
	labelScanner: {
		title: 'Etiket scannen',
		noNutrientsTitle: 'Geen voedingsinformatie gevonden',
		noNutrients: 'Geen voedingsinformatie gedetecteerd. Kijk onder flapjes, aan de onderkant of op de buitenverpakking — en maak dan een nieuwe foto.',
		noNutrientsBlurry: 'De foto is te wazig of te donker om te lezen. Probeer een nieuwe foto met beter licht en houd stevig vast.',
		noNutrientsPartial: 'Slechts een deel van de voedingsinformatie gevonden. Het volledige etiket zit mogelijk onder een flapje, aan de onderkant of op de buitenverpakking.',
		retakeButton: 'Opnieuw maken',
		cameraErrorTitle: 'Camera niet beschikbaar',
		error: 'Kon etiket niet analyseren. Probeer het opnieuw.',
		quotaTitle: 'Scanlimiet bereikt',
		cameraPermissionDenied: 'Cameratoegang is vereist om etiketten te scannen.',
		modelsAgree: '{count} model(len) komen overeen',
		acceptResult: 'Dit resultaat accepteren',
		labelType: 'Etikettype',
		confidence: 'Betrouwbaarheid',
		jsonRepaired: 'Reactie was afgekapt en automatisch hersteld — controleer de voedingsstoffen',
		doneButton: 'Klaar',
		photoHintExtract: 'Hoe meer je vastlegt, hoe beter — voedingswaarde, voorkant van de verpakking, ingrediënten.',
		photoHintImage: 'De beste foto wordt de afbeelding van het voedingsmiddel.',
		providerErrorTitle: 'Service tijdelijk niet beschikbaar',
		providerErrorMessage: 'De scanservice is tijdelijk niet beschikbaar. Probeer het over een moment opnieuw, of neem contact op met de klantenservice als dit blijft gebeuren.',
		incompleteTitle: 'Scan niet voltooid',
		incompleteMessage: 'De scan is niet voltooid. Probeer het opnieuw — je foto\'s staan er nog.',
		quotaAccountLocked: 'Etiketten scannen is tijdelijk uitgeschakeld voor je account.',
		quotaRateLimited: 'Te veel scans in korte tijd. Wacht even.',
		quotaDailyCooldown: 'Te veel mislukte scans vandaag. Probeer het morgen opnieuw.',
		quotaQualityWarning: 'De meeste van je scans mislukken — controleer de beeldkwaliteit en inhoud.',
		retryingDifferentServer: 'Problemen — een andere server proberen...',
		offlineTitle: 'Je bent offline',
		offlineMessage: 'Maak verbinding met internet en probeer het opnieuw.',
		statusReadingPackaging: 'Verpakking lezen...',
		statusExtractingProductInfo: 'Productinformatie ophalen...',
		statusAnalyzingNutrients: 'Voedingsstoffen analyseren...',
		statusCheckingIngredients: 'Ingrediënten controleren...',
		statusDetectingServingSizes: 'Portiegroottes detecteren...',
		statusAlmostThere: 'Bijna klaar...',
	},
	mealPhotoScanner: {
		title: 'Maaltijd scannen',
		analyzeButton: 'Maaltijd analyseren',
		analyzing: 'Voedingsmiddelen identificeren...',
		retryingDifferentServer: 'Opnieuw proberen met een ander model...',
		addToMeal: '{count} voedingsmiddel(en) aan maaltijd toevoegen',
		replaceInMeal: 'Vervangen door {count} voedingsmiddel(en)',
		noFoodsDetected: 'Geen voedingsmiddel gedetecteerd op deze foto. Probeer een duidelijkere foto van je maaltijd te maken.',
		noFoodsBlurry: 'De foto is te wazig of te donker. Probeer een nieuwe foto met beter licht.',
		barcodeDetectedTitle: 'Barcode gedetecteerd',
		barcodeDetectedMessage: 'Dit lijkt op een productbarcode, niet op een bord met eten. Scan de barcode om dit verpakte product te loggen.',
		nutritionLabelDetectedTitle: 'Voedingsetiket gedetecteerd',
		nutritionLabelDetectedMessage: 'Dit lijkt op het voedingsetiket van een product, niet op een bord met eten. Scan het etiket om dit verpakte product te loggen.',
		scanBarcodeButton: 'Barcode scannen',
		scanLabelButton: 'Etiket scannen',
		retakeButton: 'Opnieuw maken',
		changeButton: 'Wijzigen',
		searchButton: 'Zoeken',
		addFoodButton: 'Voedingsmiddel toevoegen',
		errorTitle: 'Analyse mislukt',
		error: 'Kon de maaltijdfoto niet analyseren. Probeer het opnieuw.',
		estimatedGrams: '{grams} g geschat',
		estimatedToMeasured: '{estimated} g geschat → {measured} g gemeten',
		addedGrams: '{grams} g door jou toegevoegd',
		quotaTitle: 'Scanlimiet bereikt',
		quotaAccountLocked: 'Maaltijden scannen is tijdelijk uitgeschakeld voor je account.',
		quotaRateLimited: 'Te veel scans in korte tijd. Wacht even.',
		quotaDailyCooldown: 'Te veel mislukte scans vandaag. Probeer het morgen opnieuw.',
		cameraPermissionDenied: 'Cameratoegang is nodig om maaltijden te scannen.',
	},
	equipmentScanner: {
		title: 'Materiaal scannen',
		analyzeButton: 'Analyseren',
		retakeButton: 'Opnieuw',
		photoHintCapture: 'Maak foto\'s vanuit meerdere hoeken voor het beste resultaat.',
		photoHintLabel: 'Zorg dat de gedrukte gewichten leesbaar zijn.',
		analyzingReadingPlates: 'Gewichten lezen...',
		analyzingMatchingType: 'Materiaaltype matchen...',
		analyzingFinalising: 'Afronden...',
		retryingDifferentServer: 'Opnieuw proberen met een ander model...',
		cameraPermissionDenied: 'Cameratoegang is nodig om materiaal te scannen.',
		errorTitle: 'Scan mislukt',
		errorCamera: 'De camera kon niet starten. Probeer het opnieuw.',
		errorNetwork: 'Kon de scanner niet bereiken. Controleer je verbinding en probeer het opnieuw.',
		errorGeneric: 'Kon het materiaal niet analyseren. Probeer het opnieuw.',
		errorIncomplete: 'De scan is niet afgerond. Probeer het opnieuw — je foto\'s staan er nog.',
		errorBadImage: 'De afbeelding is geweigerd. Zorg dat de foto\'s scherp en niet te groot zijn.',
		errorUnsupportedType: 'Dit materiaaltype kan niet worden gescand.',
		noEquipmentDetected: 'Geen materiaal herkend op de foto\'s. Probeer duidelijkere hoeken of beter licht.',
		noEquipmentBlurry: 'De foto\'s zijn te wazig of donker. Maak ze opnieuw met beter licht.',
		noEquipmentMixed: 'De foto\'s lijken verschillend materiaal te tonen. Maak de foto\'s opnieuw van HETZELFDE materiaal vanuit verschillende hoeken.',
		lowConfidenceTooltip: 'De AI was niet zeker van deze waarde — hij is mogelijk geschat of moeilijk af te lezen. Controleer voordat je toepast.',
		confidenceTooltip: 'Hoe zeker de AI is van deze aflezing. Waarden onder 70% krijgen een waarschuwing.',
		types: {
			barbell: 'Halterstang',
			dumbbells: 'Dumbbells',
			plates: 'Losse schijven',
			kettlebells: 'Kettlebells',
			cableMachine: 'Kabelmachine',
			unknown: 'Onbekend',
		},
		detectedHeader: 'Herkend ({count} items)',
		applyModeHeader: 'Hoe toepassen',
		applyMode: {
			replace: 'Vervangen',
			replaceHelp: 'Overschrijf alle bestaande waarden met de aangevinkte herkende waarden.',
			merge: 'Samenvoegen',
			mergeHelp: 'Voeg herkende waarden toe die er nog niet zijn (binnen 0,05 kg).',
			append: 'Toevoegen',
			appendHelp: 'Voeg alle aangevinkte herkende waarden toe aan de bestaande lijst (duplicaten toegestaan).',
		},
		barGroup: 'Stang',
		collarGroup: 'Sluiting',
		platesGroup: 'Schijven',
		microPlatesGroup: 'Microschijven',
		currentValues: {
			showStack: 'Resulterende stack tonen ({count} stappen)',
			headerStack: 'Resulterende stack ({count} stappen)',
			showPlates: 'Resulterende schijven tonen ({count} schijven)',
			headerPlates: 'Resulterende schijven ({count} schijven)',
			showBar: 'Resulterende stangopstelling tonen ({count} schijven)',
			headerBar: 'Resulterende stangopstelling ({count} schijven)',
			showFixed: 'Resulterende gewichten tonen ({count})',
			headerFixed: 'Resulterende gewichten ({count})',
		},
		afterApply: 'Na toepassen: {count} item(s)',
		usingChecked: '{checked} van {total} herkend in gebruik',
		typeMismatchBanner: '{detected} herkend, maar dit materiaal is een {current}.',
		unknownTypeBanner: 'We konden het materiaaltype op de foto\'s niet met zekerheid bepalen.',
		quotaTitle: 'Scanlimiet bereikt',
		quotaAccountLocked: 'Materiaal scannen is tijdelijk uitgeschakeld voor je account.',
		quotaRateLimited: 'Te veel scans in korte tijd. Wacht even.',
		quotaDailyCooldown: 'Te veel mislukte scans vandaag. Probeer het morgen opnieuw.',
	},
	workoutPlanScanner: {
		title: 'Training scannen',
		analyzeButton: 'Analyseren',
		retakeButton: 'Opnieuw',
		photoHintCapture: 'Fotografeer of maak een screenshot van je training. Eén trainingsdag per afbeelding werkt het best.',
		photoHintBatch: 'Maximaal 5 afbeeldingen per scan. Scan langere schema\'s in delen en voeg ze toe.',
		analyzingReadingWorkout: 'De training lezen...',
		analyzingMatchingExercises: 'Oefeningen matchen...',
		analyzingFinalising: 'Afronden...',
		retryingDifferentServer: 'Opnieuw proberen met een ander model...',
		cameraPermissionDenied: 'Cameratoegang is nodig om een training te scannen. Je kunt ook screenshots uploaden met de +-knop.',
		errorTitle: 'Scan mislukt',
		errorCamera: 'De camera kon niet starten. Probeer het opnieuw.',
		errorNetwork: 'Kon de scanner niet bereiken. Controleer je verbinding en probeer het opnieuw.',
		errorGeneric: 'Kon de training niet analyseren. Probeer het opnieuw.',
		errorIncomplete: 'De scan is niet afgerond. Probeer het opnieuw — je foto\'s staan er nog.',
		errorApply: 'Er ging iets mis bij het toevoegen van de gescande training. Een deel is mogelijk toch toegevoegd — controleer je trainingen hieronder, of annuleer Trainingen bewerken om de wijzigingen te verwijderen.',
		errorBadImage: 'De afbeelding is geweigerd. Zorg dat de foto\'s scherp en niet te groot zijn.',
		noWorkoutDetected: 'Geen training gevonden op de afbeeldingen. Probeer duidelijkere foto\'s of screenshots.',
		noWorkoutBlurry: 'De afbeeldingen zijn te wazig of donker om te lezen. Maak ze opnieuw met beter licht.',
		quotaTitle: 'Scanlimiet bereikt',
		quotaAccountLocked: 'Trainingen scannen is tijdelijk uitgeschakeld voor je account.',
		quotaRateLimited: 'Te veel scans in korte tijd. Wacht even.',
		quotaDailyCooldown: 'Te veel mislukte scans vandaag. Probeer het morgen opnieuw.',
		detectedSummary: '{days} dag(en) met {exercises} oefening(en) herkend.',
		willCreateCustomSummary: '{count} oefening(en) worden als nieuwe eigen oefeningen aangemaakt wanneer je toepast.',
		willCreateCustom: 'Deze oefening staat niet in de oefeningendatabase van de app. Ze wordt als nieuwe eigen oefening aangemaakt met de gescande naam.',
		willCreateCustomSimilar: 'Deze oefening staat niet in de oefeningendatabase van de app. Ze wordt als nieuwe eigen oefening aangemaakt met de gescande naam, ingesteld als vergelijkbaar met {name}.',
		useScannedButton: 'Gescande naam behouden',
		useSuggestionButton: 'Suggestie gebruiken',
		changeButton: 'Wijzigen',
		resolveButton: 'Oplossen',
		scannedAs: 'Gescand als "{name}"',
		suggestedAs: 'Voorgesteld "{name}"',
		customBadge: 'Eigen',
		matchedBadge: 'Gematcht',
		matchedBadgeTooltip: 'Dit is dezelfde oefening als de gescande, mogelijk alleen onder een andere naam in de oefeningendatabase van de app.',
		suggestedMatchBadge: 'Voorgesteld',
		suggestedMatchTooltip: 'Dit is niet de gescande oefening, maar een vergelijkbare uit de oefeningendatabase van de app, voorgesteld als vervanging.',
		alreadyInPlan: 'Zit al in je schema — bij toepassen worden de sets en herhalingen overal bijgewerkt waar de oefening wordt gebruikt.',
		setsLabel: 'Sets',
		targetRepsLabel: 'Doelherhalingen',
		applyModeHeader: 'Hoe toepassen',
		applyModeMessage: 'Toevoegen zet de gescande dag(en) bij je huidige trainingen. Vervangen verwijdert eerst je huidige trainingen. Er wordt niets opgeslagen totdat je de pagina Trainingen bewerken opslaat.',
		applyingLoading: 'Toevoegen aan je schema…',
		applyMode: {
			append: 'Toevoegen',
			replace: 'Vervangen',
		},
	},
	recipeScanner: {
		title: 'Recept scannen',
		emptyRecipeHint: 'Heb je een recept bij de hand? Scan een foto en we vullen de ingrediënten voor je in.',
		analyzeButton: 'Analyseren',
		retakeButton: 'Opnieuw',
		analyzing: 'Recept lezen...',
		retryingDifferentServer: 'Opnieuw proberen met een ander model...',
		photoHintCapture: 'Maak een foto van een receptkaart, kookboekpagina, scherm of notitie.',
		photoHintBatch: 'Maximaal 4 foto\'s — één per pagina.',
		photoHintImage: 'Een foto van het afgewerkte gerecht wordt de receptafbeelding.',
		cameraPermissionDenied: 'Cameratoegang is nodig om een recept te scannen. Je kunt ook foto\'s uploaden met de +-knop.',
		nameLabel: 'Receptnaam',
		namePlaceholder: 'Receptnaam',
		imageLabel: 'Receptafbeelding',
		servingsLabel: 'Levert {count} portie(s)',
		instructionsLabel: 'Bereidingswijze',
		useRecipeButton: '{count} ingrediënt(en) gebruiken',
		changeButton: 'Wijzigen',
		searchButton: 'Zoeken',
		estimatedGrams: '{grams} g geschat',
		estimatedToMeasured: '{estimated} g geschat → {measured} g gemeten',
		errorTitle: 'Scan mislukt',
		error: 'Kon het recept niet lezen. Probeer het opnieuw.',
		noRecipeDetected: 'Geen recept gevonden op deze foto\'s. Probeer duidelijkere foto\'s van het volledige recept.',
		noRecipeBlurry: 'De foto\'s zijn te wazig of donker om te lezen. Maak ze opnieuw met beter licht.',
		quotaTitle: 'Scanlimiet bereikt',
		quotaAccountLocked: 'Recepten scannen is tijdelijk uitgeschakeld voor je account.',
		quotaRateLimited: 'Te veel scans in korte tijd. Wacht even.',
		quotaDailyCooldown: 'Te veel mislukte scans vandaag. Probeer het morgen opnieuw.',
	},
	cameraPermission: {
		title: 'Camera inschakelen',
		nativeAndroidStep1: 'Open de app Instellingen op je telefoon',
		nativeAndroidStep2: 'Tik op Apps en daarna op MH Physique',
		nativeAndroidStep3: 'Tik op Machtigingen en daarna op Camera',
		nativeAndroidStep4: 'Kies "Alleen toestaan tijdens gebruik van de app"',
		nativeAndroidStep5: 'Kom hier terug en open de scanner opnieuw',
		nativeIosStep1: 'Open de app Instellingen op je apparaat',
		nativeIosStep2: 'Scrol omlaag en tik op MH Physique',
		nativeIosStep3: 'Zet Camera aan',
		nativeIosStep4: 'Kom hier terug en open de scanner opnieuw',
		webStep1: 'Klik op het slotpictogram naast de adresbalk',
		webStep2: 'Zoek "Camera"',
		webStep3: 'Zet de toestemming op "Toestaan"',
		webStep4: 'Sluit dit scherm en open het opnieuw',
		webIosStep1: 'Open de app Instellingen op je apparaat',
		webIosStep2: 'Scroll omlaag en tik op Safari',
		webIosStep3: 'Tik op Camera (onder "Instellingen voor websites")',
		webIosStep4: 'Kies de optie Vragen of Toestaan',
		webIosStep5: 'Kom hier terug en laad de pagina opnieuw',
		webIosOtherBrowserStep1: 'Open de app Instellingen op je apparaat',
		webIosOtherBrowserStep2: 'Scroll omlaag en tik op de browser die je gebruikt, zoals Chrome of Firefox',
		webIosOtherBrowserStep3: 'Zet Camera aan',
		webIosOtherBrowserStep4: 'Kom hier terug en laad de pagina opnieuw',
		macSafariStep1: 'Kies "Instellingen voor deze website" in het Safari-menu',
		macSafariStep2: 'Zet Camera op "Toestaan"',
		macSafariStep3: 'Laad deze pagina opnieuw',
		macSafariStep4: 'Nog steeds geblokkeerd? Open Systeeminstellingen, dan Privacy en beveiliging, dan Camera, en zet Safari aan',
	},
	barcodeScanner: {
		title: 'Barcode scannen',
		tabs: {
			scan: 'Scannen',
			enterManually: 'Handmatig invoeren',
		},
		manualEntry: {
			title: 'Barcode invoeren',
			findFood: 'Voedingsmiddel zoeken',
		},
		messages: {
			cameraPermissionDenied: 'Je moet de app toegang tot je camera geven om deze functie goed te laten werken.',
			initializingCamera: 'Camera starten',
			cannotInitializeCamera: 'Kan de camera niet starten.',
			noBarcodeFound: 'Geen barcode gevonden? Probeer {remedies}.',
		},
		remedies: {
			betterLighting: 'beter licht',
			differentDistance: 'een andere afstand',
			enablingFlash: 'de flitser inschakelen',
			zoomingInOut: 'in-/uitzoomen',
			switchingCameras: 'van camera wisselen',
		},
	},
	helpCard: {
		title: 'Informatie over...',
	},
	changelog: {
		title: 'Wijzigingslogboek',
		comingSoon: 'Binnenkort',
	},
	sso: {
		loggingIntoCommunity: 'Aanmelden bij community...',
		communityForSubscribersOnly: 'De Community is alleen voor abonnees. Neem een abonnement om mee te praten.',
	},
	nutrients: {
		names: {
			energy: 'Energie',
			protein: 'Eiwit',
			fat: 'Vet',
			carbohydrates: 'Koolhydraten',
			fiber: 'Vezels',
			cholesterol: 'Cholesterol',
			fatSaturated: 'Vet, verzadigd',
			fatMonounsaturated: 'Vet, enkelvoudig onverzadigd',
			fatPolyunsaturated: 'Vet, meervoudig onverzadigd',
			omega3: 'Omega-3',
			omega6: 'Omega-6',
			omega9: 'Omega-9',
			transsaturatedFat: 'Transvet',
			carbohydratesTotal: 'Koolhydraten, totaal',
			sugarsTotal: 'Suikers, totaal',
			sugarAdded: 'Suiker, toegevoegd',
			starch: 'Zetmeel',
			saltNacl: 'Zout (NaCl)',
			alcohol: 'Alcohol',
			water: 'Water',
			caffeine: 'Cafeïne',
			theobromine: 'Theobromine',
			calciumCa: 'Calcium (Ca)',
			ironFe: 'IJzer (Fe)',
			magnesiumMg: 'Magnesium (Mg)',
			phosphorusP: 'Fosfor (P)',
			potassiumK: 'Kalium (K)',
			sodiumNa: 'Natrium (Na)',
			zincZn: 'Zink (Zn)',
			copperCu: 'Koper (Cu)',
			fluorideF: 'Fluoride (F)',
			manganeseMn: 'Mangaan (Mn)',
			seleniumSe: 'Seleen (Se)',
			iodineI: 'Jodium (I)',
			vitaminAIu: 'Vitamine A (IE)',
			retinol: 'Retinol',
			vitaminARae: 'Vitamine A RAE',
			caroteneBeta: 'Caroteen, bèta',
			caroteneAlpha: 'Caroteen, alfa',
			vitaminEAlphaTocopherol: 'Vitamine E (alfa-tocoferol)',
			vitaminD: 'Vitamine D',
			vitaminD2Ergocalciferol: 'Vitamine D2 (ergocalciferol)',
			vitaminD3Cholecalciferol: 'Vitamine D3 (cholecalciferol)',
			vitaminCTotalAscorbicAcid: 'Vitamine C, totaal ascorbinezuur',
			thiaminVitaminB1: 'Thiamine (vitamine B-1)',
			riboflavinVitaminB2: 'Riboflavine (vitamine B-2)',
			niacinVitaminB3: 'Niacine (vitamine B-3)',
			pantothenicAcid: 'Pantotheenzuur',
			vitaminB6: 'Vitamine B-6',
			folateTotal: 'Folaat, totaal',
			vitaminB12: 'Vitamine B-12',
			cholineTotal: 'Choline, totaal',
			vitaminKPhylloquinone: 'Vitamine K (fyllochinon)',
			folicAcid: 'Foliumzuur',
			ash: 'As',
			biotinVitaminH: 'Biotine (vitamine H)',
			chromiumCr: 'Chroom (Cr)',
			molybdenumMo: 'Molybdeen (Mo)',
			fattyAcidsLinoleic: 'Vetzuren, linolzuur',
			fattyAcidsAlphaLinolenic: 'Vetzuren, alfa-linoleenzuur',
			epa: 'EPA',
			dha: 'DHA',
			fattyAcidsArachidonic: 'Vetzuren, arachidonzuur',
			sorbitol: 'Sorbitol',
			maltitol: 'Maltitol',
			mannitol: 'Mannitol',
			isomalt: 'Isomalt',
			lactitol: 'Lactitol',
			xylitol: 'Xylitol',
			erythritol: 'Erythritol',
			polyolsSugarAlcoholsTotal: 'Polyolen (suikeralcoholen), totaal',
		},
		short: {
			energy: 'Cal',
			protein: 'Eiw',
			fat: 'Vet',
			carbohydrates: 'Kool',
			fiber: 'Vez',
			cholesterol: 'Chol',
		},
		threeLetter: {
			energy: 'Cal',
			protein: 'Eiw',
			fat: 'Vet',
			carbohydrates: 'Koo',
			fiber: 'Vez',
		},
	},
	authRoles: {
		unknown: {
			name: 'Gratis',
			userExplanation: 'Je abonnement is momenteel niet actief. Voor alle functies voor training en maaltijdplanning heb je een Premium-abonnement nodig.',
		},
		paid: {
			name: 'Premium',
			userExplanation: 'Als Premium-gebruiker heb je toegang tot alle functies, inclusief het automatische trainingsschema en de maaltijdplanning.',
		},
		vip: {
			name: 'VIP',
			userExplanation: 'Als VIP-gebruiker heb je toegang tot alle Premium-functies, inclusief het automatische trainingsschema en de maaltijdplanning. Dit is een gratis doorlopend abonnement dat handmatig wordt beheerd door het team van MH Physique.',
		},
		mod: {
			name: 'Moderator',
			userExplanation: 'Als Moderator heb je toegang tot alle Premium-functies en kun je ook bijdragen van de community modereren. Dit is een gratis doorlopend abonnement dat handmatig wordt beheerd door het team van MH Physique.',
		},
		dev: {
			name: 'Ontwikkelaar',
			userExplanation: 'Dit is een basislicentie voor ontwikkelaars. Neem contact op met je productiemanager voor details over wat dit inhoudt.',
		},
		officer: {
			name: 'Officer',
			userExplanation: 'Als Officer kun je de werkingsparameters van het systeem aanpassen (de trainings- en maaltijdsolvers, officiële oefeningen, enzovoort), bijdragen van de community modereren en ook gebruikers bewerken en verwijderen.',
		},
		serverdev: {
			name: 'Server Dev',
			userExplanation: 'Als Serverontwikkelaar heb je geen uitleg nodig over wat dit betekent.',
		},
	},
	exerciseStates: {
		active: {
			title: 'Actief',
			description: 'Deze oefening maakt op dit moment deel uit van je programma.',
		},
		plateaued: {
			title: 'Plateau',
			description: 'Je hebt bij deze oefening een plateau bereikt (een tijdelijke piek in je prestaties). Hij wordt later weer ingezet, wanneer je progressie daarom vraagt.',
		},
		unsuitable: {
			title: 'Ongeschikt',
			description: 'We hebben gemerkt dat deze oefening niet optimaal voor je was. Hij wordt later weer ingezet, wanneer je progressie daarom vraagt.',
		},
		avoided: {
			title: 'Vermeden',
			description: 'Je hebt gevraagd om deze oefening te vervangen door een alternatief, vanwege een blessure of ontbrekende apparatuur. We raden hem binnenkort weer aan om te zien of de situatie is veranderd.',
		},
		ready: {
			title: 'Klaar',
			description: 'Je hebt deze oefening eerder gebruikt of geprobeerd. Hij is nu weer beschikbaar en wacht tot hij nodig is.',
		},
		unused: {
			title: 'Ongebruikt',
			description: 'We hebben deze oefening nog niet voorgesteld. Dat doen we wanneer je progressie erom vraagt.',
		},
	},
	exerciseStats: {
		setNumber: '{number}',
		importantNotice: 'Belangrijke melding',
		exerciseProgress: 'Oefeningsprogressie',
		log: 'Logboek',
		exportAsCsv: 'Exporteren als CSV',
		buttons: {
			allow: 'Toestaan',
			shareLink: 'Link delen',
			stopSharing: 'Stoppen met delen',
		},
		toasts: {
			linkCopied: 'Link gekopieerd naar klembord',
		},
		tabs: {
			log: 'Geschiedenis',
			instructions: 'Instructies',
			settings: 'Instellingen',
		},
		settings: {
			equipment: 'Materiaal',
			notSelectedYet: 'Nog niet geselecteerd',
			myoReps: 'Myo-reps',
			myoRepsTooltip: 'Myo-reps gebruiken één hoofdset gevolgd door minisets met korte rust voor snellere, effectieve spiergroei.',
			myoRepsLearnMore: 'Meer info',
			useMyoReps: 'Gebruiken',
			useMyoRepsNote: 'Gebruik Myo-reps waar mogelijk om trainingen sneller te maken en toch effectief te houden. Past een oefening niet goed, dan valt de app terug op gewone sets.',
			dontUseMyoReps: 'Niet gebruiken',
			dontUseMyoRepsNote: 'Gebruik nooit Myo-reps voor deze oefening. De training vertrouwt op traditionele gewone sets.',
			autoMyoReps: 'Automatisch',
			autoMyoRepsNote: 'Bepaal automatisch of Myo-reps voor deze oefening worden gebruikt, op basis van de algemene doelvoorkeuren en de huidige progressie.',
			rmTesting: 'Rep max (RM) testen',
			rmTestingTooltip: 'RM-testen gebruikt een zware set van 2–5 herhalingen met goede techniek om je kracht te bepalen. De app schat dan je 1RM en kiest je startgewicht.',
			rmTestingLearnMore: 'Meer info',
			useRMTesting: 'Gebruiken',
			useRMTestingNote: 'Gebruik altijd RM-testen voor deze oefening. Je test je 2–5 rep max, zodat de app je kracht kan inschatten en de juiste gewichten kan instellen.',
			dontUseRMTesting: 'Niet gebruiken',
			dontUseRMTestingNote: 'Gebruik nooit RM-testen voor deze oefening. De app baseert zich dan op je geregistreerde prestaties.',
			autoRMTesting: 'Automatisch',
			autoRMTestingNote: 'Bepaal automatisch of RM-testen wordt gebruikt op basis van je algemene instelling.',
		},
		options: {
			exerciseStatus: 'Oefeningstatus',
		},
		alerts: {
			stopAvoidingTitle: 'Niet meer vermijden',
			stopAvoidingMessage: 'Ben je van gedachten veranderd? Dit gebruikt deze oefening niet meteen in je schema, maar maakt hem wel beschikbaar voor verdere planning of wisselen.',
		},
		filters: {
			weight: 'Gewicht',
			oneRM: '1 RM',
			tonnage: 'Tonnage',
			includeRMTests: 'RM-testen meenemen',
		},
		emptyState: {
			noProgressData: 'Geen voortgangsgegevens',
			noProgressDataSubtext: 'Je oefeningsgegevens verschijnen hier zodra je de beweging hebt uitgevoerd.',
			noLogHistory: 'Geen loggeschiedenis',
			noLogHistorySubtext: 'Je geregistreerde oefeningen en notities verschijnen hier zodra je de beweging hebt uitgevoerd.',
			noDataInRange: 'Geen gegevens in bereik',
			noDataInRangeSubtext: 'Geen oefeningsgegevens gevonden voor het gekozen datumbereik. Probeer een andere periode te kiezen.',
			loadFailed: 'Kan oefeningsgegevens niet laden',
			loadFailedSubtext: 'Er ging iets mis tijdens het laden. Probeer het opnieuw.',
		},
		logTable: {
			date: 'DATUM',
			loggedSets: 'GELOGDE SETS',
			notes: 'NOTITIES',
		},
		logDetail: {
			sets: 'Sets',
			notes: 'Notities',
		},
		chart: {
			weight: 'Gewicht',
			oneRMEstimate: '1RM-schatting',
			tonnage: 'Tonnage',
			weightAxis: 'Gewicht ({unit})',
			oneRMAxis: '1RM ({unit})',
			tonnageAxis: 'Tonnage ({unit})',
		},
	},
	trendChart: {
		last7Days: 'Laatste 7 dagen',
		seeAll: 'Alles bekijken',
		noData: 'Geen gegevens',
	},
	markdownEditor: {
		buttons: {
			unlink: 'Koppeling verwijderen',
		},
		placeholders: {
			url: 'URL',
		},
	},
	planHandler: {
		macrosOnTarget: 'Macro\'s op doel',
	},
	programSettings: {
		title: 'Programma-instellingen',
		tabs: {
			training: 'Training',
			nutrition: 'Voeding',
		},
		settings: {
			title: 'Instellingen',
		},
		advancedTraining: {
			title: 'Geavanceerde trainingsmethoden',
			edit: 'Bewerken',
		},
		moreSettings: {
			toggle: 'Meer instellingen',
			info: 'Wijzigingen hier kunnen programma-optimalisaties voorstellen. Je kunt altijd je huidige trainingen houden.',
		},
		schedule: {
			title: 'Schema',
			frequency: 'Trainingsfrequentie',
			days: 'Trainingsdagen',
			daysPerWeek: 'dagen per week',
			hoursPerNight: 'uur per nacht',
			sleep: 'Slaap',
		},
		lifestyle: {
			title: 'Levensstijl',
			activityLevel: 'Activiteitsniveau',
			stressLevel: 'Stressniveau',
		},
		volume: {
			title: 'Trainingsvolume',
			priority: 'Fysieke prioriteit',
			setsPerWeek: 'Sets per week per spiergroep',
			setsPerWeekCurrentPlanTooltip: 'Je trainingen zijn nog gebouwd voor {volume} sets per week. Gebruik Bekijken en optimaliseren onder Spiervolume om ze dichter bij je doel te brengen.',
		},
		nutrition: {
			goal: 'Doel',
			primaryGoal: 'Primair doel',
			schedule: 'Schema',
			mealFrequency: 'Maaltijdfrequentie',
			mealsPerDay: '{count} maaltijden per dag',
			mealTimes: 'Maaltijdtijden',
			energyBalance: 'Energiebalans',
			calorieSurplus: 'Caloriesurplus',
			calorieDeficit: 'Calorietekort',
			energyBalanceCustomText: '{sign}{percent}% ({sign}{adjustment} kcal)',
		},
		buttons: {
			update: 'Bijwerken',
			updateProgram: 'Programma bijwerken',
			volumeDetails: 'Bekijken en optimaliseren',
		},
	},
	system: {
		messages: {
			recompiling: 'Angular: Opnieuw compileren...',
		},
	},
	workoutDetail: {
		volumeAutoregulation: {
			title: 'Volume-autoregulatie',
			message: 'Op basis van je gegevens, met name je vermoeidheidsindex{intensityInfo}, raden we aan je setvolume voor {exerciseName} met 1 set te {direction}.',
			intensityHighRep: ' in de sessie met veel herhalingen',
			intensityMediumRep: ' in de sessie met een gemiddeld aantal herhalingen',
			intensityLowRep: ' in de sessie met weinig herhalingen',
			directionIncreasing: 'verhogen',
			directionDecreasing: 'verlagen',
			buttons: {
				accept: 'Accepteren',
				decline: 'Weigeren',
				decideLater: 'Ik beslis later',
			},
		},
	},
	cliAuth: {
		allowAccess: 'Toegang toestaan?',
		description: 'MH Physique CLI (GitHub) vraagt toestemming om:',
		permissions: {
			downloadData: 'Snapshots van gebruikersdatabases downloaden',
			actOnBehalf: 'Namens jou acties uitvoeren',
		},
		confirmAccess: 'Toegang toestaan voor {email}?',
		authorizing: 'Autoriseren...',
		approved: 'Toegang verleend',
		approvedDetail: 'Je kunt deze pagina sluiten en terugkeren naar de terminal.',
		denied: 'Toegang geweigerd',
		deniedDetail: 'Het verzoek is geweigerd. Je kunt deze pagina sluiten.',
		buttons: {
			deny: 'Weigeren',
			allow: 'Toestaan',
		},
		errors: {
			noSession: 'Geen autorisatiesessie gevonden. Start de CLI-tool opnieuw.',
			notSignedIn: 'Log eerst in op de app en probeer het dan opnieuw.',
		},
	},
	muscles: {
		bodyParts: {
			glutes: 'Grote bilspier',
			glutemed: 'Middelste bilspier',
			quads: 'Quadriceps',
			hams: 'Hamstrings',
			calves: 'Kuiten (gastrocnemius en soleus)',
			shoulders: 'Schouders (alle koppen)',
			chest: 'Borst',
			lats: 'Latissimus',
			traps: 'Trapezius',
			triceps: 'Triceps',
			biceps: 'Biceps',
			abs: 'Buikspieren',
		},
		volumeTable: {
			chest: 'Borst',
			ldelt: 'Zijdelingse deltoideus',
			rdelt: 'Achterste deltoideus',
			utraps: 'Bovenste trapezius',
			lats: 'Latissimus',
			biceps: 'Biceps',
			triceps: 'Triceps',
			erectors: 'Onderrug',
			quads: 'Quadriceps',
			hams: 'Hamstrings',
			glutes: 'Bilspieren',
			glutemed: 'Middelste bilspier',
			gastrocnemius: 'Kuiten (gastrocnemius)',
			soleus: 'Kuiten (soleus)',
			abs: 'Buikspieren',
		},
	},
	coach: {
		manageClientOffline: {
			title: 'Je bent offline',
			message: 'Voor het beheren van een cliënt is een internetverbinding nodig. Maak verbinding met internet en probeer het opnieuw.',
		},
		formerCoachBadge: {
			label: 'Voormalige coach',
			tooltip: 'Gemaakt door je voormalige coach {coachName}. Je kunt hem blijven gebruiken of een andere versie kiezen.',
			editPageBody: 'Gemaakt door je voormalige coach {coachName}.',
		},
		detachExerciseNotice: 'Je schema gebruikt nog steeds de oefeningen van je voormalige coach. Open de kiezer om terug te schakelen naar je eigen versie als je dat wilt.',
		title: 'Coaching',
		addClient: 'Cliënt toevoegen',
		unnamedClient: 'Naamloze cliënt',
		clientGoneMessage: 'Deze cliënt staat niet meer in je lijst.',
		slotsRemaining: '{remaining} cliëntplekken over',
		perSeatSlots: 'Voeg altijd cliënten toe — per plek gefactureerd',
		checkout: {
			billingTitle: 'Hoe coachingfacturering werkt',
			billingInfo: 'Dit is een maandabonnement dat per cliëntplek wordt gefactureerd. Je begint met één plek — die van jou, waarin ook je Premium-lidmaatschap is inbegrepen. Elke cliënt die je coacht voegt één plek toe aan je maandelijkse rekening, en het verwijderen van een cliënt verwijdert hun plek. Wijzigingen in plekken worden naar rato verrekend op je volgende factuur.',
		},
		emptyState: {
			title: 'Nog geen cliënten',
		},
		editProgram: 'Programma bewerken',
		manageClient: 'Cliënt beheren',
		managingBannerLabel: 'Beheren',
		backToMyAccount: 'Terug naar mijn account',
		status: {
			pending: 'In afwachting',
			claimed: 'Actief',
		},
		nicknamePrompt: {
			createTitle: 'Nieuwe cliënt',
			renameTitle: 'Cliënt hernoemen',
			message: 'Kies een bijnaam voor je eigen referentie. Je cliënt ziet deze naam niet.',
			placeholder: 'Cliëntbijnaam',
			create: 'Aanmaken',
			rename: 'Hernoemen',
			cancel: 'Annuleren',
		},
		rename: 'Cliënt hernoemen',
		removeClient: {
			button: 'Cliënt verwijderen',
			confirmTitle: 'Cliënt verwijderen',
			confirmMessage: 'Hiermee wordt deze cliëntplek permanent verwijderd.',
			confirmMessageClaimed: 'Hiermee wordt de cliënt losgekoppeld van je coaching. Ze behouden hun huidige programma.',
			confirm: 'Verwijderen',
			cancel: 'Annuleren',
			removing: 'Cliënt verwijderen…',
		},
		intakeChoice: {
			title: 'Hoe wil je beginnen?',
			subtext: 'Je kunt de intake zelf invullen, of een lege intake naar de cliënt sturen en die zelf laten beantwoorden.',
			fillMyself: 'Ik vul de intake in',
			fillMyselfSubtext: 'Je beantwoordt elke stap en bereidt het programma voor. De cliënt krijgt een link om het voltooide programma te claimen.',
			sendBlank: 'Lege intake naar cliënt sturen',
			sendBlankSubtext: 'De cliënt claimt de link, beantwoordt de intake zelf, en jij beoordeelt en finaliseert het programma binnen hun account.',
		},
		clientFills: {
			invitedTitle: 'Wachten op cliënt',
			invitedSubtext: 'De uitnodiging is verstuurd. De cliënt vult de intake in op zijn eigen account. Je krijgt een melding wanneer die klaar is.',
			fillMyself: 'Intake zelf invullen',
			submittedTitle: 'Intake klaar voor beoordeling',
			submittedSubtext: 'Je cliënt heeft de intake voltooid. Bekijk hun antwoorden, stel het trainingsvolume en de energiebalans in, en genereer het programma.',
			reviewIntake: 'Intake beoordelen',
		},
		awaiting: {
			headerTitle: 'Je programma',
			title: 'Je coach maakt je programma af',
			subtext: 'We laten het je weten zodra je programma klaar is. Je kunt de app sluiten en later terugkomen.',
			subtextWithCoach: '{coachName} beoordeelt je intake en stelt je trainings- en voedingsplan samen. We laten het je weten zodra het klaar is. Je kunt de app sluiten en later terugkomen.',
		},
		invite: {
			title: 'Cliënt uitnodigen',
			share: 'Delen',
			linkCopied: 'Link gekopieerd',
			linkCopiedMessage: 'De uitnodigingslink is naar je klembord gekopieerd. Deel hem met je cliënt om ze op weg te helpen.',
			ok: 'OK',
			description: 'Deel deze link met je cliënt. Ze kunnen zich aanmelden en het programma ontvangen dat je hebt voorbereid.',
			creatingLink: 'De uitnodigingslink wordt gemaakt. Dit kan een paar seconden duren.',
			linkFailed: 'We konden de uitnodigingslink niet aanmaken.',
		},
		claim: {
			title: 'Coachuitnodiging',
			description: '{coachName} heeft een trainings- en voedingsprogramma voor je voorbereid. Door te accepteren kan je coach je trainingsgegevens bekijken en je programma aanpassen.',
			descriptionBlankIntake: '{coachName} heeft je uitgenodigd om samen te trainen. Beantwoord een paar vragen, zodat je coach je trainings- en voedingsprogramma kan opstellen. Door te accepteren kan je coach je trainingsgegevens bekijken en je programma aanpassen.',
			accept: 'Accepteren',
			overwriteWarning: 'Je hebt al een actief programma. Bij accepteren wordt je huidige programma vervangen. Je logs, voedingsmiddelen, oefeningen en apparatuur blijven behouden.',
			connected: 'Je bent nu verbonden met {coachName}.',
			invalidToken: 'Deze uitnodigingslink is ongeldig of is al gebruikt.',
			couldNotCheckToken: 'We konden je uitnodigingslink op dit moment niet controleren. Je link is nog steeds geldig, dus controleer je verbinding en probeer het opnieuw.',
			couldNotComplete: 'We konden het instellen van je programma niet voltooien. Je uitnodigingslink is nog steeds geldig, dus open hem opnieuw. Werkt het daarna nog steeds niet, neem dan contact op met je coach.',
			connectedSetupUnfinished: 'Je bent nu verbonden met je coach, maar we konden je programma niet volledig kopiëren. Open de app opnieuw en neem contact op met je coach als je programma nog steeds ontbreekt.',
			settingUp: 'Je programma instellen...',
			activationTimeout: 'Het activeren van je coachtoegang duurt langer dan verwacht. Probeer het zo meteen opnieuw, of neem contact op met support als het probleem aanhoudt.',
		},
		settingsSection: {
			title: 'Coaching',
			coachName: 'Je coach',
			leaveCoaching: 'Coaching verlaten',
		},
		selfDetach: {
			confirmTitle: 'Coaching verlaten',
			confirmMessage: 'Je wordt losgekoppeld van {coachName}. Je behoudt je trainingsgegevens, voedingslogs en oefeningen, maar je verliest je abonnementstoegang. Dit kan niet ongedaan worden gemaakt.',
			confirmButton: 'Verlaten',
			successToast: 'Je bent losgekoppeld van {coachName}.',
			deleteAccountButton: 'Verlaat eerst de coaching',
		},
		deleteBlocked: {
			message: 'Je wordt momenteel gecoacht door {coachName}. Vraag je coach om je te verwijderen, of neem contact op met support, voordat je je gegevens verwijdert.',
		},
		workoutViewOnly: 'Je bekijkt deze training als coach. Het uitvoeren van de training wordt door de cliënt beheerd.',
		weighInViewOnly: 'Je bekijkt deze weging als coach. Gewichtsgegevens worden door de cliënt beheerd.',
		offlineOverlay: {
			title: 'Verbinding verbroken',
			message: 'Wachten op herverbinding. Alle wijzigingen worden gesynchroniseerd zodra de verbinding is hersteld.',
		},
		presence: {
			online: 'Online',
			lastSeen: '{time} geleden voor het laatst gezien',
			coachViewing: 'Je coach bekijkt momenteel je programma',
		},
		checkup: {
			submitToCoach: 'Indienen bij coach',
			submittedToast: 'Je krijgt een melding wanneer je coach de beoordeling voltooit.',
			willBeSentForReview: 'Je checkup wordt naar je coach gestuurd voor beoordeling. Je ziet eventuele bijgewerkte doelen nadat je coach ze heeft beoordeeld.',
			awaitingReview: 'Wachten op beoordeling door coach',
			reviewTitle: 'Checkup beoordelen',
			currentTarget: 'Huidig doel',
			recommendedTarget: 'Aanbevolen doel',
			accept: 'Accepteren',
			modify: 'Aanpassen',
			decline: 'Afwijzen',
			customCalories: 'Eigen caloriedoel',
			reviewActionPrompt: 'Beoordeel de wekelijkse check-up van je cliënt en bepaal hoe je het caloriedoel aanpast.',
			kcalDelta: '{sign}{diff} kcal',
			tabDecision: 'Beslissing',
			tabBodyComposition: 'Lichaamssamenstelling',
			weightChange: 'Gewichtsverandering',
			kcalValue: '{value} kcal',
			bfPercent: '~{value}%',
			resolveError: 'Kan deze check-up niet afronden. Probeer het opnieuw.',
			decisionChoice: {
				accept: 'Doel van de app accepteren',
				acceptHelp: 'Het plan van je cliënt wordt de aanbeveling van de app.',
				modify: 'Ander doel instellen',
				modifyHelp: 'Kies zelf het getal, in kcal of als verandering in procent.',
				decline: 'Huidig doel houden',
				declineHelp: 'Het plan van je cliënt blijft deze week zoals het is.',
			},
		},
		dashboard: {
			refresh: 'Vernieuwen',
			statusOnTrack: 'Op koers',
			statusOffTrack: 'Uit koers',
			statusUndetermined: 'Onbepaald',
			statusUnknown: 'Onbekend',
			itemsNone: '—',
			pendingSectionTitle: 'Openstaande uitnodigingen',
			actionItemsSectionTitle: 'Openstaande actiepunten',
			actionItemCheckupTitle: 'Wekelijkse check-up',
			actionItemStrengthTestTitle: 'Krachttest',
			actionItemSubtext: 'Wacht op je beoordeling',
			actionItemTimeAgo: '{time} geleden',
			handoverIncompleteBadge: 'Installatie onvolledig',
			handoverIncompleteExplanation: 'Deze cliënt heeft je uitnodiging geaccepteerd, maar zijn account heeft het programma dat je hebt voorbereid nooit volledig ontvangen. Open Cliënt beheren om te zien wat hij echt heeft, of vraag hem om de uitnodigingslink opnieuw te openen.',
		},
		billing: {
			title: 'Facturering',
			headerAffordance: 'Facturatiedashboard openen',
			refresh: 'Vernieuwen',
			activeSlotsLine: '{count} actieve cliëntplekken',
			runoutLine: 'In je huidige tempo raken je tegoeden rond {date} op.',
			balance: {
				remaining: '{amount} cliëntmaanden resterend',
				dueWithBilling: '{amount} cliëntmaanden openstaand',
				locked: 'Account geblokkeerd',
			},
			history: {
				sectionTitle: 'Afschriften',
				consumed: '{amount} cliëntmaanden verbruikt',
				settled: 'Voldaan',
				unsettled: 'Niet voldaan — geen betaalmethode geregistreerd',
				empty: 'Nog geen afschriften. Je ziet hier op de 3e van elke maand een regel.',
			},
			loadError: {
				title: 'Kan facturering niet laden',
				subtext: 'We konden je facturatiedashboard niet laden. Controleer je verbinding en probeer het opnieuw.',
				retry: 'Opnieuw proberen',
			},
			unmigrated: {
				title: 'Facturering komt binnenkort',
				subtext: 'Je account gebruikt de vorige plek-gebaseerde toekenning. We laten het je weten wanneer het nieuwe factureringssysteem voor jou wordt geactiveerd.',
			},
			seat: {
				heading: '{count} {{cliënt|cliënten}} coachen',
				billedMonthly: 'Maandelijks gefactureerd, naar rato bij het toevoegen of verwijderen van cliënten.',
				nextPayment: 'Volgende betaling: {amount} op {date}',
				manageNote: 'Je coachingabonnement omvat je eigen plan plus één plek per cliënt. Zeg je coachingabonnement op om te stoppen met coachen.',
			},
			recordedHistory: {
				chartTitle: 'Cliënten door de tijd',
				range6: '6 maanden',
				range12: '12 maanden',
				rangeAria: 'Periode',
				active: 'Actief',
				asleep: 'Slapend',
				mostClientsNote: 'Het hoogste aantal cliënten dat je per maand had.',
				capNote: 'Stippellijn: de limiet van je abonnement per maand (nu {cap} {{cliënt|cliënten}}).',
				chartAria: 'Cliënten per maand, {from} tot {to}: {values}',
				chartAriaWithCap: 'Cliënten per maand, {from} tot {to}: {values}; abonnementslimiet {cap}',
				paymentsTitle: 'Eerdere betalingen',
				invoice: 'Factuur',
				testBadge: 'Test',
				paddleLine: '{amount} · {seats} {{cliëntplek|cliëntplekken}}',
				amountOnly: '{amount}',
				storeLine: '{amount} · abonnement voor {cap} cliënten · {store}',
				storeLineNoPlan: '{amount} · {store}',
				appStore: 'App Store',
				googlePlay: 'Google Play',
				receiptsApple: 'Bonnetjes vind je in je aankoopgeschiedenis in de App Store.',
				receiptsGoogle: 'Bonnetjes vind je in je aankoopgeschiedenis in Google Play.',
				emptyHistory: 'Nog geen geschiedenis. Wijzigingen in je cliënten worden vanaf nu bijgehouden.',
				emptyPayments: 'Nog geen betalingen.',
				loadError: 'Je cliëntgeschiedenis kon niet worden geladen.',
				retry: 'Opnieuw proberen',
				invoiceUnavailable: 'De factuur is nu niet beschikbaar. Probeer het over een minuut opnieuw.',
				invoiceBlocked: 'Je browser heeft het factuurtabblad geblokkeerd. Sta pop-ups voor deze site toe en tik opnieuw op Factuur.',
			},
		},
		tier: {
			becomeCoach: 'Coach worden',
			noTiersAvailable: 'Coachingplannen zijn momenteel niet beschikbaar. Probeer het later opnieuw.',
			tierOption: '{count} cliënten · {price}',
			purchaseFailed: 'We konden je aankoop niet voltooien. Probeer het opnieuw.',
			purchaseNotYetConfirmed: 'Je aankoop is gelukt, maar we konden hem zojuist niet helemaal bevestigen, dus je coachingplan is misschien nog niet actief. Koop niet opnieuw. Mogelijk wordt het vanzelf actief de volgende keer dat je de app opent. Is het na een paar dagen nog steeds niet actief, neem dan contact op met support.',
			crossProviderConflict: 'Je hebt al een actief lidmaatschap via een ander betaalkanaal. Zeg dat eerst op en stel coaching hier daarna in.',
			purchaseSuccess: 'Alles is geregeld — je coachingplan is nu actief.',
			alreadyOwned: 'Je zit al op dit plan. Gebruik Plan wijzigen om over te stappen naar een ander plan.',
			tierName: '{count} cliënten',
			usageLine: '{used} van {cap} cliëntplekken in gebruik',
			changePlan: 'Plan wijzigen',
			changePlanSubtext: 'Upgrade of downgrade hoeveel cliënten je kunt coachen.',
			changeFailed: 'We konden je plan niet wijzigen. Probeer het opnieuw.',
			changeNotYetConfirmed: 'Je planwijziging is doorgevoerd in de winkel, maar we konden hem zojuist niet helemaal bevestigen, dus je nieuwe plan is misschien nog niet zichtbaar. Probeer het niet opnieuw. Mogelijk wordt hij vanzelf toegepast de volgende keer dat je de app opent. Is je nieuwe plan na een paar dagen nog steeds niet zichtbaar, neem dan contact op met support.',
			changeScheduled: 'Je planwijziging is ingepland en gaat in aan het einde van je huidige factureringsperiode.',
			changeSuccess: 'Je plan is bijgewerkt.',
			pauseWarning: {
				title: 'Sommige cliënten worden gepauzeerd',
				message: 'Dit abonnement dekt {cap} {{cliënt|cliënten}}, en je hebt er op dit moment meer. Als je doorgaat, pauzeren we {count} {{cliënt|cliënten}}: {names}. Een gepauzeerde cliënt behoudt zijn account, trainingsschema en geschiedenis, maar krijgt niet langer de Premium-toegang die jij biedt, en je kunt hem niet openen. Je kunt ze later weer wakker maken, zolang je binnen je abonnement blijft.',
				confirm: 'Doorgaan',
			},
			pausedNowSuffix: '{count} {{cliënt is|cliënten zijn}} gepauzeerd: {names}. Je kunt ze weer wakker maken vanuit je cliëntenlijst zodra je abonnement ruimte heeft.',
			pauseScheduledNotice: {
				title: 'Cliënten worden gepauzeerd bij verlenging',
				body: 'Je abonnement wijzigt op {date} naar {cap} {{cliënt|cliënten}}. Op dat moment pauzeren we {count} {{cliënt|cliënten}}: {names}. Tot die tijd verandert er niets.',
				bodyNoDate: 'Je abonnement wijzigt bij je volgende verlenging naar {cap} {{cliënt|cliënten}}. Op dat moment pauzeren we {count} {{cliënt|cliënten}}: {names}. Tot die tijd verandert er niets.',
			},
			crossChannel: {
				appBlock: 'Je lidmaatschap wordt op het web beheerd. Je kunt coach worden via onze website.',
				webBlock: 'Je lidmaatschap loopt via de {store}. Om coach te worden kun je een coachingplan in de app kopen — of, voor een lagere prijs, je lidmaatschap in de store opzeggen en overstappen op facturering via het web.',
				webBlockPayPro: 'Je lidmaatschap loopt nog via onze vorige betaalprovider, dus coaching kan er nog niet mee worden ingesteld. Je lidmaatschap moet eerst naar onze huidige provider — neem contact met ons op, dan regelen wij het voor je, zonder onderbreking van je lidmaatschap.',
			},
		},
		branding: {
			title: 'Branding',
			headerAffordance: 'Je branding aanpassen',
			logoLabel: 'Logo',
			logoHelp: 'Upload je logo. Het verschijnt in de app van je cliënten.',
			brandNameLabel: 'Merknaam',
			brandNamePlaceholder: 'Je bedrijfsnaam',
			accentLabel: 'Accentkleur',
			accentHelp: 'Kies een voorinstelling of voer je eigen hexkleur in. We bouwen er automatisch een goed leesbare kleurfamilie van.',
			contrastWarning: 'Tekst kan lastig leesbaar zijn op deze kleur. We houden het automatisch leesbaar, maar een sterkere kleur leest prettiger.',
			previewLabel: 'Voorbeeld',
			previewButton: 'Voorbeeldknop',
			previewLink: 'Voorbeeldlink',
			save: 'Branding opslaan',
			saveConfirmTitle: 'Branding toepassen?',
			saveConfirmMessage: 'Deze branding wordt toegepast op al je cliënten de volgende keer dat ze de app openen.',
			saveSuccess: 'Branding opgeslagen.',
			savePartial: 'Branding opgeslagen, maar {count} cliënt(en) konden niet worden bijgewerkt. Sla opnieuw op om het bij hen nog eens te proberen.',
			saveError: 'Kan branding niet opslaan. Controleer je verbinding en probeer het opnieuw.',
			reset: 'Terugzetten naar standaard',
			resetConfirmTitle: 'Branding verwijderen?',
			resetConfirmMessage: 'Dit verwijdert je branding voor al je cliënten. Hun app krijgt de volgende keer dat ze deze openen weer de standaard MH Physique-uitstraling.',
			resetSuccess: 'Branding teruggezet naar standaard.',
			resetPartial: 'Branding teruggezet, maar {count} cliënt(en) konden niet worden bijgewerkt. Zet opnieuw terug om het bij hen nog eens te proberen.',
			resetError: 'Kan branding niet terugzetten. Controleer je verbinding en probeer het opnieuw.',
			poweredByMh: 'Mogelijk gemaakt door MH Physique',
		},
		sleepClient: {
			button: 'Cliënt pauzeren',
			confirmTitle: 'Deze cliënt pauzeren?',
			confirmMessage: 'Ze behouden hun account, schema en geschiedenis, en je kunt ze op elk moment weer hervatten. Zolang ze gepauzeerd zijn, gaan ze terug naar de gratis versie, kun je hun account niet openen en nemen ze geen plek meer in op je abonnement.',
			confirm: 'Pauzeren',
			cancel: 'Annuleren',
			working: 'Bezig met pauzeren…',
		},
		wakeClient: {
			button: 'Cliënt hervatten',
			confirmTitle: 'Deze cliënt hervatten?',
			confirmMessage: 'Ze krijgen meteen weer volledige toegang en je kunt hun account weer openen. Ze nemen dan ook weer een plek in op je abonnement.',
			confirm: 'Hervatten',
			cancel: 'Annuleren',
			working: 'Bezig met hervatten…',
		},
		clientAsleep: {
			badge: 'Gepauzeerd',
			badgeSince: '{days} {{dag|dagen}} gepauzeerd',
			badgeSinceToday: 'Sinds vandaag gepauzeerd',
			refusedTitle: 'Deze cliënt is gepauzeerd',
			refusedMessage: 'Je kunt het account van een gepauzeerde cliënt niet openen. Hervat deze cliënt om verder te gaan.',
			becausePlanFull: 'Gepauzeerd omdat je abonnement vol is',
			becausePlanFullSince: 'Al {days} {{dag|dagen}} gepauzeerd omdat je abonnement vol is',
			becausePlanFullToday: 'Vandaag gepauzeerd omdat je abonnement vol is',
		},
	},
	pageTitles: {
		login: 'Inloggen',
		fatalError: 'Fatale fout',
		subscribe: 'Abonneren',
		unsubscribe: 'Afmelden',
		changelog: 'Wat is nieuw',
		home: 'Start',
		editMeal: 'Maaltijd',
		workoutDetail: 'Training',
		equipmentEdit: 'Apparatuur bewerken',
		editWeighIn: 'Weging',
		training: 'Training',
		editWorkouts: 'Trainingen bewerken',
		nutrition: 'Voeding',
		programSettings: 'Programma-instellingen',
		advancedTrainingMethods: 'Geavanceerde trainingsmethoden',
		nutritionOptions: 'Voedingsopties',
		scheduleTips: 'Schematips',
		equipmentSearch: 'Apparatuur',
		foods: 'Voedingsmiddelen',
		barcodeScanner: 'Barcode scannen',
		labelScanner: 'Etiket scannen',
		mealPhotoScanner: 'Maaltijd scannen',
		equipmentScanner: 'Apparatuur scannen',
		workoutPlanScanner: 'Training scannen',
		recipeScanner: 'Recept scannen',
		mealPlan: 'Maaltijdplan',
		editFood: 'Voedingsmiddel',
		editNutritionPlan: 'Dagelijks voedingsdoel bewerken',
		editIngredient: 'Ingrediënt bewerken',
		exerciseSwitch: 'Oefening wisselen',
		editExercise: 'Oefening bewerken',
		viewExercise: 'Oefening',
		exerciseConfiguration: 'Oefeningsconfiguratie',
		exerciseDiff: 'Update beschikbaar',
		muscleVolume: 'Spiervolume',
		editTrainingGoal: 'Trainingsdoel bewerken',
		updatePlanOptions: 'Werk je programma bij',
		weeklyCheckup: 'Wekelijkse check-up',
		exerciseStats: 'Oefeningstatistieken',
		progress: 'Voortgang',
		userProfile: 'Gebruikersprofiel',
		settings: 'Instellingen',
		appSettings: 'App-instellingen',
		notificationSettings: 'Meldingsinstellingen',
		customizeHomepage: 'Startpagina aanpassen',
		redeemCode: 'Code inwisselen',
		referralInvite: 'Uitnodiging',
		promo: 'Actie',
		referralHub: 'Vriend uitnodigen',
		intakeForm: 'Intake',
		introCarousel: 'Introductiecarrousel',
		awaitingCoach: 'Wachten op coach',
		helpCard: 'Help',
		mealSuggestions: 'Maaltijdsuggesties',
		note: 'Notitie',
		purchaseSuccess: 'Abonnement actief',
		nutritionInfo: 'Voedingswaarden',
		taskCalendar: 'Takenkalender',
		inputCalendar: 'Kalender',
		changeWorkout: 'Training wijzigen',
		trainingOverview: 'Trainingsoverzicht',
		sendFeedback: 'Feedback sturen',
		sendCoachMessage: 'Bericht aan coach',
		help: 'Help & FAQ',
		cliAuth: 'CLI-autorisatie',
		coachSettings: 'Coaching',
		coachClientDetail: 'Cliëntdetails',
		coachBilling: 'Coachfacturering',
		coachCheckout: 'Coach worden',
		coachBranding: 'Branding',
		coachClaim: 'Coach claimen',
	},
	coachingTips: {
		scheduleItems: {
			training: 'Training',
			wakeUp: 'Opstaan',
			goToSleep: 'Gaan slapen',
			weeklyCheckup: 'Wekelijkse check-up',
		},
	},
} satisfies Translation;

export default nl;
